(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/config/adobe-launch/assets/javascripts/launch-script.js') >= 0) return;  svs.modules.push('/components/config/adobe-launch/assets/javascripts/launch-script.js'); (function() {
  window._satellite = window._satellite || {};
  window._satellite.container = {
    "buildInfo": {
      "buildDate": "2020-02-12T12:09:09Z",
      "environment": "production",
      "turbineBuildDate": "2020-02-05T18:11:16Z",
      "turbineVersion": "25.7.0"
    },
    "dataElements": {
      "session: user id": {
        "modulePath": "core/src/lib/dataElements/sessionStorage.js",
        "settings": {
          "name": "_uid"
        }
      },
      "domain": {
        "modulePath": "core/src/lib/dataElements/customCode.js",
        "settings": {
          "source": function(event) {
            return window.location.hostname;
          }
        }
      },
      "content: modified page name": {
        "modulePath": "core/src/lib/dataElements/customCode.js",
        "settings": {
          "source": function(event) {
            try{
              var pid = _satellite.getVar('site section: pageID');
              var arr = pid.split("/");
              if( arr.length == 2 && arr[1] ==  ""){
                return "home";
              }
              pageName = "";
              for(i=1;i<arr.length;i++){
                pageName += arr[i] + ":";
              }
              return pageName.substring(0,pageName.length-1);
            }catch(e){}


          }
        }
      },
      "content: system enviorment": {
        "modulePath": "core/src/lib/dataElements/sessionStorage.js",
        "settings": {
          "name": "systemEnv"
        }
      },
      "random id": {
        "modulePath": "core/src/lib/dataElements/randomNumber.js",
        "settings": {
          "max": 1000000000,
          "min": 0
        }
      },
      "Analytics Account": {
        "defaultValue": "sssac-svenskaspelsocdev-new",
        "modulePath": "lookup-table-utility/src/lib/dataElements/lookupTable.js",
        "settings": {
          "lookupArray": [
            {
              "input": "spela.test3.svenskaspel.se",
              "output": "sssac-svenskaspelsocstage-new"
            },
            {
              "input": "spela.test.svenskaspel.se",
              "output": "sssac-svenskaspelsocdev-new"
            },
            {
              "input": "spela.svenskaspel.se",
              "output": "sssac-svenskaspelsocprod-new"
            },
            {
              "input": "spela.test0.svenskaspel.se",
              "output": "sssac-svenskaspelsocstage-new"
            },
            {
              "input": "app.spela.svenskaspel.se",
              "output": "sssac-svenskaspelsocprod-new"
            }
          ],
          "inputVariable": {
            "value": "%domain%",
            "dataElement": true
          }
        }
      },
      "user: consent object": {
        "modulePath": "core/src/lib/dataElements/customCode.js",
        "settings": {
          "source": function(event) {
            try{
              var cok = _satellite.cookie.get("consent");
              _satellite.logger.log("The User Consent Checked: " + cok);
              if(typeof cok != 'undefined'){
                var arr = cok.split(",");
                if(arr.length > 2 && arr[1] == "t" ){
                  return {"aa":true,"aam":true,"ecid":true,"target":true };
                }
              }else{
                return {"aa":true,"aam":true,"ecid":true,"target":true };
              }
              return {"aa":false,"aam":false,"ecid":false,"target":false };
            }catch(e){}
            return {"aa":false,"aam":false,"ecid":false,"target":false }
          }
        }
      },
      "user: consent": {
        "defaultValue": "false",
        "modulePath": "core/src/lib/dataElements/customCode.js",
        "settings": {
          "source": function(event) {
            try{
              var cok = _satellite.cookie.get("consent");
              _satellite.logger.log("The User Consent Checked: " + cok);
              if(typeof cok != 'undefined'){
                var arr = cok.split(",");
                if(arr.length > 2 && arr[1] == "t" ){
                  return "true";
                }else{
                  return "false"
                }
              }else{
                return "true";
              }
              return "false";
            }catch(e){}
          }
        }
      },
      "content: site": {
        "modulePath": "core/src/lib/dataElements/customCode.js",
        "settings": {
          "source": function(event) {
            try{
              return digitalData[0].site;
            }catch(e){}
          }
        }
      },
      "ACC Broadlog Id": {
        "forceLowerCase": true,
        "cleanText": true,
        "storageDuration": "pageview",
        "modulePath": "core/src/lib/dataElements/queryStringParameter.js",
        "settings": {
          "name": "bid",
          "caseInsensitive": true
        }
      }
    },
    "extensions": {
      "core": {
        "displayName": "Core",
        "modules": {
          "core/src/lib/dataElements/sessionStorage.js": {
            "name": "session-storage",
            "displayName": "Session Storage",
            "script": function(module, exports, require, turbine) {

              'use strict';

              var window = require('@adobe/reactor-window');

              module.exports = function(settings) {
                try {
                  return window.sessionStorage.getItem(settings.name);
                } catch (e) {
                  return null;
                }
              };

            }

          },
          "core/src/lib/dataElements/customCode.js": {
            "name": "custom-code",
            "displayName": "Custom Code",
            "script": function(module, exports, require, turbine) {

              'use strict';

              module.exports = function(settings, event) {
                return settings.source(event);
              };

            }

          },
          "core/src/lib/dataElements/randomNumber.js": {
            "name": "random-number",
            "displayName": "Random Number",
            "script": function(module, exports, require, turbine) {

              'use strict';

              module.exports = function(settings) {
                var min = Math.ceil(settings.min);
                var max = Math.floor(settings.max);

                return min > max ? NaN : Math.floor(Math.random() * (max - min + 1)) + min;
              };

            }

          },
          "core/src/lib/dataElements/queryStringParameter.js": {
            "name": "query-string-parameter",
            "displayName": "Query String Parameter",
            "script": function(module, exports, require, turbine) {

              'use strict';

              var window = require('@adobe/reactor-window');
              var queryString = require('@adobe/reactor-query-string');

              module.exports = function(settings) {
                var queryParams = queryString.parse(window.location.search);

                if (settings.caseInsensitive) {
                  var lowerCaseName = settings.name.toLowerCase();
                  var keys = Object.keys(queryParams);
                  for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    if (key.toLowerCase() === lowerCaseName) {
                      return queryParams[key];
                    }
                  }
                } else {
                  return queryParams[settings.name];
                }
              };

            }

          },
          "core/src/lib/events/directCall.js": {
            "name": "direct-call",
            "displayName": "Direct Call",
            "script": function(module, exports, require, turbine) {

              'use strict';

              var triggersByIdentifier = {};

              window._satellite = window._satellite || {};

              window._satellite.track = function(identifier, detail) {
                identifier = identifier.trim();
                var triggers = triggersByIdentifier[identifier];
                if (triggers) {
                  var syntheticEvent = {
                    identifier: identifier,
                    detail: detail
                  };

                  triggers.forEach(function(trigger) {
                    trigger(syntheticEvent);
                  });

                  var logMessage = 'Rules using the direct call event type with identifier "' + identifier +
                    '" have been triggered' + (detail ? ' with additional detail:' : '.');
                  var logArgs = [logMessage];

                  if (detail) {
                    logArgs.push(detail);
                  }

                  turbine.logger.log.apply(turbine.logger, logArgs);
                } else {
                  turbine.logger.log('"' + identifier + '" does not match any direct call identifiers.');
                }
              };

              module.exports = function(settings, trigger) {
                var triggers = triggersByIdentifier[settings.identifier];

                if (!triggers) {
                  triggers = triggersByIdentifier[settings.identifier] = [];
                }

                triggers.push(trigger);
              };

            }

          },
          "core/src/lib/conditions/valueComparison.js": {
            "name": "value-comparison",
            "displayName": "Value Comparison",
            "script": function(module, exports, require, turbine) {

              'use strict';

              var isNumber = function(value) {
                return typeof value === 'number' && isFinite(value); 
              };

              var isString = function(value) {
                return typeof value === 'string' || value instanceof String;
              };

              var updateCase = function(operand, caseInsensitive) {
                return caseInsensitive && isString(operand) ? operand.toLowerCase() : operand;
              };

              var castToStringIfNumber = function(operand) {
                return isNumber(operand) ? String(operand) : operand;
              };

              var castToNumberIfString = function(operand) {
                return isString(operand) ? Number(operand) : operand;
              };

              var guardStringCompare = function(compare) {
                return function(leftOperand, rightOperand, caseInsensitive) {
                  leftOperand = castToStringIfNumber(leftOperand);
                  rightOperand = castToStringIfNumber(rightOperand);

                  return (
                    isString(leftOperand) &&
                    isString(rightOperand) &&
                    compare(leftOperand, rightOperand, caseInsensitive)
                  );
                };
              };

              var guardNumberCompare = function(compare) {
                return function(leftOperand, rightOperand) {
                  leftOperand = castToNumberIfString(leftOperand);
                  rightOperand = castToNumberIfString(rightOperand);

                  return (
                    isNumber(leftOperand) &&
                    isNumber(rightOperand) &&
                    compare(leftOperand, rightOperand)
                  );
                };
              };

              var guardCaseSensitivity = function(compare) {
                return function(leftOperand, rightOperand, caseInsensitive) {
                  return compare(
                    updateCase(leftOperand, caseInsensitive),
                    updateCase(rightOperand, caseInsensitive)
                  );
                };
              };

              var conditions = {
                equals: guardCaseSensitivity(function(leftOperand, rightOperand) {
                  return leftOperand == rightOperand;
                }),
                doesNotEqual: function() {
                  return !conditions.equals.apply(null, arguments);
                },
                contains: guardStringCompare(guardCaseSensitivity(function(leftOperand, rightOperand) {
                  return leftOperand.indexOf(rightOperand) !== -1;
                })),
                doesNotContain: function() {
                  return !conditions.contains.apply(null, arguments);
                },
                startsWith: guardStringCompare(guardCaseSensitivity(function(leftOperand, rightOperand) {
                  return leftOperand.indexOf(rightOperand) === 0;
                })),
                doesNotStartWith: function() {
                  return !conditions.startsWith.apply(null, arguments);
                },
                endsWith: guardStringCompare(guardCaseSensitivity(function(leftOperand, rightOperand) {
                  return leftOperand.substring(
                    leftOperand.length - rightOperand.length,
                    leftOperand.length
                  ) === rightOperand;
                })),
                doesNotEndWith: function() {
                  return !conditions.endsWith.apply(null, arguments);
                },
                matchesRegex: guardStringCompare(function(leftOperand, rightOperand, caseInsensitive) {
                  return new RegExp(rightOperand, caseInsensitive ? 'i' : '').test(leftOperand);
                }),
                doesNotMatchRegex: function() {
                  return !conditions.matchesRegex.apply(null, arguments);
                },
                lessThan: guardNumberCompare(function(leftOperand, rightOperand) {
                  return leftOperand < rightOperand;
                }),
                lessThanOrEqual: guardNumberCompare(function(leftOperand, rightOperand) {
                  return leftOperand <= rightOperand;
                }),
                greaterThan: guardNumberCompare(function(leftOperand, rightOperand) {
                  return leftOperand > rightOperand;
                }),
                greaterThanOrEqual: guardNumberCompare(function(leftOperand, rightOperand) {
                  return leftOperand >= rightOperand;
                }),
                isTrue: function(leftOperand) {
                  return leftOperand === true;
                },
                isTruthy: function(leftOperand) {
                  return Boolean(leftOperand);
                },
                isFalse: function(leftOperand) {
                  return leftOperand === false;
                },
                isFalsy: function(leftOperand) {
                  return !leftOperand;
                },
              };

              module.exports = function(settings) {
                return conditions[settings.comparison.operator](
                  settings.leftOperand,
                  settings.rightOperand,
                  Boolean(settings.comparison.caseInsensitive)
                );
              };

            }

          },
          "core/src/lib/actions/customCode.js": {
            "name": "custom-code",
            "displayName": "Custom Code",
            "script": function(module, exports, require, turbine) {

              'use strict';

              var document = require('@adobe/reactor-document');
              var decorateCode = require('./helpers/decorateCode');
              var loadCodeSequentially = require('./helpers/loadCodeSequentially');
              var postscribe = require('../../../node_modules/postscribe/dist/postscribe');
              var extensionSettings = turbine.getExtensionSettings();

              var postscribeWrite = (function() {
                var write = function(source) {
                  postscribe(document.body, source, {
                    beforeWriteToken: function(tag) {
                      if (extensionSettings.cspNonce && tag.tagName === 'script') {
                        tag.attrs.nonce = extensionSettings.cspNonce;
                      }
                      return tag;
                    },
                    error: function(error) {
                      turbine.logger.error(error.msg);
                    }
                  });
                };

                var queue = [];

                var flushQueue = function() {
                  if (document.body) {
                    while (queue.length) {
                      write(queue.shift());
                    }
                  } else {
                    setTimeout(flushQueue, 20);
                  }
                };

                return function(source) {
                  queue.push(source);
                  flushQueue();
                };
              })();

              var libraryWasLoadedAsynchronously = (function() {
                if (document.currentScript) {
                  return document.currentScript.async;
                } else {
                  var scripts = document.querySelectorAll('script');
                  for (var i = 0; i < scripts.length; i++) {
                    var script = scripts[i];
                    if (/(launch|satelliteLib)-[^\/]+.js(\?.*)?$/.test(script.src)) {
                      return script.async;
                    }
                  }
                  return true;
                }
              })();

              module.exports = function(settings, event) {
                var action = {
                  settings: settings,
                  event: event
                };

                var source = action.settings.source;
                if (!source) {
                  return;
                }

                if (action.settings.isExternal) {
                  return loadCodeSequentially(source).then(function(source) {
                    if (source) {
                      postscribeWrite(decorateCode(action, source));
                    }
                  });
                } else {
                  if (!libraryWasLoadedAsynchronously && document.readyState === 'loading') {
                    if (document.write) {
                      document.write(decorateCode(action, source));
                    } else {
                      postscribeWrite(decorateCode(action, source));
                    }
                  } else {
                    postscribeWrite(decorateCode(action, source));
                  }
                }
              };

            }

          },
          "core/src/lib/conditions/customCode.js": {
            "name": "custom-code",
            "displayName": "Custom Code",
            "script": function(module, exports, require, turbine) {

              'use strict';

              module.exports = function(settings, event) {
                return settings.source.call(event.element, event, event.target);
              };

            }

          },
          "core/src/lib/events/libraryLoaded.js": {
            "name": "library-loaded",
            "displayName": "Library Loaded (Page Top)",
            "script": function(module, exports, require, turbine) {

              'use strict';

              var pageLifecycleEvents = require('./helpers/pageLifecycleEvents');

              module.exports = function(settings, trigger) {
                pageLifecycleEvents.registerLibraryLoadedTrigger(trigger);
              };

            }

          },
          "core/src/lib/actions/helpers/decorateCode.js": {
            "script": function(module, exports, require, turbine) {

              'use strict';

              var id = 0;

              var isSourceLoadedFromFile = function(action) {
                return action.settings.isExternal;
              };

              var decorateGlobalJavaScriptCode = function(action, source) {
                return '<scr' + 'ipt>\n' + source + '\n</scr' + 'ipt>';
              };

              var decorateNonGlobalJavaScriptCode = function(action, source) {
                var runScriptFnName = '__runScript' + ++id;

                _satellite[runScriptFnName] = function(fn) {
                  fn.call(action.event.element, action.event, action.event.target);
                  delete _satellite[runScriptFnName];
                };

                return '<scr' + 'ipt>_satellite["' + runScriptFnName + '"](function(event, target) {\n' +
                  source +
                  '\n});</scr' + 'ipt>';
              };

              var decorators = {
                javascript: function(action, source) {
                  return action.settings.global ?
                    decorateGlobalJavaScriptCode(action, source) :
                    decorateNonGlobalJavaScriptCode(action, source);
                },
                html: function(action, source) {
                  if (isSourceLoadedFromFile(action)) {
                    return turbine.replaceTokens(source, action.event);
                  }

                  return source;
                }
              };

              module.exports = function(action, source) {
                return decorators[action.settings.language](action, source);
              };

            }

          },
          "core/src/lib/actions/helpers/loadCodeSequentially.js": {
            "script": function(module, exports, require, turbine) {

              'use strict';

              var Promise = require('@adobe/reactor-promise');
              var getSourceByUrl = require('./getSourceByUrl');

              var previousExecuteCodePromise = Promise.resolve();

              module.exports = function(sourceUrl) {
                var sequentiallyLoadCodePromise = new Promise(function(resolve) {
                  var loadCodePromise = getSourceByUrl(sourceUrl);

                  Promise.all([
                    loadCodePromise,
                    previousExecuteCodePromise
                  ]).then(function(values) {
                    var source = values[0];
                    resolve(source);
                  });
                });

                previousExecuteCodePromise = sequentiallyLoadCodePromise;
                return sequentiallyLoadCodePromise;
              };

            }

          },
          "core/node_modules/postscribe/dist/postscribe.js": {
            "script": function(module, exports, require, turbine) {
              (function webpackUniversalModuleDefinition(root, factory) {
                if(typeof exports === 'object' && typeof module === 'object')
                  module.exports = factory();
                else if(typeof define === 'function' && define.amd)
                  define([], factory);
                else if(typeof exports === 'object')
                  exports["postscribe"] = factory();
                else
                  root["postscribe"] = factory();
              })(this, function() {
                return  (function(modules) { 
 	var installedModules = {};
 	function __webpack_require__(moduleId) {
 		if(installedModules[moduleId])
 			return installedModules[moduleId].exports;
 		var module = installedModules[moduleId] = {
 			exports: {},
 			id: moduleId,
 			loaded: false
 		};
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 		module.loaded = true;
 		return module.exports;
 	}
 	__webpack_require__.m = modules;
 	__webpack_require__.c = installedModules;
 	__webpack_require__.p = "";
 	return __webpack_require__(0);
 })
 ([
 function(module, exports, __webpack_require__) {

                    'use strict';

                    var _postscribe = __webpack_require__(1);

                    var _postscribe2 = _interopRequireDefault(_postscribe);

                    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

                    module.exports = _postscribe2['default'];

 },
 function(module, exports, __webpack_require__) {

                    'use strict';

                    exports.__esModule = true;

                    var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

                    exports['default'] = postscribe;

                    var _writeStream = __webpack_require__(2);

                    var _writeStream2 = _interopRequireDefault(_writeStream);

                    var _utils = __webpack_require__(4);

                    var utils = _interopRequireWildcard(_utils);

                    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

                    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

                    function doNothing() {}

                    var OPTIONS = {
                      afterAsync: doNothing,

                      afterDequeue: doNothing,

                      afterStreamStart: doNothing,

                      afterWrite: doNothing,

                      autoFix: true,

                      beforeEnqueue: doNothing,

                      beforeWriteToken: function beforeWriteToken(tok) {
                        return tok;
                      },

                      beforeWrite: function beforeWrite(str) {
                        return str;
                      },

                      done: doNothing,

                      error: function error(e) {
                        throw new Error(e.msg);
                      },


                      releaseAsync: false
                    };

                    var nextId = 0;
                    var queue = [];
                    var active = null;

                    function nextStream() {
                      var args = queue.shift();
                      if (args) {
                        var options = utils.last(args);

                        options.afterDequeue();
                        args.stream = runStream.apply(undefined, args);
                        options.afterStreamStart();
                      }
                    }

                    function runStream(el, html, options) {
                      active = new _writeStream2['default'](el, options);

                      active.id = nextId++;
                      active.name = options.name || active.id;
                      postscribe.streams[active.name] = active;

                      var doc = el.ownerDocument;

                      var stash = {
                        close: doc.close,
                        open: doc.open,
                        write: doc.write,
                        writeln: doc.writeln
                      };

                      function _write(str) {
                        str = options.beforeWrite(str);
                        active.write(str);
                        options.afterWrite(str);
                      }

                      _extends(doc, {
                        close: doNothing,
                        open: doNothing,
                        write: function write() {
                          for (var _len = arguments.length, str = Array(_len), _key = 0; _key < _len; _key++) {
                            str[_key] = arguments[_key];
                          }

                          return _write(str.join(''));
                        },
                        writeln: function writeln() {
                          for (var _len2 = arguments.length, str = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                            str[_key2] = arguments[_key2];
                          }

                          return _write(str.join('') + '\n');
                        }
                      });

                      var oldOnError = active.win.onerror || doNothing;

                      active.win.onerror = function (msg, url, line) {
                        options.error({ msg: msg + ' - ' + url + ': ' + line });
                        oldOnError.apply(active.win, [msg, url, line]);
                      };

                      active.write(html, function () {
                        _extends(doc, stash);

                        active.win.onerror = oldOnError;

                        options.done();
                        active = null;
                        nextStream();
                      });

                      return active;
                    }

                    function postscribe(el, html, options) {
                      if (utils.isFunction(options)) {
                        options = { done: options };
                      } else if (options === 'clear') {
                        queue = [];
                        active = null;
                        nextId = 0;
                        return;
                      }

                      options = utils.defaults(options, OPTIONS);

                      if (/^#/.test(el)) {
                        el = window.document.getElementById(el.substr(1));
                      } else {
                        el = el.jquery ? el[0] : el;
                      }

                      var args = [el, html, options];

                      el.postscribe = {
                        cancel: function cancel() {
                          if (args.stream) {
                            args.stream.abort();
                          } else {
                            args[1] = doNothing;
                          }
                        }
                      };

                      options.beforeEnqueue(args);
                      queue.push(args);

                      if (!active) {
                        nextStream();
                      }

                      return el.postscribe;
                    }

                    _extends(postscribe, {
                      streams: {},
                      queue: queue,
                      WriteStream: _writeStream2['default']
                    });

 },
 function(module, exports, __webpack_require__) {

                    'use strict';

                    exports.__esModule = true;

                    var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

                    var _prescribe = __webpack_require__(3);

                    var _prescribe2 = _interopRequireDefault(_prescribe);

                    var _utils = __webpack_require__(4);

                    var utils = _interopRequireWildcard(_utils);

                    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

                    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

                    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

                    var DEBUG_CHUNK = false;

                    var BASEATTR = 'data-ps-';

                    var PROXY_STYLE = 'ps-style';

                    var PROXY_SCRIPT = 'ps-script';

                    function getData(el, name) {
                      var attr = BASEATTR + name;

                      var val = el.getAttribute(attr);

                      return !utils.existy(val) ? val : String(val);
                    }

                    function setData(el, name) {
                      var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                      var attr = BASEATTR + name;

                      if (utils.existy(value) && value !== '') {
                        el.setAttribute(attr, value);
                      } else {
                        el.removeAttribute(attr);
                      }
                    }


                    var WriteStream = function () {
                      function WriteStream(root) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                        _classCallCheck(this, WriteStream);

                        this.root = root;
                        this.options = options;
                        this.doc = root.ownerDocument;
                        this.win = this.doc.defaultView || this.doc.parentWindow;
                        this.parser = new _prescribe2['default']('', { autoFix: options.autoFix });

                        this.actuals = [root];

                        this.proxyHistory = '';

                        this.proxyRoot = this.doc.createElement(root.nodeName);

                        this.scriptStack = [];
                        this.writeQueue = [];

                        setData(this.proxyRoot, 'proxyof', 0);
                      }



                      WriteStream.prototype.write = function write() {
                        var _writeQueue;

                        (_writeQueue = this.writeQueue).push.apply(_writeQueue, arguments);

                        while (!this.deferredRemote && this.writeQueue.length) {
                          var arg = this.writeQueue.shift();

                          if (utils.isFunction(arg)) {
                            this._callFunction(arg);
                          } else {
                            this._writeImpl(arg);
                          }
                        }
                      };



                      WriteStream.prototype._callFunction = function _callFunction(fn) {
                        var tok = { type: 'function', value: fn.name || fn.toString() };
                        this._onScriptStart(tok);
                        fn.call(this.win, this.doc);
                        this._onScriptDone(tok);
                      };



                      WriteStream.prototype._writeImpl = function _writeImpl(html) {
                        this.parser.append(html);

                        var tok = void 0;
                        var script = void 0;
                        var style = void 0;
                        var tokens = [];

                        while ((tok = this.parser.readToken()) && !(script = utils.isScript(tok)) && !(style = utils.isStyle(tok))) {
                          tok = this.options.beforeWriteToken(tok);

                          if (tok) {
                            tokens.push(tok);
                          }
                        }

                        if (tokens.length > 0) {
                          this._writeStaticTokens(tokens);
                        }

                        if (script) {
                          this._handleScriptToken(tok);
                        }

                        if (style) {
                          this._handleStyleToken(tok);
                        }
                      };



                      WriteStream.prototype._writeStaticTokens = function _writeStaticTokens(tokens) {
                        var chunk = this._buildChunk(tokens);

                        if (!chunk.actual) {
                          return null;
                        }

                        chunk.html = this.proxyHistory + chunk.actual;
                        this.proxyHistory += chunk.proxy;
                        this.proxyRoot.innerHTML = chunk.html;

                        if (DEBUG_CHUNK) {
                          chunk.proxyInnerHTML = this.proxyRoot.innerHTML;
                        }

                        this._walkChunk();

                        if (DEBUG_CHUNK) {
                          chunk.actualInnerHTML = this.root.innerHTML;
                        }

                        return chunk;
                      };



                      WriteStream.prototype._buildChunk = function _buildChunk(tokens) {
                        var nextId = this.actuals.length;

                        var raw = [];

                        var actual = [];

                        var proxy = [];

                        var len = tokens.length;
                        for (var i = 0; i < len; i++) {
                          var tok = tokens[i];
                          var tokenRaw = tok.toString();

                          raw.push(tokenRaw);

                          if (tok.attrs) {
                            if (!/^noscript$/i.test(tok.tagName)) {
                              var id = nextId++;

                              actual.push(tokenRaw.replace(/(\/?>)/, ' ' + BASEATTR + 'id=' + id + ' $1'));

                              if (tok.attrs.id !== PROXY_SCRIPT && tok.attrs.id !== PROXY_STYLE) {
                                proxy.push(
                                  tok.type === 'atomicTag' ? '' : '<' + tok.tagName + ' ' + BASEATTR + 'proxyof=' + id + (tok.unary ? ' />' : '>'));
                              }
                            }
                          } else {
                            actual.push(tokenRaw);

                            proxy.push(tok.type === 'endTag' ? tokenRaw : '');
                          }
                        }

                        return {
                          tokens: tokens,
                          raw: raw.join(''),
                          actual: actual.join(''),
                          proxy: proxy.join('')
                        };
                      };



                      WriteStream.prototype._walkChunk = function _walkChunk() {
                        var node = void 0;
                        var stack = [this.proxyRoot];

                        while (utils.existy(node = stack.shift())) {
                          var isElement = node.nodeType === 1;
                          var isProxy = isElement && getData(node, 'proxyof');

                          if (!isProxy) {
                            if (isElement) {
                              this.actuals[getData(node, 'id')] = node;
                              setData(node, 'id');
                            }

                            var parentIsProxyOf = node.parentNode && getData(node.parentNode, 'proxyof');
                            if (parentIsProxyOf) {
                              this.actuals[parentIsProxyOf].appendChild(node);
                            }
                          }

                          stack.unshift.apply(stack, utils.toArray(node.childNodes));
                        }
                      };



                      WriteStream.prototype._handleScriptToken = function _handleScriptToken(tok) {
                        var _this = this;

                        var remainder = this.parser.clear();

                        if (remainder) {
                          this.writeQueue.unshift(remainder);
                        }

                        tok.src = tok.attrs.src || tok.attrs.SRC;

                        tok = this.options.beforeWriteToken(tok);
                        if (!tok) {
                          return;
                        }

                        if (tok.src && this.scriptStack.length) {
                          this.deferredRemote = tok;
                        } else {
                          this._onScriptStart(tok);
                        }

                        this._writeScriptToken(tok, function () {
                          _this._onScriptDone(tok);
                        });
                      };



                      WriteStream.prototype._handleStyleToken = function _handleStyleToken(tok) {
                        var remainder = this.parser.clear();

                        if (remainder) {
                          this.writeQueue.unshift(remainder);
                        }

                        tok.type = tok.attrs.type || tok.attrs.TYPE || 'text/css';

                        tok = this.options.beforeWriteToken(tok);

                        if (tok) {
                          this._writeStyleToken(tok);
                        }

                        if (remainder) {
                          this.write();
                        }
                      };



                      WriteStream.prototype._writeStyleToken = function _writeStyleToken(tok) {
                        var el = this._buildStyle(tok);

                        this._insertCursor(el, PROXY_STYLE);

                        if (tok.content) {
                          if (el.styleSheet && !el.sheet) {
                            el.styleSheet.cssText = tok.content;
                          } else {
                            el.appendChild(this.doc.createTextNode(tok.content));
                          }
                        }
                      };



                      WriteStream.prototype._buildStyle = function _buildStyle(tok) {
                        var el = this.doc.createElement(tok.tagName);

                        el.setAttribute('type', tok.type);

                        utils.eachKey(tok.attrs, function (name, value) {
                          el.setAttribute(name, value);
                        });

                        return el;
                      };



                      WriteStream.prototype._insertCursor = function _insertCursor(el, which) {
                        this._writeImpl('<span id="' + which + '"/>');

                        var cursor = this.doc.getElementById(which);

                        if (cursor) {
                          cursor.parentNode.replaceChild(el, cursor);
                        }
                      };



                      WriteStream.prototype._onScriptStart = function _onScriptStart(tok) {
                        tok.outerWrites = this.writeQueue;
                        this.writeQueue = [];
                        this.scriptStack.unshift(tok);
                      };



                      WriteStream.prototype._onScriptDone = function _onScriptDone(tok) {
                        if (tok !== this.scriptStack[0]) {
                          this.options.error({ msg: 'Bad script nesting or script finished twice' });
                          return;
                        }

                        this.scriptStack.shift();

                        this.write.apply(this, tok.outerWrites);


                        if (!this.scriptStack.length && this.deferredRemote) {
                          this._onScriptStart(this.deferredRemote);
                          this.deferredRemote = null;
                        }
                      };



                      WriteStream.prototype._writeScriptToken = function _writeScriptToken(tok, done) {
                        var el = this._buildScript(tok);
                        var asyncRelease = this._shouldRelease(el);
                        var afterAsync = this.options.afterAsync;

                        if (tok.src) {
                          el.src = tok.src;
                          this._scriptLoadHandler(el, !asyncRelease ? function () {
                            done();
                            afterAsync();
                          } : afterAsync);
                        }

                        try {
                          this._insertCursor(el, PROXY_SCRIPT);
                          if (!el.src || asyncRelease) {
                            done();
                          }
                        } catch (e) {
                          this.options.error(e);
                          done();
                        }
                      };



                      WriteStream.prototype._buildScript = function _buildScript(tok) {
                        var el = this.doc.createElement(tok.tagName);

                        utils.eachKey(tok.attrs, function (name, value) {
                          el.setAttribute(name, value);
                        });

                        if (tok.content) {
                          el.text = tok.content;
                        }

                        return el;
                      };



                      WriteStream.prototype._scriptLoadHandler = function _scriptLoadHandler(el, done) {
                        function cleanup() {
                          el = el.onload = el.onreadystatechange = el.onerror = null;
                        }

                        var error = this.options.error;

                        function success() {
                          cleanup();
                          if (done != null) {
                            done();
                          }
                          done = null;
                        }

                        function failure(err) {
                          cleanup();
                          error(err);
                          if (done != null) {
                            done();
                          }
                          done = null;
                        }

                        function reattachEventListener(el, evt) {
                          var handler = el['on' + evt];
                          if (handler != null) {
                            el['_on' + evt] = handler;
                          }
                        }

                        reattachEventListener(el, 'load');
                        reattachEventListener(el, 'error');

                        _extends(el, {
                          onload: function onload() {
                            if (el._onload) {
                              try {
                                el._onload.apply(this, Array.prototype.slice.call(arguments, 0));
                              } catch (err) {
                                failure({ msg: 'onload handler failed ' + err + ' @ ' + el.src });
                              }
                            }
                            success();
                          },
                          onerror: function onerror() {
                            if (el._onerror) {
                              try {
                                el._onerror.apply(this, Array.prototype.slice.call(arguments, 0));
                              } catch (err) {
                                failure({ msg: 'onerror handler failed ' + err + ' @ ' + el.src });
                                return;
                              }
                            }
                            failure({ msg: 'remote script failed ' + el.src });
                          },
                          onreadystatechange: function onreadystatechange() {
                            if (/^(loaded|complete)$/.test(el.readyState)) {
                              success();
                            }
                          }
                        });
                      };



                      WriteStream.prototype._shouldRelease = function _shouldRelease(el) {
                        var isScript = /^script$/i.test(el.nodeName);
                        return !isScript || !!(this.options.releaseAsync && el.src && el.hasAttribute('async'));
                      };

                      return WriteStream;
                    }();

                    exports['default'] = WriteStream;

 },
 function(module, exports, __webpack_require__) {

                    (function webpackUniversalModuleDefinition(root, factory) {
                      if(true)
                        module.exports = factory();
                      else if(typeof define === 'function' && define.amd)
                        define([], factory);
                      else if(typeof exports === 'object')
                        exports["Prescribe"] = factory();
                      else
                        root["Prescribe"] = factory();
                    })(this, function() {
                      return  (function(modules) { 
 	var installedModules = {};

 	function __webpack_require__(moduleId) {

 		if(installedModules[moduleId])
 			return installedModules[moduleId].exports;

 		var module = installedModules[moduleId] = {
 			exports: {},
 			id: moduleId,
 			loaded: false
 		};

 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		module.loaded = true;

 		return module.exports;
 	}


 	__webpack_require__.m = modules;

 	__webpack_require__.c = installedModules;

 	__webpack_require__.p = "";

 	return __webpack_require__(0);
 })
 ([
 function(module, exports, __webpack_require__) {

                          'use strict';

                          var _HtmlParser = __webpack_require__(1);

                          var _HtmlParser2 = _interopRequireDefault(_HtmlParser);

                          function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

                          module.exports = _HtmlParser2['default'];

 },
 function(module, exports, __webpack_require__) {

                          'use strict';

                          exports.__esModule = true;

                          var _supports = __webpack_require__(2);

                          var supports = _interopRequireWildcard(_supports);

                          var _streamReaders = __webpack_require__(3);

                          var streamReaders = _interopRequireWildcard(_streamReaders);

                          var _fixedReadTokenFactory = __webpack_require__(6);

                          var _fixedReadTokenFactory2 = _interopRequireDefault(_fixedReadTokenFactory);

                          var _utils = __webpack_require__(5);

                          function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

                          function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

                          function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

                          var detect = {
                            comment: /^<!--/,
                            endTag: /^<\//,
                            atomicTag: /^<\s*(script|style|noscript|iframe|textarea)[\s\/>]/i,
                            startTag: /^</,
                            chars: /^[^<]/
                          };


                          var HtmlParser = function () {
                            function HtmlParser() {
                              var _this = this;

                              var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                              _classCallCheck(this, HtmlParser);

                              this.stream = stream;

                              var fix = false;
                              var fixedTokenOptions = {};

                              for (var key in supports) {
                                if (supports.hasOwnProperty(key)) {
                                  if (options.autoFix) {
                                    fixedTokenOptions[key + 'Fix'] = true; 
                                  }
                                  fix = fix || fixedTokenOptions[key + 'Fix'];
                                }
                              }

                              if (fix) {
                                this._readToken = (0, _fixedReadTokenFactory2['default'])(this, fixedTokenOptions, function () {
                                  return _this._readTokenImpl();
                                });
                                this._peekToken = (0, _fixedReadTokenFactory2['default'])(this, fixedTokenOptions, function () {
                                  return _this._peekTokenImpl();
                                });
                              } else {
                                this._readToken = this._readTokenImpl;
                                this._peekToken = this._peekTokenImpl;
                              }
                            }



                            HtmlParser.prototype.append = function append(str) {
                              this.stream += str;
                            };



                            HtmlParser.prototype.prepend = function prepend(str) {
                              this.stream = str + this.stream;
                            };



                            HtmlParser.prototype._readTokenImpl = function _readTokenImpl() {
                              var token = this._peekTokenImpl();
                              if (token) {
                                this.stream = this.stream.slice(token.length);
                                return token;
                              }
                            };



                            HtmlParser.prototype._peekTokenImpl = function _peekTokenImpl() {
                              for (var type in detect) {
                                if (detect.hasOwnProperty(type)) {
                                  if (detect[type].test(this.stream)) {
                                    var token = streamReaders[type](this.stream);

                                    if (token) {
                                      if (token.type === 'startTag' && /script|style/i.test(token.tagName)) {
                                        return null;
                                      } else {
                                        token.text = this.stream.substr(0, token.length);
                                        return token;
                                      }
                                    }
                                  }
                                }
                              }
                            };



                            HtmlParser.prototype.peekToken = function peekToken() {
                              return this._peekToken();
                            };



                            HtmlParser.prototype.readToken = function readToken() {
                              return this._readToken();
                            };



                            HtmlParser.prototype.readTokens = function readTokens(handlers) {
                              var tok = void 0;
                              while (tok = this.readToken()) {
                                if (handlers[tok.type] && handlers[tok.type](tok) === false) {
                                  return;
                                }
                              }
                            };



                            HtmlParser.prototype.clear = function clear() {
                              var rest = this.stream;
                              this.stream = '';
                              return rest;
                            };



                            HtmlParser.prototype.rest = function rest() {
                              return this.stream;
                            };

                            return HtmlParser;
                          }();

                          exports['default'] = HtmlParser;


                          HtmlParser.tokenToString = function (tok) {
                            return tok.toString();
                          };

                          HtmlParser.escapeAttributes = function (attrs) {
                            var escapedAttrs = {};

                            for (var name in attrs) {
                              if (attrs.hasOwnProperty(name)) {
                                escapedAttrs[name] = (0, _utils.escapeQuotes)(attrs[name], null);
                              }
                            }

                            return escapedAttrs;
                          };

                          HtmlParser.supports = supports;

                          for (var key in supports) {
                            if (supports.hasOwnProperty(key)) {
                              HtmlParser.browserHasFlaw = HtmlParser.browserHasFlaw || !supports[key] && key;
                            }
                          }

 },
 function(module, exports) {

                          'use strict';

                          exports.__esModule = true;
                          var tagSoup = false;
                          var selfClose = false;

                          var work = window.document.createElement('div');

                          try {
                            var html = '<P><I></P></I>';
                            work.innerHTML = html;
                            exports.tagSoup = tagSoup = work.innerHTML !== html;
                          } catch (e) {
                            exports.tagSoup = tagSoup = false;
                          }

                          try {
                            work.innerHTML = '<P><i><P></P></i></P>';
                            exports.selfClose = selfClose = work.childNodes.length === 2;
                          } catch (e) {
                            exports.selfClose = selfClose = false;
                          }

                          work = null;

                          exports.tagSoup = tagSoup;
                          exports.selfClose = selfClose;

 },
 function(module, exports, __webpack_require__) {

                          'use strict';

                          exports.__esModule = true;

                          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

                          exports.comment = comment;
                          exports.chars = chars;
                          exports.startTag = startTag;
                          exports.atomicTag = atomicTag;
                          exports.endTag = endTag;

                          var _tokens = __webpack_require__(4);

                          var REGEXES = {
                            startTag: /^<([\-A-Za-z0-9_]+)((?:\s+[\w\-]+(?:\s*=?\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/,
                            endTag: /^<\/([\-A-Za-z0-9_]+)[^>]*>/,
                            attr: /(?:([\-A-Za-z0-9_]+)\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|([^>\s]+)))|(?:([\-A-Za-z0-9_]+)(\s|$)+)/g,
                            fillAttr: /^(checked|compact|declare|defer|disabled|ismap|multiple|nohref|noresize|noshade|nowrap|readonly|selected)$/i
                          };

                          function comment(stream) {
                            var index = stream.indexOf('-->');
                            if (index >= 0) {
                              return new _tokens.CommentToken(stream.substr(4, index - 1), index + 3);
                            }
                          }

                          function chars(stream) {
                            var index = stream.indexOf('<');
                            return new _tokens.CharsToken(index >= 0 ? index : stream.length);
                          }

                          function startTag(stream) {
                            var endTagIndex = stream.indexOf('>');
                            if (endTagIndex !== -1) {
                              var match = stream.match(REGEXES.startTag);
                              if (match) {
                                var _ret = function () {
                                  var attrs = {};
                                  var booleanAttrs = {};
                                  var rest = match[2];

                                  match[2].replace(REGEXES.attr, function (match, name) {
                                    if (!(arguments[2] || arguments[3] || arguments[4] || arguments[5])) {
                                      attrs[name] = '';
                                    } else if (arguments[5]) {
                                      attrs[arguments[5]] = '';
                                      booleanAttrs[arguments[5]] = true;
                                    } else {
                                      attrs[name] = arguments[2] || arguments[3] || arguments[4] || REGEXES.fillAttr.test(name) && name || '';
                                    }

                                    rest = rest.replace(match, '');
                                  });

                                  return {
                                    v: new _tokens.StartTagToken(match[1], match[0].length, attrs, booleanAttrs, !!match[3], rest.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ''))
                                  };
                                }();

                                if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
                              }
                            }
                          }

                          function atomicTag(stream) {
                            var start = startTag(stream);
                            if (start) {
                              var rest = stream.slice(start.length);
                              if (rest.match(new RegExp('<\/\\s*' + start.tagName + '\\s*>', 'i'))) {
                                var match = rest.match(new RegExp('([\\s\\S]*?)<\/\\s*' + start.tagName + '\\s*>', 'i'));
                                if (match) {
                                  return new _tokens.AtomicTagToken(start.tagName, match[0].length + start.length, start.attrs, start.booleanAttrs, match[1]);
                                }
                              }
                            }
                          }

                          function endTag(stream) {
                            var match = stream.match(REGEXES.endTag);
                            if (match) {
                              return new _tokens.EndTagToken(match[1], match[0].length);
                            }
                          }

 },
 function(module, exports, __webpack_require__) {

                          'use strict';

                          exports.__esModule = true;
                          exports.EndTagToken = exports.AtomicTagToken = exports.StartTagToken = exports.TagToken = exports.CharsToken = exports.CommentToken = exports.Token = undefined;

                          var _utils = __webpack_require__(5);

                          function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

                          var Token =
                            exports.Token = function Token(type, length) {
                              _classCallCheck(this, Token);

                              this.type = type;
                              this.length = length;
                              this.text = '';
                            };



                          var CommentToken = exports.CommentToken = function () {
                            function CommentToken(content, length) {
                              _classCallCheck(this, CommentToken);

                              this.type = 'comment';
                              this.length = length || (content ? content.length : 0);
                              this.text = '';
                              this.content = content;
                            }

                            CommentToken.prototype.toString = function toString() {
                              return '<!--' + this.content;
                            };

                            return CommentToken;
                          }();



                          var CharsToken = exports.CharsToken = function () {
                            function CharsToken(length) {
                              _classCallCheck(this, CharsToken);

                              this.type = 'chars';
                              this.length = length;
                              this.text = '';
                            }

                            CharsToken.prototype.toString = function toString() {
                              return this.text;
                            };

                            return CharsToken;
                          }();



                          var TagToken = exports.TagToken = function () {
                            function TagToken(type, tagName, length, attrs, booleanAttrs) {
                              _classCallCheck(this, TagToken);

                              this.type = type;
                              this.length = length;
                              this.text = '';
                              this.tagName = tagName;
                              this.attrs = attrs;
                              this.booleanAttrs = booleanAttrs;
                              this.unary = false;
                              this.html5Unary = false;
                            }



                            TagToken.formatTag = function formatTag(tok) {
                              var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                              var str = '<' + tok.tagName;
                              for (var key in tok.attrs) {
                                if (tok.attrs.hasOwnProperty(key)) {
                                  str += ' ' + key;

                                  var val = tok.attrs[key];
                                  if (typeof tok.booleanAttrs === 'undefined' || typeof tok.booleanAttrs[key] === 'undefined') {
                                    str += '="' + (0, _utils.escapeQuotes)(val) + '"';
                                  }
                                }
                              }

                              if (tok.rest) {
                                str += ' ' + tok.rest;
                              }

                              if (tok.unary && !tok.html5Unary) {
                                str += '/>';
                              } else {
                                str += '>';
                              }

                              if (content !== undefined && content !== null) {
                                str += content + '</' + tok.tagName + '>';
                              }

                              return str;
                            };

                            return TagToken;
                          }();



                          var StartTagToken = exports.StartTagToken = function () {
                            function StartTagToken(tagName, length, attrs, booleanAttrs, unary, rest) {
                              _classCallCheck(this, StartTagToken);

                              this.type = 'startTag';
                              this.length = length;
                              this.text = '';
                              this.tagName = tagName;
                              this.attrs = attrs;
                              this.booleanAttrs = booleanAttrs;
                              this.html5Unary = false;
                              this.unary = unary;
                              this.rest = rest;
                            }

                            StartTagToken.prototype.toString = function toString() {
                              return TagToken.formatTag(this);
                            };

                            return StartTagToken;
                          }();



                          var AtomicTagToken = exports.AtomicTagToken = function () {
                            function AtomicTagToken(tagName, length, attrs, booleanAttrs, content) {
                              _classCallCheck(this, AtomicTagToken);

                              this.type = 'atomicTag';
                              this.length = length;
                              this.text = '';
                              this.tagName = tagName;
                              this.attrs = attrs;
                              this.booleanAttrs = booleanAttrs;
                              this.unary = false;
                              this.html5Unary = false;
                              this.content = content;
                            }

                            AtomicTagToken.prototype.toString = function toString() {
                              return TagToken.formatTag(this, this.content);
                            };

                            return AtomicTagToken;
                          }();



                          var EndTagToken = exports.EndTagToken = function () {
                            function EndTagToken(tagName, length) {
                              _classCallCheck(this, EndTagToken);

                              this.type = 'endTag';
                              this.length = length;
                              this.text = '';
                              this.tagName = tagName;
                            }

                            EndTagToken.prototype.toString = function toString() {
                              return '</' + this.tagName + '>';
                            };

                            return EndTagToken;
                          }();

 },
 function(module, exports) {

                          'use strict';

                          exports.__esModule = true;
                          exports.escapeQuotes = escapeQuotes;

                          function escapeQuotes(value) {
                            var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

                            return !value ? defaultValue : value.replace(/([^"]*)"/g, function (_, prefix) {
                              return (/\\/.test(prefix) ? prefix + '"' : prefix + '\\"'
                              );
                            });
                          }

 },
 function(module, exports) {

                          'use strict';

                          exports.__esModule = true;
                          exports['default'] = fixedReadTokenFactory;
                          var EMPTY = /^(AREA|BASE|BASEFONT|BR|COL|FRAME|HR|IMG|INPUT|ISINDEX|LINK|META|PARAM|EMBED)$/i;

                          var CLOSESELF = /^(COLGROUP|DD|DT|LI|OPTIONS|P|TD|TFOOT|TH|THEAD|TR)$/i;

                          function correct(tok) {
                            if (tok && tok.type === 'startTag') {
                              tok.unary = EMPTY.test(tok.tagName) || tok.unary;
                              tok.html5Unary = !/\/>$/.test(tok.text);
                            }
                            return tok;
                          }

                          function peekToken(parser, readTokenImpl) {
                            var tmp = parser.stream;
                            var tok = correct(readTokenImpl());
                            parser.stream = tmp;
                            return tok;
                          }

                          function closeLast(parser, stack) {
                            var tok = stack.pop();

                            parser.prepend('</' + tok.tagName + '>');
                          }

                          function newStack() {
                            var stack = [];

                            stack.last = function () {
                              return this[this.length - 1];
                            };

                            stack.lastTagNameEq = function (tagName) {
                              var last = this.last();
                              return last && last.tagName && last.tagName.toUpperCase() === tagName.toUpperCase();
                            };

                            stack.containsTagName = function (tagName) {
                              for (var i = 0, tok; tok = this[i]; i++) {
                                if (tok.tagName === tagName) {
                                  return true;
                                }
                              }
                              return false;
                            };

                            return stack;
                          }

                          function fixedReadTokenFactory(parser, options, readTokenImpl) {
                            var stack = newStack();

                            var handlers = {
                              startTag: function startTag(tok) {
                                var tagName = tok.tagName;

                                if (tagName.toUpperCase() === 'TR' && stack.lastTagNameEq('TABLE')) {
                                  parser.prepend('<TBODY>');
                                  prepareNextToken();
                                } else if (options.selfCloseFix && CLOSESELF.test(tagName) && stack.containsTagName(tagName)) {
                                  if (stack.lastTagNameEq(tagName)) {
                                    closeLast(parser, stack);
                                  } else {
                                    parser.prepend('</' + tok.tagName + '>');
                                    prepareNextToken();
                                  }
                                } else if (!tok.unary) {
                                  stack.push(tok);
                                }
                              },
                              endTag: function endTag(tok) {
                                var last = stack.last();
                                if (last) {
                                  if (options.tagSoupFix && !stack.lastTagNameEq(tok.tagName)) {
                                    closeLast(parser, stack);
                                  } else {
                                    stack.pop();
                                  }
                                } else if (options.tagSoupFix) {
                                  readTokenImpl();
                                  prepareNextToken();
                                }
                              }
                            };

                            function prepareNextToken() {
                              var tok = peekToken(parser, readTokenImpl);
                              if (tok && handlers[tok.type]) {
                                handlers[tok.type](tok);
                              }
                            }

                            return function fixedReadToken() {
                              prepareNextToken();
                              return correct(readTokenImpl());
                            };
                          }

 }
 ])
                    });
                    ;

 },
 function(module, exports) {

                    'use strict';

                    exports.__esModule = true;

                    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

                    exports.existy = existy;
                    exports.isFunction = isFunction;
                    exports.each = each;
                    exports.eachKey = eachKey;
                    exports.defaults = defaults;
                    exports.toArray = toArray;
                    exports.last = last;
                    exports.isTag = isTag;
                    exports.isScript = isScript;
                    exports.isStyle = isStyle;
                    function existy(thing) {
                      return thing !== void 0 && thing !== null;
                    }

                    function isFunction(x) {
                      return 'function' === typeof x;
                    }

                    function each(arr, fn, target) {
                      var i = void 0;
                      var len = arr && arr.length || 0;
                      for (i = 0; i < len; i++) {
                        fn.call(target, arr[i], i);
                      }
                    }

                    function eachKey(obj, fn, target) {
                      for (var key in obj) {
                        if (obj.hasOwnProperty(key)) {
                          fn.call(target, key, obj[key]);
                        }
                      }
                    }

                    function defaults(options, _defaults) {
                      options = options || {};
                      eachKey(_defaults, function (key, val) {
                        if (!existy(options[key])) {
                          options[key] = val;
                        }
                      });
                      return options;
                    }

                    function toArray(obj) {
                      try {
                        return Array.prototype.slice.call(obj);
                      } catch (e) {
                        var _ret = function () {
                          var ret = [];
                          each(obj, function (val) {
                            ret.push(val);
                          });
                          return {
                            v: ret
                          };
                        }();

                        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
                      }
                    }

                    function last(array) {
                      return array[array.length - 1];
                    }

                    function isTag(tok, tag) {
                      return !tok || !(tok.type === 'startTag' || tok.type === 'atomicTag') || !('tagName' in tok) ? !1 : !!~tok.tagName.toLowerCase().indexOf(tag);
                    }

                    function isScript(tok) {
                      return isTag(tok, 'script');
                    }

                    function isStyle(tok) {
                      return isTag(tok, 'style');
                    }

 }
 ])
              });
              ;
            }

          },
          "core/src/lib/actions/helpers/getSourceByUrl.js": {
            "script": function(module, exports, require, turbine) {

              'use strict';
              var loadScript = require('@adobe/reactor-load-script');
              var Promise = require('@adobe/reactor-promise');

              var codeBySourceUrl = {};
              var scriptStore = {};

              var loadScriptOnlyOnce = function(url) {
                if (!scriptStore[url]) {
                  scriptStore[url] = loadScript(url);
                }

                return scriptStore[url];
              };

              _satellite.__registerScript = function(sourceUrl, code) {
                codeBySourceUrl[sourceUrl] = code;
              };

              module.exports = function(sourceUrl) {
                if (codeBySourceUrl[sourceUrl]) {
                  return Promise.resolve(codeBySourceUrl[sourceUrl]);
                } else {
                  return new Promise(function(resolve) {
                    loadScriptOnlyOnce(sourceUrl).then(function() {
                      resolve(codeBySourceUrl[sourceUrl]);
                    }, function() {
                      resolve();
                    });
                  });
                }
              };

            }

          },
          "core/src/lib/events/helpers/pageLifecycleEvents.js": {
            "script": function(module, exports, require, turbine) {

              'use strict';


              var window = require('@adobe/reactor-window');
              var document = require('@adobe/reactor-document');

              var isIE10 = window.navigator.appVersion.indexOf('MSIE 10') !== -1;
              var WINDOW_LOADED = 'WINDOW_LOADED';
              var DOM_READY = 'DOM_READY';
              var PAGE_BOTTOM = 'PAGE_BOTTOM';

              var lifecycleEventsOrder = [PAGE_BOTTOM, DOM_READY, WINDOW_LOADED];

              var createSyntheticEvent = function(element, nativeEvent) {
                return {
                  element: element,
                  target: element,
                  nativeEvent: nativeEvent
                };
              };

              var registry = {};
              lifecycleEventsOrder.forEach(function(event) {
                registry[event] = [];
              });

              var processRegistry = function(lifecycleEvent, nativeEvent) {
                lifecycleEventsOrder
                .slice(0, getLifecycleEventIndex(lifecycleEvent) + 1)
                .forEach(function(lifecycleEvent) {
                  processTriggers(nativeEvent, lifecycleEvent);
                });
              };

              var detectLifecycleEvent = function() {
                if (document.readyState === 'complete') {
                  return WINDOW_LOADED;
                } else if (document.readyState === 'interactive') {
                  return !isIE10 ? DOM_READY : null;
                }
              };

              var getLifecycleEventIndex = function(event) {
                return lifecycleEventsOrder.indexOf(event);
              };

              var processTriggers = function(nativeEvent, lifecycleEvent) {
                registry[lifecycleEvent].forEach(function(triggerData) {
                  processTrigger(nativeEvent, triggerData);
                });
                registry[lifecycleEvent] = [];
              };

              var processTrigger = function(nativeEvent, triggerData) {
                var trigger = triggerData.trigger;
                var syntheticEventFn = triggerData.syntheticEventFn;

                trigger(syntheticEventFn ? syntheticEventFn(nativeEvent) : null);
              };

              window._satellite = window._satellite || {};
              window._satellite.pageBottom = processRegistry.bind(null, PAGE_BOTTOM);

              document.addEventListener(
                'DOMContentLoaded',
                processRegistry.bind(null, DOM_READY),
                true
              );
              window.addEventListener(
                'load',
                processRegistry.bind(null, WINDOW_LOADED),
                true
              );

              window.setTimeout(function() {
                var lifecycleEvent = detectLifecycleEvent();
                if (lifecycleEvent) {
                  processRegistry(lifecycleEvent);
                }
              }, 0);

              module.exports = {
                registerLibraryLoadedTrigger: function(trigger) {
                  trigger();
                },
                registerPageBottomTrigger: function(trigger) {
                  registry[PAGE_BOTTOM].push({
                    trigger: trigger
                  });
                },
                registerDomReadyTrigger: function(trigger) {
                  registry[DOM_READY].push({
                    trigger: trigger,
                    syntheticEventFn: createSyntheticEvent.bind(null, document)
                  });
                },
                registerWindowLoadedTrigger: function(trigger) {
                  registry[WINDOW_LOADED].push({
                    trigger: trigger,
                    syntheticEventFn: createSyntheticEvent.bind(null, window)
                  });
                }
              };

            }

          }
        },
        "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EP0fe6b1b3170b414e92e8f7ad4f74f857/"
      },
      "adobe-analytics": {
        "displayName": "Adobe Analytics",
        "modules": {
          "adobe-analytics/src/lib/actions/setVariables.js": {
            "name": "set-variables",
            "displayName": "Set Variables",
            "script": function(module, exports, require, turbine) {

              'use strict';

              var getTracker = require('../sharedModules/getTracker');
              var applyTrackerVariables = require('../helpers/applyTrackerVariables');

              module.exports = function(settings, event) {
                return getTracker().then(function(tracker) {
                  turbine.logger.info('Set variables on the tracker.');
                  applyTrackerVariables(tracker, settings.trackerProperties);
                  if (settings.customSetup && settings.customSetup.source) {
                    settings.customSetup.source.call(event.element, event, tracker);
                  }
                }, function(errorMessage) {
                  turbine.logger.error(
                    'Cannot set variables: ' +
                    errorMessage
                  );
                });
              };

            }

          },
          "adobe-analytics/src/lib/actions/sendBeacon.js": {
            "name": "send-beacon",
            "displayName": "Send Beacon",
            "script": function(module, exports, require, turbine) {

              'use strict';

              var getTracker = require('../sharedModules/getTracker');

              var isLink = function(element) {
                return element && element.nodeName && element.nodeName.toLowerCase() === 'a';
              };

              var getLinkName = function(element) {
                if (isLink(element)) {
                  return element.innerHTML;
                } else {
                  return 'link clicked';
                }
              };

              var sendBeacon = function(tracker, settings, targetElement) {
                if (settings.type === 'page') {
                  turbine.logger.info('Firing page view beacon.');
                  tracker.t();
                } else {
                  var linkSettings = {
                    linkType: settings.linkType || 'o',
                    linkName: settings.linkName || getLinkName(targetElement)
                  };

                  turbine.logger.info(
                    'Firing link track beacon using the values: ' +
                    JSON.stringify(linkSettings) + '.'
                  );

                  tracker.tl(
                    isLink(targetElement) ? targetElement : 'true',
                    linkSettings.linkType,
                    linkSettings.linkName
                  );
                }
              };

              module.exports = function(settings, event) {
                return getTracker().then(function(tracker) {
                  sendBeacon(tracker, settings, event.element);
                }, function(errorMessage) {
                  turbine.logger.error(
                    'Cannot send beacon: ' +
                    errorMessage
                  );
                });
              };

            }

          },
          "adobe-analytics/src/lib/actions/clearVariables.js": {
            "name": "clear-variables",
            "displayName": "Clear Variables",
            "script": function(module, exports, require, turbine) {

              'use strict';

              var getTracker = require('../sharedModules/getTracker');

              module.exports = function() {
                return getTracker().then(function(tracker) {
                  if (tracker.clearVars) {
                    turbine.logger.info('Clear variables.');
                    tracker.clearVars();
                  }
                }, function(errorMessage) {
                  turbine.logger.error(
                    'Cannot clear variables: ' +
                    errorMessage
                  );
                });
              };

            }

          },
          "adobe-analytics/src/lib/sharedModules/getTracker.js": {
            "script": function(module, exports, require, turbine) {

              'use strict';

              var cookie = require('@adobe/reactor-cookie');
              var Promise = require('@adobe/reactor-promise');
              var window = require('@adobe/reactor-window');
              var augmenters = require('../helpers/augmenters');
              var loadScript = require('@adobe/reactor-load-script');

              var applyTrackerVariables = require('../helpers/applyTrackerVariables');
              var loadLibrary = require('../helpers/loadLibrary');
              var generateVersion = require('../helpers/generateVersion');

              var version = generateVersion(turbine.buildInfo.turbineBuildDate);
              var BEFORE_SETTINGS_LOAD_PHASE = 'beforeSettings';

              var mcidInstance = turbine.getSharedModule('adobe-mcid', 'mcid-instance');

              var checkEuCompliance = function(trackingCoookieName) {
                if (!trackingCoookieName) {
                  return true;
                }

                var euCookieValue = cookie.get(trackingCoookieName);
                return euCookieValue === 'true';
              };

              var augmentTracker = function(tracker) {
                return Promise.all(augmenters.map(function(augmenterFn) {
                  var result;

                  try {
                    result = augmenterFn(tracker);
                  } catch (e) {
                    setTimeout(function() {
                      throw e;
                    });
                  }

                  return Promise.resolve(result);
                })).then(function() {
                  return tracker;
                });
              };

              var linkVisitorId = function(tracker) {
                if (mcidInstance) {
                  turbine.logger.info('Setting MCID instance on the tracker.');
                  tracker.visitor = mcidInstance;
                }

                return tracker;
              };

              var updateTrackerVersion = function(tracker) {
                turbine.logger.info('Setting version on tracker: "' + version + '".');

                if (typeof tracker.tagContainerMarker !== 'undefined') {
                  tracker.tagContainerMarker = version;
                } else if (typeof tracker.version === 'string'
                  && tracker.version.substring(tracker.version.length - 5) !== ('-' + version)) {
                  tracker.version += '-' + version;
                }

                return tracker;
              };

              var updateTrackerVariables = function(trackerProperties, customSetup, tracker) {
                if (customSetup.loadPhase === BEFORE_SETTINGS_LOAD_PHASE && customSetup.source) {
                  turbine.logger.info('Calling custom script before settings.');
                  customSetup.source.call(window, tracker);
                }

                applyTrackerVariables(tracker, trackerProperties || {});

                if (customSetup.loadPhase !== BEFORE_SETTINGS_LOAD_PHASE && customSetup.source) {
                  turbine.logger.info('Calling custom script after settings.');
                  customSetup.source.call(window, tracker);
                }

                return tracker;
              };

              var loadTrackerModules = function(properties, tracker) {
                var moduleProperties = properties.moduleProperties;
                if (moduleProperties &&
                  moduleProperties.audienceManager &&
                  moduleProperties.audienceManager.config &&
                  window._satellite &&
                  window._satellite.company &&
                  window._satellite.company.orgId) {
                  var visitorServiceConfig = {
                    namespace: window._satellite.company.orgId
                  };
                  moduleProperties.audienceManager.config.visitorService = visitorServiceConfig;
                  var libFileName = 'AppMeasurement_Module_AudienceManagement.js';
                  var libFileUrl = turbine.getHostedLibFileUrl(libFileName);
                  return loadScript(libFileUrl)
                  .then( function() {
                    tracker.loadModule('AudienceManagement');
                    turbine.logger.info('Initializing AudienceManagement module');
                    tracker.AudienceManagement.setup(moduleProperties.audienceManager.config);
                    return tracker;
                  });
                } else {
                  return tracker;
                }
              };

              var initialize = function(settings) {
                if (checkEuCompliance(settings.trackingCookieName)) {
                  return loadLibrary(settings)
                  .then(augmentTracker)
                  .then(linkVisitorId)
                  .then(updateTrackerVersion)
                  .then(updateTrackerVariables.bind(
                    null,
                    settings.trackerProperties,
                    settings.customSetup || {}
                  ))
                  .then(loadTrackerModules.bind(null, settings));
                } else {
                  return Promise.reject('EU compliance was not acknowledged by the user.');
                }
              };

              var promise = initialize(turbine.getExtensionSettings());
              module.exports = function() {
                return promise;
              };

            }
            ,
            "name": "get-tracker",
            "shared": true
          },
          "adobe-analytics/src/lib/sharedModules/augmentTracker.js": {
            "name": "augment-tracker",
            "shared": true,
            "script": function(module, exports, require, turbine) {

              'use strict';

              var augmenters = require('../helpers/augmenters');

              module.exports = function(fn) {
                augmenters.push(fn);
              };

            }

          },
          "adobe-analytics/src/lib/helpers/applyTrackerVariables.js": {
            "script": function(module, exports, require, turbine) {

              'use strict';

              var queryString = require('@adobe/reactor-query-string');
              var window = require('@adobe/reactor-window');

              var eVarRegExp = /eVar([0-9]+)/;
              var propRegExp = /prop([0-9]+)/;
              var linkTrackVarsKeys = new RegExp('^(eVar[0-9]+)|(prop[0-9]+)|(hier[0-9]+)|campaign|purchaseID|' +
                'channel|server|state|zip|pageType$');

              var onlyUnique = function(value, index, self) {
                return self.indexOf(value) === index;
              };

              var buildLinkTrackVars = function(tracker, newTrackerProperties, addEvents) {
                var linkTrackVarsValues = Object.keys(newTrackerProperties)
                .filter(linkTrackVarsKeys.test.bind(linkTrackVarsKeys));

                if (addEvents) {
                  linkTrackVarsValues.push('events');
                }

                linkTrackVarsValues = linkTrackVarsValues.concat((tracker.linkTrackVars || '').split(','));

                return linkTrackVarsValues.filter(function(value, index) {
                  return value !== 'None' && value && onlyUnique(value, index, linkTrackVarsValues);
                }).join(',');
              };

              var buildLinkTrackEvents = function(tracker, eventsData) {
                var linkTrackEventsValues = eventsData.map(function(event) {
                  return event.name;
                });

                linkTrackEventsValues = linkTrackEventsValues.concat((tracker.linkTrackEvents || '').split(','));

                return linkTrackEventsValues.filter(function(value, index) {
                  return value !== 'None'  && onlyUnique(value, index, linkTrackEventsValues);
                }).join(',');
              };

              var commaJoin = function(store, keyName, trackerProperties) {
                store[keyName] = trackerProperties[keyName].join(',');
              };

              var variablesTransform = function(store, keyName, trackerProperties) {
                var dynamicVariablePrefix = trackerProperties.dynamicVariablePrefix || 'D=';

                trackerProperties[keyName].forEach(function(variableData) {
                  var value;
                  if (variableData.type === 'value') {
                    value = variableData.value;
                  } else {
                    var eVarData = eVarRegExp.exec(variableData.value);

                    if (eVarData) {
                      value = dynamicVariablePrefix + 'v' + eVarData[1];
                    } else {
                      var propData = propRegExp.exec(variableData.value);

                      if (propData) {
                        value = dynamicVariablePrefix + 'c' + propData[1];
                      }
                    }
                  }

                  store[variableData.name] = value;
                });
              };

              var transformers = {
                linkDownloadFileTypes: commaJoin,
                linkExternalFilters: commaJoin,
                linkInternalFilters: commaJoin,
                hierarchies: function(store, keyName, trackerProperties) {
                  trackerProperties[keyName].forEach(function(hierarchyData) {
                    store[hierarchyData.name] = hierarchyData.sections.join(hierarchyData.delimiter);
                  });
                },
                props: variablesTransform,
                eVars: variablesTransform,
                campaign: function(store, keyName, trackerProperties) {
                  if (trackerProperties[keyName].type === 'queryParam') {
                    var queryParams = queryString.parse(window.location.search);
                    store[keyName] = queryParams[trackerProperties[keyName].value];
                  } else {
                    store[keyName] = trackerProperties[keyName].value;
                  }
                },
                events: function(store, keyName, trackerProperties) {
                  var events = trackerProperties[keyName].map(function(data) {
                    var entry = data.name;
                    if (data.value) {
                      entry = [entry, data.value].join('=');
                    }
                    if (data.id) {
                      entry = [entry, data.id].join(':');
                    }
                    return entry;
                  });
                  store[keyName] = events.join(',');
                }
              };

              module.exports = function(tracker, trackerProperties) {
                var newProperties = {};
                trackerProperties = trackerProperties || {};

                Object.keys(trackerProperties).forEach(function(propertyName) {
                  var transform = transformers[propertyName];
                  var value = trackerProperties[propertyName];

                  if (transform) {
                    transform(newProperties, propertyName, trackerProperties);
                  } else {
                    newProperties[propertyName] = value;
                  }
                });

                if (newProperties.events) {
                  if (tracker.events && tracker.events.length > 0) {
                    newProperties.events = tracker.events + ',' + newProperties.events;
                  }
                }

                var hasEvents =
                  trackerProperties && trackerProperties.events && trackerProperties.events.length > 0;
                var linkTrackVars = buildLinkTrackVars(tracker, newProperties, hasEvents);
                if (linkTrackVars) {
                  newProperties.linkTrackVars = linkTrackVars;
                }

                var linkTrackEvents = buildLinkTrackEvents(tracker, trackerProperties.events || []);
                if (linkTrackEvents) {
                  newProperties.linkTrackEvents = linkTrackEvents;
                }

                turbine.logger.info(
                  'Applying the following properties on tracker: "' +
                  JSON.stringify(newProperties) +
                  '".'
                );

                Object.keys(newProperties).forEach(function(propertyName) {
                  tracker[propertyName] = newProperties[propertyName];
                });
              };

            }

          },
          "adobe-analytics/src/lib/helpers/augmenters.js": {
            "script": function(module, exports, require, turbine) {

              'use strict';

              module.exports = [];

            }

          },
          "adobe-analytics/src/lib/helpers/loadLibrary.js": {
            "script": function(module, exports, require, turbine) {

              'use strict';

              var loadScript = require('@adobe/reactor-load-script');
              var window = require('@adobe/reactor-window');
              var Promise = require('@adobe/reactor-promise');

              var LIB_TYPES = {
                MANAGED: 'managed',
                PREINSTALLED: 'preinstalled',
                REMOTE: 'remote',
                CUSTOM: 'custom'
              };

              var loadAppMeasurementScript = function(url) {
                turbine.logger.info('Loading AppMeasurement script from: ' + url + '.');
                return loadScript(url);
              };

              var getReportSuites = function(reportSuitesData) {
                var reportSuiteValues = reportSuitesData.production;
                if (reportSuitesData[turbine.buildInfo.environment]) {
                  reportSuiteValues = reportSuitesData[turbine.buildInfo.environment];
                }

                return reportSuiteValues.join(',');
              };

              var createTracker = function(settings, reportSuites) {
                if (!window.s_gi) {
                  throw new Error(
                    'Unable to create AppMeasurement tracker, `s_gi` function not found.' + window.AppMeasurement
                  );
                }
                turbine.logger.info('Creating AppMeasurement tracker with these report suites: "' +
                  reportSuites + '"');
                var tracker = window.s_gi(reportSuites);
                if (settings.libraryCode.scopeTrackerGlobally) {
                  turbine.logger.info('Setting the tracker as window.s');
                  window.s = tracker;
                }
                return tracker;
              };

              var loadManagedLibrary = function(settings) {
                var reportSuites = getReportSuites(settings.libraryCode.accounts);
                return loadAppMeasurementScript(turbine.getHostedLibFileUrl('AppMeasurement.js'))
                .then(createTracker.bind(null, settings, reportSuites));
              };

              var setReportSuitesOnTracker = function(settings, tracker) {
                if (settings.libraryCode.accounts) {
                  if (!tracker.sa) {
                    turbine.logger.warn('Cannot set report suites on tracker. `sa` method not available.');
                  } else {
                    var reportSuites = getReportSuites(settings.libraryCode.accounts);
                    turbine.logger.info('Setting the following report suites on the tracker: "' +
                      reportSuites + '"');
                    tracker.sa(reportSuites);
                  }
                }

                return tracker;
              };

              var poll = function(trackerVariableName) {
                turbine.logger.info('Waiting for the tracker to become accessible at: "' +
                  trackerVariableName + '".');
                return new Promise(function(resolve, reject) {
                  var i = 1;
                  var intervalId = setInterval(function() {
                    if (window[trackerVariableName]) {
                      turbine.logger.info('Found tracker located at: "' + trackerVariableName + '".');
                      resolve(window[trackerVariableName]);
                      clearInterval(intervalId);
                    }

                    if (i >= 10) {
                      clearInterval(intervalId);
                      reject(new Error(
                        'Bailing out. Cannot find the global variable name: "' + trackerVariableName + '".'
                      ));
                    }

                    i++;
                  }, 1000);
                });
              };

              var detectPreinstalledLibrary = function(settings) {
                return poll(settings.libraryCode.trackerVariableName)
                .then(setReportSuitesOnTracker.bind(null, settings));
              };

              var getTrackerFromVariable = function(trackerVariableName) {
                if (window[trackerVariableName]) {
                  turbine.logger.info('Found tracker located at: "' + trackerVariableName + '".');
                  return window[trackerVariableName];
                } else {
                  throw new Error('Cannot find the global variable name: "' + trackerVariableName + '".');
                }
              };

              var loadRemoteLibrary = function(url, settings) {
                return loadAppMeasurementScript(url)
                .then(getTrackerFromVariable.bind(null, settings.libraryCode.trackerVariableName))
                .then(setReportSuitesOnTracker.bind(null, settings));
              };

              module.exports = function(settings) {
                var url;
                var libraryPromise;

                switch (settings.libraryCode.type) {
                  case LIB_TYPES.MANAGED:
                    libraryPromise = loadManagedLibrary(settings);
                    break;

                  case LIB_TYPES.PREINSTALLED:
                    libraryPromise = detectPreinstalledLibrary(settings);
                    break;

                  case LIB_TYPES.CUSTOM:
                    url = settings.libraryCode.source;

                    libraryPromise = loadRemoteLibrary(url, settings);
                    break;

                  case LIB_TYPES.REMOTE:
                    url = window.location.protocol === 'https:' ?
                      settings.libraryCode.httpsUrl : settings.libraryCode.httpUrl;

                    libraryPromise = loadRemoteLibrary(url, settings);
                    break;

                  default:
                    throw new Error('Cannot load library. Type not supported.');
                }

                return libraryPromise;
              };

            }

          },
          "adobe-analytics/src/lib/helpers/generateVersion.js": {
            "script": function(module, exports, require, turbine) {


              'use strict';

              var THIRD_OF_DAY = 8; 

              var getDayField = function(date) {
                return date.getUTCDate().toString(36);
              };

              var getLastChar = function(str) {
                return str.substr(str.length - 1);
              };

              var getRevision = function(date) {
                return Math.floor(date.getUTCHours() / THIRD_OF_DAY);
              };

              var getMonthField = function(date) {
                var monthNumber = date.getUTCMonth() + 1;
                var revision = getRevision(date);

                var monthField = (monthNumber + revision * 12).toString(36);

                return getLastChar(monthField);
              };

              var getYearField = function(date) {
                return (date.getUTCFullYear() - 2010).toString(36);
              };

              module.exports = function(dateString) {
                var date = new Date(dateString);

                if (isNaN(date)) {
                  throw new Error('Invalid date provided');
                }

                return ('L' + getYearField(date) + getMonthField(date) + getDayField(date)).toUpperCase();
              };

            }

          }
        },
        "settings": {
          "orgId": "315F75E95BFC0EE50A495C73@AdobeOrg",
          "customSetup": {
            "source": function(s) {
              s.usePlugins=true;
              s.trackInlineStats=false;

              function s_doPlugins(s) {
                var sysEnv = _satellite.getVar("content: system enviorment");
                if(sysEnv != ""){
                  s.eVar5 = sysEnv;
                }

                if ((s.linkType == "o") || (s.linkType == "d") || (s.linkType == "e")){
                  s.linkTrackVars= s.linkTrackVars+",prop6,eVar5,eVar39,events";
                }else{
                  s.prop2=s.getPreviousValue(s.pageName,'gpv','');
                  if(s.prop2=="")
                    s.prop2="First page"
                }

                s.campaign = s.Util.getQueryParam("cid");
                var isUTM = s.Util.getQueryParam("utm_source");

                s.eVar39 = _satellite.getVisitorId().getMarketingCloudVisitorID();

                _satellite.logger.log("utm source: "+isUTM);

                if (!s.campaign && isUTM){
                  var gaUTM=[];
                  gaUTM.push(s.Util.getQueryParam('utm_source'));
                  gaUTM.push(s.Util.getQueryParam('utm_medium'));

                  if (s.Util.getQueryParam('utm_campaign') != "") {
                    gaUTM.push(s.Util.getQueryParam('utm_campaign'));
                  } else {
                    gaUTM.push("na");
                  }
                  if (s.Util.getQueryParam('utm_term') != "") {
                    gaUTM.push(s.Util.getQueryParam('utm_term'));
                  } else {
                    gaUTM.push("na");
                  }
                  if (s.Util.getQueryParam('utm_content') != "") {
                    gaUTM.push(s.Util.getQueryParam('utm_content'));
                  } else {
                    gaUTM.push("na");
                  }
                  gaUTM.push('(ga-utm)');
                  s.campaign = gaUTM.join(":");
                }


                try{
                  s.prop6 = _satellite.getVar("content: site");
                  var locData = localStorage.getItem("promoList");
                  if(locData && locData !=""){
                    locData = JSON.parse(locData);
                    var promoStr = "";
                    for(i=0;i < locData.length;i++){
                      promoStr += locData[i].componentID + ",";
                    }
                    promoStr = promoStr.substring(0,promoStr.length-1);
                    s.list1=promoStr;
                    s.linkTrackVars+="list1";
                    s.events = s.apl(s.events,"event1",",",2);
                    s.linkTrackEvents = s.apl(s.linkTrackEvents,"event1",",",2);
                    localStorage.removeItem("promoList");
                  }
                }catch(e){}


              }

              s.doPlugins=s_doPlugins

              s.getPreviousValue=new Function("v","c","el",""
                +"var s=this,t=new Date,i,j,r='';t.setTime(t.getTime()+1800000);if(el"
                +"){if(s.events){i=s.split(el,',');j=s.split(s.events,',');for(x in i"
                +"){for(y in j){if(i[x]==j[y]){if(s.c_r(c)) r=s.c_r(c);v?s.c_w(c,v,t)"
                +":s.c_w(c,'no value',t);return r}}}}}else{if(s.c_r(c)) r=s.c_r(c);v?"
                +"s.c_w(c,v,t):s.c_w(c,'no value',t);return r}");

              s.apl=new Function("l","v","d","u",""
                +"var s=this,m=0;if(!l)l='';if(u){var i,n,a=s.split(l,d);for(i=0;i<a."
                +"length;i++){n=a[i];m=m||(u==1?(n==v):(n.toLowerCase()==v.toLowerCas"
                +"e()));}}if(!m)l=l?l+d+v:v;return l");

              s.split=new Function("l","d",""
                +"var i,x=0,a=new Array;while(l){i=l.indexOf(d);i=i>-1?i:l.length;a[x"
                +"++]=l.substring(0,i);l=l.substring(i+d.length);}return a");



            }
          },
          "libraryCode": {
            "type": "custom",
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/4bc19535e626/448aad890223/EX0f26066879f44bd1b87f0d5041958376-libraryCode_source.js',
            "company": "svensk8",
            "accounts": {
              "staging": [
                "%Analytics Account%"
              ],
              "production": [
                "%Analytics Account%"
              ],
              "development": [
                "%Analytics Account%"
              ]
            },
            "trackerVariableName": "s"
          },
          "moduleProperties": {
            "audienceManager": {
              "config": {
                "partner": "svenskaspelsportcasino"
              }
            }
          },
          "trackerProperties": {
            "currencyCode": "SEK",
            "trackingServer": "svenskaspelsportcasino.sc.omtrdc.net",
            "trackInlineStats": false,
            "visitorNamespace": "spela.svenskaspel.se",
            "trackDownloadLinks": false,
            "trackExternalLinks": false,
            "trackingServerSecure": "svenskaspelsportcasino.sc.omtrdc.net"
          }
        },
        "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EP5e9ec493dfa0465eaa797b523b09d3f7/"
      },
      "adobe-mcid": {
        "displayName": "Experience Cloud ID Service",
        "modules": {
          "adobe-mcid/src/lib/actions/setCustomerIds.js": {
            "name": "set-customer-ids",
            "displayName": "Set Customer IDs",
            "script": function(module, exports, require, turbine) {
              'use strict';

              var mcidInstance = require('../sharedModules/mcidInstance');
              var logger = turbine.logger;

              var isPopulatedString = function(val) {
                return typeof val === 'string' && val.length > 0;
              };

              var formatForMcid = function(customerIds) {
                var formatted = {};
                var rejected = [];

                customerIds.forEach(function(customerId) {
                  var integrationCode = customerId.integrationCode;
                  var value = customerId.value;

                  if (isPopulatedString(integrationCode) && isPopulatedString(value)) {
                    formatted[integrationCode] = {
                      id: value
                    };

                    if (customerId.hasOwnProperty('authState')) {
                      formatted[customerId.integrationCode].authState = customerId.authState;
                    }

                    if (customerId.hasOwnProperty('hashType')) {
                      formatted[customerId.integrationCode].hashType = customerId.hashType;
                    }
                  } else {
                    rejected.push(customerId);
                  }
                });

                if (rejected.length) {
                  logger.warn('Rejected these customer ids: ' + JSON.stringify(rejected));
                }

                return formatted;
              };

              module.exports = function(settings) {
                if (!mcidInstance) {
                  logger.warn('MCID instance cannot be found. Cannot set Customer IDs.');
                  return;
                }

                var customerIds = formatForMcid(settings.customerIds);
                mcidInstance.setCustomerIDs(customerIds);
                logger.info('Set Customer IDs: ' + JSON.stringify(customerIds));
              };

            }

          },
          "adobe-mcid/src/lib/sharedModules/mcidInstance.js": {
            "script": function(module, exports, require, turbine) {

              'use strict';
              var document = require('@adobe/reactor-document');
              var VisitorAPI = require('../codeLibrary/VisitorAPI');
              var timeUnits = require('../../view/utils/timeUnits');

              var transformArrayToObject = function(configs) {
                var initConfig = configs.reduce(function(obj, config) {
                  var value = /^(true|false)$/i.test(config.value) ? JSON.parse(config.value) : config.value;

                  obj[config.name] = value;

                  return obj;
                }, {});

                return initConfig;
              };

              var initializeVisitorId = function(Visitor) {
                var extensionSettings = turbine.getExtensionSettings();
                if (typeof extensionSettings.orgId !== 'string') {
                  throw new TypeError('Org ID is not a string.');
                }

                var initConfig = transformArrayToObject(extensionSettings.variables || []);
                var doesOptInApply = extensionSettings.doesOptInApply;
                if (doesOptInApply) {
                  if (typeof doesOptInApply === 'boolean') {
                    initConfig['doesOptInApply'] = doesOptInApply;
                  } else if (extensionSettings.optInCallback) {
                    initConfig['doesOptInApply'] = extensionSettings.optInCallback;
                  }
                }

                var isOptInStorageEnabled = extensionSettings.isOptInStorageEnabled;
                if (isOptInStorageEnabled) {
                  initConfig['isOptInStorageEnabled'] = isOptInStorageEnabled;
                }

                var optInCookieDomain = extensionSettings.optInCookieDomain;
                if (optInCookieDomain) {
                  initConfig['optInCookieDomain'] = optInCookieDomain;
                }

                var optInStorageExpiry = extensionSettings.optInStorageExpiry;
                if (optInStorageExpiry) {
                  var timeUnit = extensionSettings.timeUnit;
                  if (timeUnit && timeUnits[timeUnit]) {
                    var seconds = optInStorageExpiry * timeUnits[timeUnit];
                    initConfig['optInStorageExpiry'] = seconds;
                  }
                } else if (isOptInStorageEnabled === true) {
                  initConfig['optInStorageExpiry'] = 13 * 30 * 24 * 3600;
                }

                var previousPermissions = extensionSettings.previousPermissions;
                if (previousPermissions) {
                  initConfig['previousPermissions'] = previousPermissions;
                }

                var preOptInApprovals = extensionSettings.preOptInApprovals;
                if (preOptInApprovals) {
                  initConfig['preOptInApprovals'] = preOptInApprovals;
                } else {
                  var preOptInApprovalInput = extensionSettings.preOptInApprovalInput;
                  if (preOptInApprovalInput) {
                    initConfig['preOptInApprovals'] = preOptInApprovalInput;
                  }
                }

                var isIabContext = extensionSettings.isIabContext;
                if (isIabContext) {
                  initConfig['isIabContext'] = isIabContext;
                }

                var instance = Visitor.getInstance(extensionSettings.orgId, initConfig);

                turbine.logger.info('Created instance using orgId: "' + extensionSettings.orgId + '"');
                turbine.logger.info('Set variables: ' + JSON.stringify(initConfig));

                instance.getMarketingCloudVisitorID(function(id) {
                  turbine.logger.info('Obtained Marketing Cloud Visitor Id: ' + id);
                }, true);

                return instance;
              };

              var excludePathsMatched = function(path) {
                var extensionSettings = turbine.getExtensionSettings();
                var pathExclusions = extensionSettings.pathExclusions || [];

                return pathExclusions.some(function(pathExclusion) {
                  if (pathExclusion.valueIsRegex) {
                    return new RegExp(pathExclusion.value, 'i').test(path);
                  } else {
                    return pathExclusion.value === path;
                  }
                });
              };

              var visitorIdInstance = null;

              _satellite.getVisitorId = function() { return visitorIdInstance; };

              if (excludePathsMatched(document.location.pathname)) {
                turbine.logger.warn('MCID library not loaded. One of the path exclusions matches the ' +
                  'current path.');
              } else {
                visitorIdInstance = initializeVisitorId(VisitorAPI);
              }

              module.exports = visitorIdInstance;

            }
            ,
            "name": "mcid-instance",
            "shared": true
          },
          "adobe-mcid/src/lib/codeLibrary/VisitorAPI.js": {
            "script": function(module, exports, require, turbine) {
              module.exports = function() {
                var e=function(){"use strict";function e(t){return(e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(t)}function t(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function n(){return{callbacks:{},add:function(e,t){this.callbacks[e]=this.callbacks[e]||[];var n=this.callbacks[e].push(t)-1,i=this;return function(){i.callbacks[e].splice(n,1)}},execute:function(e,t){if(this.callbacks[e]){t=void 0===t?[]:t,t=t instanceof Array?t:[t];try{for(;this.callbacks[e].length;){var n=this.callbacks[e].shift();"function"==typeof n?n.apply(null,t):n instanceof Array&&n[1].apply(n[0],t)}delete this.callbacks[e]}catch(e){}}},executeAll:function(e,t){(t||e&&!j.isObjectEmpty(e))&&Object.keys(this.callbacks).forEach(function(t){var n=void 0!==e[t]?e[t]:"";this.execute(t,n)},this)},hasCallbacks:function(){return Boolean(Object.keys(this.callbacks).length)}}}function i(e,t,n){var i=null==e?void 0:e[t];return void 0===i?n:i}function r(e){for(var t=/^\d+$/,n=0,i=e.length;n<i;n++)if(!t.test(e[n]))return!1;return!0}function a(e,t){for(;e.length<t.length;)e.push("0");for(;t.length<e.length;)t.push("0")}function o(e,t){for(var n=0;n<e.length;n++){var i=parseInt(e[n],10),r=parseInt(t[n],10);if(i>r)return 1;if(r>i)return-1}return 0}function s(e,t){if(e===t)return 0;var n=e.toString().split("."),i=t.toString().split(".");return r(n.concat(i))?(a(n,i),o(n,i)):NaN}function l(e){return e===Object(e)&&0===Object.keys(e).length}function c(e){return"function"==typeof e||e instanceof Array&&e.length}function u(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){return!0};this.log=_e("log",e,t),this.warn=_e("warn",e,t),this.error=_e("error",e,t)}function d(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.isEnabled,n=e.cookieName,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=i.cookies;return t&&n&&r?{remove:function(){r.remove(n)},get:function(){var e=r.get(n),t={};try{t=JSON.parse(e)}catch(e){t={}}return t},set:function(e,t){t=t||{},r.set(n,JSON.stringify(e),{domain:t.optInCookieDomain||"",cookieLifetime:t.optInStorageExpiry||3419e4,expires:!0})}}:{get:Le,set:Le,remove:Le}}function f(e){this.name=this.constructor.name,this.message=e,"function"==typeof Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):this.stack=new Error(e).stack}function p(){function e(e,t){var n=De(e);return n.length?n.every(function(e){return!!t[e]}):Se(t)}function t(){M(b),O(ce.COMPLETE),_(h.status,h.permissions),m.set(h.permissions,{optInCookieDomain:l,optInStorageExpiry:c}),C.execute(xe)}function n(e){return function(n,i){if(!Ae(n))throw new Error("[OptIn] Invalid category(-ies). Please use the `OptIn.Categories` enum.");return O(ce.CHANGED),Object.assign(b,ye(De(n),e)),i||t(),h}}var i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=i.doesOptInApply,a=i.previousPermissions,o=i.preOptInApprovals,s=i.isOptInStorageEnabled,l=i.optInCookieDomain,c=i.optInStorageExpiry,u=i.isIabContext,f=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},p=f.cookies,g=Pe(a);Re(g,"Invalid `previousPermissions`!"),Re(o,"Invalid `preOptInApprovals`!");var m=d({isEnabled:!!s,cookieName:"adobeujs-optin"},{cookies:p}),h=this,_=le(h),C=ge(),I=Me(g),v=Me(o),D=m.get(),S={},A=function(e,t){return ke(e)||t&&ke(t)?ce.COMPLETE:ce.PENDING}(I,D),y=function(e,t,n){var i=ye(pe,!r);return r?Object.assign({},i,e,t,n):i}(v,I,D),b=be(y),O=function(e){return A=e},M=function(e){return y=e};h.deny=n(!1),h.approve=n(!0),h.denyAll=h.deny.bind(h,pe),h.approveAll=h.approve.bind(h,pe),h.isApproved=function(t){return e(t,h.permissions)},h.isPreApproved=function(t){return e(t,v)},h.fetchPermissions=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=t?h.on(ce.COMPLETE,e):Le;return!r||r&&h.isComplete||!!o?e(h.permissions):t||C.add(xe,function(){return e(h.permissions)}),n},h.complete=function(){h.status===ce.CHANGED&&t()},h.registerPlugin=function(e){if(!e||!e.name||"function"!=typeof e.onRegister)throw new Error(je);S[e.name]||(S[e.name]=e,e.onRegister.call(e,h))},h.execute=Ne(S),Object.defineProperties(h,{permissions:{get:function(){return y}},status:{get:function(){return A}},Categories:{get:function(){return ue}},doesOptInApply:{get:function(){return!!r}},isPending:{get:function(){return h.status===ce.PENDING}},isComplete:{get:function(){return h.status===ce.COMPLETE}},__plugins:{get:function(){return Object.keys(S)}},isIabContext:{get:function(){return u}}})}function g(e,t){function n(){r=null,e.call(e,new f("The call took longer than you wanted!"))}function i(){r&&(clearTimeout(r),e.apply(e,arguments))}if(void 0===t)return e;var r=setTimeout(n,t);return i}function m(){if(window.__cmp)return window.__cmp;var e=window;if(e===window.top)return void Ie.error("__cmp not found");for(var t;!t;){e=e.parent;try{e.frames.__cmpLocator&&(t=e)}catch(e){}if(e===window.top)break}if(!t)return void Ie.error("__cmp not found");var n={};return window.__cmp=function(e,i,r){var a=Math.random()+"",o={__cmpCall:{command:e,parameter:i,callId:a}};n[a]=r,t.postMessage(o,"*")},window.addEventListener("message",function(e){var t=e.data;if("string"==typeof t)try{t=JSON.parse(e.data)}catch(e){}if(t.__cmpReturn){var i=t.__cmpReturn;n[i.callId]&&(n[i.callId](i.returnValue,i.success),delete n[i.callId])}},!1),window.__cmp}function h(){var e=this;e.name="iabPlugin",e.version="0.0.1";var t=ge(),n={allConsentData:null},i=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return n[e]=t};e.fetchConsentData=function(e){var t=e.callback,n=e.timeout,i=g(t,n);r({callback:i})},e.isApproved=function(e){var t=e.callback,i=e.category,a=e.timeout;if(n.allConsentData)return t(null,s(i,n.allConsentData.vendorConsents,n.allConsentData.purposeConsents));var o=g(function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=n.vendorConsents,a=n.purposeConsents;t(e,s(i,r,a))},a);r({category:i,callback:o})},e.onRegister=function(t){var n=Object.keys(de),i=function(e){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=i.purposeConsents,a=i.gdprApplies,o=i.vendorConsents;!e&&a&&o&&r&&(n.forEach(function(e){var n=s(e,o,r);t[n?"approve":"deny"](e,!0)}),t.complete())};e.fetchConsentData({callback:i})};var r=function(e){var r=e.callback;if(n.allConsentData)return r(null,n.allConsentData);t.add("FETCH_CONSENT_DATA",r);var s={};o(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.purposeConsents,o=e.gdprApplies,l=e.vendorConsents;(arguments.length>1?arguments[1]:void 0)&&(s={purposeConsents:r,gdprApplies:o,vendorConsents:l},i("allConsentData",s)),a(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(arguments.length>1?arguments[1]:void 0)&&(s.consentString=e.consentData,i("allConsentData",s)),t.execute("FETCH_CONSENT_DATA",[null,n.allConsentData])})})},a=function(e){var t=m();t&&t("getConsentData",null,e)},o=function(e){var t=Fe(de),n=m();n&&n("getVendorConsents",t,e)},s=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},i=!!t[de[e]];return i&&function(){return fe[e].every(function(e){return n[e]})}()}}var _="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};Object.assign=Object.assign||function(e){for(var t,n,i=1;i<arguments.length;++i){n=arguments[i];for(t in n)Object.prototype.hasOwnProperty.call(n,t)&&(e[t]=n[t])}return e};var C,I,v={HANDSHAKE:"HANDSHAKE",GETSTATE:"GETSTATE",PARENTSTATE:"PARENTSTATE"},D={MCMID:"MCMID",MCAID:"MCAID",MCAAMB:"MCAAMB",MCAAMLH:"MCAAMLH",MCOPTOUT:"MCOPTOUT",CUSTOMERIDS:"CUSTOMERIDS"},S={MCMID:"getMarketingCloudVisitorID",MCAID:"getAnalyticsVisitorID",MCAAMB:"getAudienceManagerBlob",MCAAMLH:"getAudienceManagerLocationHint",MCOPTOUT:"isOptedOut",ALLFIELDS:"getVisitorValues"},A={CUSTOMERIDS:"getCustomerIDs"},y={MCMID:"getMarketingCloudVisitorID",MCAAMB:"getAudienceManagerBlob",MCAAMLH:"getAudienceManagerLocationHint",MCOPTOUT:"isOptedOut",MCAID:"getAnalyticsVisitorID",CUSTOMERIDS:"getCustomerIDs",ALLFIELDS:"getVisitorValues"},b={MC:"MCMID",A:"MCAID",AAM:"MCAAMB"},O={MCMID:"MCMID",MCOPTOUT:"MCOPTOUT",MCAID:"MCAID",MCAAMLH:"MCAAMLH",MCAAMB:"MCAAMB"},M={UNKNOWN:0,AUTHENTICATED:1,LOGGED_OUT:2},k={GLOBAL:"global"},E={MESSAGES:v,STATE_KEYS_MAP:D,ASYNC_API_MAP:S,SYNC_API_MAP:A,ALL_APIS:y,FIELDGROUP_TO_FIELD:b,FIELDS:O,AUTH_STATE:M,OPT_OUT:k},T=E.STATE_KEYS_MAP,L=function(e){function t(){}function n(t,n){var i=this;return function(){var r=e(0,t),a={};return a[t]=r,i.setStateAndPublish(a),n(r),r}}this.getMarketingCloudVisitorID=function(e){e=e||t;var i=this.findField(T.MCMID,e),r=n.call(this,T.MCMID,e);return void 0!==i?i:r()},this.getVisitorValues=function(e){this.getMarketingCloudVisitorID(function(t){e({MCMID:t})})}},P=E.MESSAGES,R=E.ASYNC_API_MAP,w=E.SYNC_API_MAP,F=function(){function e(){}function t(e,t){var n=this;return function(){return n.callbackRegistry.add(e,t),n.messageParent(P.GETSTATE),""}}function n(n){this[R[n]]=function(i){i=i||e;var r=this.findField(n,i),a=t.call(this,n,i);return void 0!==r?r:a()}}function i(t){this[w[t]]=function(){return this.findField(t,e)||{}}}Object.keys(R).forEach(n,this),Object.keys(w).forEach(i,this)},N=E.ASYNC_API_MAP,x=function(){Object.keys(N).forEach(function(e){this[N[e]]=function(t){this.callbackRegistry.add(e,t)}},this)},j=function(e,t){return t={exports:{}},e(t,t.exports),t.exports}(function(t,n){n.isObjectEmpty=function(e){return e===Object(e)&&0===Object.keys(e).length},n.isValueEmpty=function(e){return""===e||n.isObjectEmpty(e)},n.getIeVersion=function(){if(document.documentMode)return document.documentMode;for(var e=7;e>4;e--){var t=document.createElement("div");if(t.innerHTML="\x3c!--[if IE "+e+"]><span></span><![endif]--\x3e",t.getElementsByTagName("span").length)return t=null,e;t=null}return null},n.encodeAndBuildRequest=function(e,t){return e.map(encodeURIComponent).join(t)},n.isObject=function(t){return null!==t&&"object"===e(t)&&!1===Array.isArray(t)},n.defineGlobalNamespace=function(){return window.adobe=n.isObject(window.adobe)?window.adobe:{},window.adobe},n.pluck=function(e,t){return t.reduce(function(t,n){return e[n]&&(t[n]=e[n]),t},Object.create(null))},n.parseOptOut=function(e,t,n){t||(t=n,e.d_optout&&e.d_optout instanceof Array&&(t=e.d_optout.join(",")));var i=parseInt(e.d_ottl,10);return isNaN(i)&&(i=7200),{optOut:t,d_ottl:i}},n.normalizeBoolean=function(e){var t=e;return"true"===e?t=!0:"false"===e&&(t=!1),t}}),V=(j.isObjectEmpty,j.isValueEmpty,j.getIeVersion,j.encodeAndBuildRequest,j.isObject,j.defineGlobalNamespace,j.pluck,j.parseOptOut,j.normalizeBoolean,n),U=E.MESSAGES,H={0:"prefix",1:"orgID",2:"state"},B=function(e,t){this.parse=function(e){try{var t={};return e.data.split("|").forEach(function(e,n){if(void 0!==e){t[H[n]]=2!==n?e:JSON.parse(e)}}),t}catch(e){}},this.isInvalid=function(n){var i=this.parse(n);if(!i||Object.keys(i).length<2)return!0;var r=e!==i.orgID,a=!t||n.origin!==t,o=-1===Object.keys(U).indexOf(i.prefix);return r||a||o},this.send=function(n,i,r){var a=i+"|"+e;r&&r===Object(r)&&(a+="|"+JSON.stringify(r));try{n.postMessage(a,t)}catch(e){}}},G=E.MESSAGES,Y=function(e,t,n,i){function r(e){Object.assign(p,e)}function a(e){Object.assign(p.state,e),Object.assign(p.state.ALLFIELDS,e),p.callbackRegistry.executeAll(p.state)}function o(e){if(!h.isInvalid(e)){m=!1;var t=h.parse(e);p.setStateAndPublish(t.state)}}function s(e){!m&&g&&(m=!0,h.send(i,e))}function l(){r(new L(n._generateID)),p.getMarketingCloudVisitorID(),p.callbackRegistry.executeAll(p.state,!0),_.removeEventListener("message",c)}function c(e){if(!h.isInvalid(e)){var t=h.parse(e);m=!1,_.clearTimeout(p._handshakeTimeout),_.removeEventListener("message",c),r(new F(p)),_.addEventListener("message",o),p.setStateAndPublish(t.state),p.callbackRegistry.hasCallbacks()&&s(G.GETSTATE)}}function u(){g&&postMessage?(_.addEventListener("message",c),s(G.HANDSHAKE),p._handshakeTimeout=setTimeout(l,250)):l()}function d(){_.s_c_in||(_.s_c_il=[],_.s_c_in=0),p._c="Visitor",p._il=_.s_c_il,p._in=_.s_c_in,p._il[p._in]=p,_.s_c_in++}function f(){function e(e){0!==e.indexOf("_")&&"function"==typeof n[e]&&(p[e]=function(){})}Object.keys(n).forEach(e),p.getSupplementalDataID=n.getSupplementalDataID,p.isAllowed=function(){return!0}}var p=this,g=t.whitelistParentDomain;p.state={ALLFIELDS:{}},p.version=n.version,p.marketingCloudOrgID=e,p.cookieDomain=n.cookieDomain||"",p._instanceType="child";var m=!1,h=new B(e,g);p.callbackRegistry=V(),p.init=function(){d(),f(),r(new x(p)),u()},p.findField=function(e,t){if(void 0!==p.state[e])return t(p.state[e]),p.state[e]},p.messageParent=s,p.setStateAndPublish=a},q=E.MESSAGES,X=E.ALL_APIS,W=E.ASYNC_API_MAP,J=E.FIELDGROUP_TO_FIELD,K=function(e,t){function n(){var t={};return Object.keys(X).forEach(function(n){var i=X[n],r=e[i]();j.isValueEmpty(r)||(t[n]=r)}),t}function i(){var t=[];return e._loading&&Object.keys(e._loading).forEach(function(n){if(e._loading[n]){var i=J[n];t.push(i)}}),t.length?t:null}function r(t){return function n(r){var a=i();if(a){var o=W[a[0]];e[o](n,!0)}else t()}}function a(e,i){var r=n();t.send(e,i,r)}function o(e){l(e),a(e,q.HANDSHAKE)}function s(e){r(function(){a(e,q.PARENTSTATE)})()}function l(n){function i(i){r.call(e,i),t.send(n,q.PARENTSTATE,{CUSTOMERIDS:e.getCustomerIDs()})}var r=e.setCustomerIDs;e.setCustomerIDs=i}return function(e){if(!t.isInvalid(e)){(t.parse(e).prefix===q.HANDSHAKE?o:s)(e.source)}}},z=function(e,t){function n(e){return function(n){i[e]=n,r++,r===a&&t(i)}}var i={},r=0,a=Object.keys(e).length;Object.keys(e).forEach(function(t){var i=e[t];if(i.fn){var r=i.args||[];r.unshift(n(t)),i.fn.apply(i.context||null,r)}})},Q={get:function(e){e=encodeURIComponent(e);var t=(";"+document.cookie).split(" ").join(";"),n=t.indexOf(";"+e+"="),i=n<0?n:t.indexOf(";",n+1);return n<0?"":decodeURIComponent(t.substring(n+2+e.length,i<0?t.length:i))},set:function(e,t,n){var r=i(n,"cookieLifetime"),a=i(n,"expires"),o=i(n,"domain"),s=i(n,"secure"),l=s?"Secure":"";if(a&&"SESSION"!==r&&"NONE"!==r){var c=""!==t?parseInt(r||0,10):-60;if(c)a=new Date,a.setTime(a.getTime()+1e3*c);else if(1===a){a=new Date;var u=a.getYear();a.setYear(u+2+(u<1900?1900:0))}}else a=0;return e&&"NONE"!==r?(document.cookie=encodeURIComponent(e)+"="+encodeURIComponent(t)+"; path=/;"+(a?" expires="+a.toGMTString()+";":"")+(o?" domain="+o+";":"")+l,this.get(e)===t):0},remove:function(e,t){var n=i(t,"domain");n=n?" domain="+n+";":"",document.cookie=encodeURIComponent(e)+"=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"+n}},$=function(e){var t;!e&&_.location&&(e=_.location.hostname),t=e;var n,i=t.split(".");for(n=i.length-2;n>=0;n--)if(t=i.slice(n).join("."),Q.set("test","cookie",{domain:t}))return Q.remove("test",{domain:t}),t;return""},Z={compare:s,isLessThan:function(e,t){return s(e,t)<0},areVersionsDifferent:function(e,t){return 0!==s(e,t)},isGreaterThan:function(e,t){return s(e,t)>0},isEqual:function(e,t){return 0===s(e,t)}},ee=!!_.postMessage,te={postMessage:function(e,t,n){var i=1;t&&(ee?n.postMessage(e,t.replace(/([^:]+:\/\/[^\/]+).*/,"$1")):t&&(n.location=t.replace(/#.*$/,"")+"#"+ +new Date+i+++"&"+e))},receiveMessage:function(e,t){var n;try{ee&&(e&&(n=function(n){if("string"==typeof t&&n.origin!==t||"[object Function]"===Object.prototype.toString.call(t)&&!1===t(n.origin))return!1;e(n)}),_.addEventListener?_[e?"addEventListener":"removeEventListener"]("message",n):_[e?"attachEvent":"detachEvent"]("onmessage",n))}catch(e){}}},ne=function(e){var t,n,i="0123456789",r="",a="",o=8,s=10,l=10;if(1==e){for(i+="ABCDEF",t=0;16>t;t++)n=Math.floor(Math.random()*o),r+=i.substring(n,n+1),n=Math.floor(Math.random()*o),a+=i.substring(n,n+1),o=16;return r+"-"+a}for(t=0;19>t;t++)n=Math.floor(Math.random()*s),r+=i.substring(n,n+1),0===t&&9==n?s=3:(1==t||2==t)&&10!=s&&2>n?s=10:2<t&&(s=10),n=Math.floor(Math.random()*l),a+=i.substring(n,n+1),0===t&&9==n?l=3:(1==t||2==t)&&10!=l&&2>n?l=10:2<t&&(l=10);return r+a},ie=function(e,t){return{corsMetadata:function(){var e="none",t=!0;return"undefined"!=typeof XMLHttpRequest&&XMLHttpRequest===Object(XMLHttpRequest)&&("withCredentials"in new XMLHttpRequest?e="XMLHttpRequest":"undefined"!=typeof XDomainRequest&&XDomainRequest===Object(XDomainRequest)&&(t=!1),Object.prototype.toString.call(_.HTMLElement).indexOf("Constructor")>0&&(t=!1)),{corsType:e,corsCookiesEnabled:t}}(),getCORSInstance:function(){return"none"===this.corsMetadata.corsType?null:new _[this.corsMetadata.corsType]},fireCORS:function(t,n,i){function r(e){var n;try{if((n=JSON.parse(e))!==Object(n))return void a.handleCORSError(t,null,"Response is not JSON")}catch(e){return void a.handleCORSError(t,e,"Error parsing response as JSON")}try{for(var i=t.callback,r=_,o=0;o<i.length;o++)r=r[i[o]];r(n)}catch(e){a.handleCORSError(t,e,"Error forming callback function")}}var a=this;n&&(t.loadErrorHandler=n);try{var o=this.getCORSInstance();o.open("get",t.corsUrl+"&ts="+(new Date).getTime(),!0),"XMLHttpRequest"===this.corsMetadata.corsType&&(o.withCredentials=!0,o.timeout=e.loadTimeout,o.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),o.onreadystatechange=function(){4===this.readyState&&200===this.status&&r(this.responseText)}),o.onerror=function(e){a.handleCORSError(t,e,"onerror")},o.ontimeout=function(e){a.handleCORSError(t,e,"ontimeout")},o.send(),e._log.requests.push(t.corsUrl)}catch(e){this.handleCORSError(t,e,"try-catch")}},handleCORSError:function(t,n,i){e.CORSErrors.push({corsData:t,error:n,description:i}),t.loadErrorHandler&&("ontimeout"===i?t.loadErrorHandler(!0):t.loadErrorHandler(!1))}}},re={POST_MESSAGE_ENABLED:!!_.postMessage,DAYS_BETWEEN_SYNC_ID_CALLS:1,MILLIS_PER_DAY:864e5,ADOBE_MC:"adobe_mc",ADOBE_MC_SDID:"adobe_mc_sdid",VALID_VISITOR_ID_REGEX:/^[0-9a-fA-F\-]+$/,ADOBE_MC_TTL_IN_MIN:5,VERSION_REGEX:/vVersion\|((\d+\.)?(\d+\.)?(\*|\d+))(?=$|\|)/,FIRST_PARTY_SERVER_COOKIE:"s_ecid"},ae=function(e,t){var n=_.document;return{THROTTLE_START:3e4,MAX_SYNCS_LENGTH:649,throttleTimerSet:!1,id:null,onPagePixels:[],iframeHost:null,getIframeHost:function(e){if("string"==typeof e){var t=e.split("/");return t[0]+"//"+t[2]}},subdomain:null,url:null,getUrl:function(){var t,i="http://fast.",r="?d_nsid="+e.idSyncContainerID+"#"+encodeURIComponent(n.location.origin);return this.subdomain||(this.subdomain="nosubdomainreturned"),e.loadSSL&&(i=e.idSyncSSLUseAkamai?"https://fast.":"https://"),t=i+this.subdomain+".demdex.net/dest5.html"+r,this.iframeHost=this.getIframeHost(t),this.id="destination_publishing_iframe_"+this.subdomain+"_"+e.idSyncContainerID,t},checkDPIframeSrc:function(){var t="?d_nsid="+e.idSyncContainerID+"#"+encodeURIComponent(n.location.href);"string"==typeof e.dpIframeSrc&&e.dpIframeSrc.length&&(this.id="destination_publishing_iframe_"+(e._subdomain||this.subdomain||(new Date).getTime())+"_"+e.idSyncContainerID,this.iframeHost=this.getIframeHost(e.dpIframeSrc),this.url=e.dpIframeSrc+t)},idCallNotProcesssed:null,doAttachIframe:!1,startedAttachingIframe:!1,iframeHasLoaded:null,iframeIdChanged:null,newIframeCreated:null,originalIframeHasLoadedAlready:null,iframeLoadedCallbacks:[],regionChanged:!1,timesRegionChanged:0,sendingMessages:!1,messages:[],messagesPosted:[],messagesReceived:[],messageSendingInterval:re.POST_MESSAGE_ENABLED?null:100,onPageDestinationsFired:[],jsonForComparison:[],jsonDuplicates:[],jsonWaiting:[],jsonProcessed:[],canSetThirdPartyCookies:!0,receivedThirdPartyCookiesNotification:!1,readyToAttachIframePreliminary:function(){return!(e.idSyncDisableSyncs||e.disableIdSyncs||e.idSyncDisable3rdPartySyncing||e.disableThirdPartyCookies||e.disableThirdPartyCalls)},readyToAttachIframe:function(){return this.readyToAttachIframePreliminary()&&(this.doAttachIframe||e._doAttachIframe)&&(this.subdomain&&"nosubdomainreturned"!==this.subdomain||e._subdomain)&&this.url&&!this.startedAttachingIframe},attachIframe:function(){function e(){r=n.createElement("iframe"),r.sandbox="allow-scripts allow-same-origin",r.title="Adobe ID Syncing iFrame",r.id=i.id,r.name=i.id+"_name",r.style.cssText="display: none; width: 0; height: 0;",r.src=i.url,i.newIframeCreated=!0,t(),n.body.appendChild(r)}function t(e){r.addEventListener("load",function(){r.className="aamIframeLoaded",i.iframeHasLoaded=!0,i.fireIframeLoadedCallbacks(e),i.requestToProcess()})}this.startedAttachingIframe=!0;var i=this,r=n.getElementById(this.id);r?"IFRAME"!==r.nodeName?(this.id+="_2",this.iframeIdChanged=!0,e()):(this.newIframeCreated=!1,"aamIframeLoaded"!==r.className?(this.originalIframeHasLoadedAlready=!1,t("The destination publishing iframe already exists from a different library, but hadn't loaded yet.")):(this.originalIframeHasLoadedAlready=!0,this.iframeHasLoaded=!0,this.iframe=r,this.fireIframeLoadedCallbacks("The destination publishing iframe already exists from a different library, and had loaded alresady."),this.requestToProcess())):e(),this.iframe=r},fireIframeLoadedCallbacks:function(e){this.iframeLoadedCallbacks.forEach(function(t){"function"==typeof t&&t({message:e||"The destination publishing iframe was attached and loaded successfully."})}),this.iframeLoadedCallbacks=[]},requestToProcess:function(t){function n(){r.jsonForComparison.push(t),r.jsonWaiting.push(t),r.processSyncOnPage(t)}var i,r=this;if(t===Object(t)&&t.ibs)if(i=JSON.stringify(t.ibs||[]),this.jsonForComparison.length){var a,o,s,l=!1;for(a=0,o=this.jsonForComparison.length;a<o;a++)if(s=this.jsonForComparison[a],i===JSON.stringify(s.ibs||[])){l=!0;break}l?this.jsonDuplicates.push(t):n()}else n();if((this.receivedThirdPartyCookiesNotification||!re.POST_MESSAGE_ENABLED||this.iframeHasLoaded)&&this.jsonWaiting.length){var c=this.jsonWaiting.shift();this.process(c),this.requestToProcess()}e.idSyncDisableSyncs||e.disableIdSyncs||!this.iframeHasLoaded||!this.messages.length||this.sendingMessages||(this.throttleTimerSet||(this.throttleTimerSet=!0,setTimeout(function(){r.messageSendingInterval=re.POST_MESSAGE_ENABLED?null:150},this.THROTTLE_START)),this.sendingMessages=!0,this.sendMessages())},getRegionAndCheckIfChanged:function(t,n){var i=e._getField("MCAAMLH"),r=t.d_region||t.dcs_region;return i?r&&(e._setFieldExpire("MCAAMLH",n),e._setField("MCAAMLH",r),parseInt(i,10)!==r&&(this.regionChanged=!0,this.timesRegionChanged++,e._setField("MCSYNCSOP",""),e._setField("MCSYNCS",""),i=r)):(i=r)&&(e._setFieldExpire("MCAAMLH",n),e._setField("MCAAMLH",i)),i||(i=""),i},processSyncOnPage:function(e){var t,n,i,r;if((t=e.ibs)&&t instanceof Array&&(n=t.length))for(i=0;i<n;i++)r=t[i],r.syncOnPage&&this.checkFirstPartyCookie(r,"","syncOnPage")},process:function(e){var t,n,i,r,a,o=encodeURIComponent,s=!1;if((t=e.ibs)&&t instanceof Array&&(n=t.length))for(s=!0,i=0;i<n;i++)r=t[i],a=[o("ibs"),o(r.id||""),o(r.tag||""),j.encodeAndBuildRequest(r.url||[],","),o(r.ttl||""),"","",r.fireURLSync?"true":"false"],r.syncOnPage||(this.canSetThirdPartyCookies?this.addMessage(a.join("|")):r.fireURLSync&&this.checkFirstPartyCookie(r,a.join("|")));s&&this.jsonProcessed.push(e)},checkFirstPartyCookie:function(t,n,i){var r="syncOnPage"===i,a=r?"MCSYNCSOP":"MCSYNCS";e._readVisitor();var o,s,l=e._getField(a),c=!1,u=!1,d=Math.ceil((new Date).getTime()/re.MILLIS_PER_DAY);l?(o=l.split("*"),s=this.pruneSyncData(o,t.id,d),c=s.dataPresent,u=s.dataValid,c&&u||this.fireSync(r,t,n,o,a,d)):(o=[],this.fireSync(r,t,n,o,a,d))},pruneSyncData:function(e,t,n){var i,r,a,o=!1,s=!1;for(r=0;r<e.length;r++)i=e[r],a=parseInt(i.split("-")[1],10),i.match("^"+t+"-")?(o=!0,n<a?s=!0:(e.splice(r,1),r--)):n>=a&&(e.splice(r,1),r--);return{dataPresent:o,dataValid:s}},manageSyncsSize:function(e){if(e.join("*").length>this.MAX_SYNCS_LENGTH)for(e.sort(function(e,t){return parseInt(e.split("-")[1],10)-parseInt(t.split("-")[1],10)});e.join("*").length>this.MAX_SYNCS_LENGTH;)e.shift()},fireSync:function(t,n,i,r,a,o){var s=this;if(t){if("img"===n.tag){var l,c,u,d,f=n.url,p=e.loadSSL?"https:":"http:";for(l=0,c=f.length;l<c;l++){u=f[l],d=/^\/\//.test(u);var g=new Image;g.addEventListener("load",function(t,n,i,r){return function(){s.onPagePixels[t]=null,e._readVisitor();var o,l=e._getField(a),c=[];if(l){o=l.split("*");var u,d,f;for(u=0,d=o.length;u<d;u++)f=o[u],f.match("^"+n.id+"-")||c.push(f)}s.setSyncTrackingData(c,n,i,r)}}(this.onPagePixels.length,n,a,o)),g.src=(d?p:"")+u,this.onPagePixels.push(g)}}}else this.addMessage(i),this.setSyncTrackingData(r,n,a,o)},addMessage:function(t){var n=encodeURIComponent,i=n(e._enableErrorReporting?"---destpub-debug---":"---destpub---");this.messages.push((re.POST_MESSAGE_ENABLED?"":i)+t)},setSyncTrackingData:function(t,n,i,r){t.push(n.id+"-"+(r+Math.ceil(n.ttl/60/24))),this.manageSyncsSize(t),e._setField(i,t.join("*"))},sendMessages:function(){var e,t=this,n="",i=encodeURIComponent;this.regionChanged&&(n=i("---destpub-clear-dextp---"),this.regionChanged=!1),this.messages.length?re.POST_MESSAGE_ENABLED?(e=n+i("---destpub-combined---")+this.messages.join("%01"),this.postMessage(e),this.messages=[],this.sendingMessages=!1):(e=this.messages.shift(),this.postMessage(n+e),setTimeout(function(){t.sendMessages()},this.messageSendingInterval)):this.sendingMessages=!1},postMessage:function(e){te.postMessage(e,this.url,this.iframe.contentWindow),this.messagesPosted.push(e)},receiveMessage:function(e){var t,n=/^---destpub-to-parent---/;"string"==typeof e&&n.test(e)&&(t=e.replace(n,"").split("|"),"canSetThirdPartyCookies"===t[0]&&(this.canSetThirdPartyCookies="true"===t[1],this.receivedThirdPartyCookiesNotification=!0,this.requestToProcess()),this.messagesReceived.push(e))},processIDCallData:function(i){(null==this.url||i.subdomain&&"nosubdomainreturned"===this.subdomain)&&("string"==typeof e._subdomain&&e._subdomain.length?this.subdomain=e._subdomain:this.subdomain=i.subdomain||"",this.url=this.getUrl()),i.ibs instanceof Array&&i.ibs.length&&(this.doAttachIframe=!0),this.readyToAttachIframe()&&(e.idSyncAttachIframeOnWindowLoad?(t.windowLoaded||"complete"===n.readyState||"loaded"===n.readyState)&&this.attachIframe():this.attachIframeASAP()),"function"==typeof e.idSyncIDCallResult?e.idSyncIDCallResult(i):this.requestToProcess(i),"function"==typeof e.idSyncAfterIDCallResult&&e.idSyncAfterIDCallResult(i)},canMakeSyncIDCall:function(t,n){return e._forceSyncIDCall||!t||n-t>re.DAYS_BETWEEN_SYNC_ID_CALLS},attachIframeASAP:function(){function e(){t.startedAttachingIframe||(n.body?t.attachIframe():setTimeout(e,30))}var t=this;e()}}},oe={audienceManagerServer:{},audienceManagerServerSecure:{},cookieDomain:{},cookieLifetime:{},cookieName:{},doesOptInApply:{},disableThirdPartyCalls:{},discardTrackingServerECID:{},idSyncAfterIDCallResult:{},idSyncAttachIframeOnWindowLoad:{},idSyncContainerID:{},idSyncDisable3rdPartySyncing:{},disableThirdPartyCookies:{},idSyncDisableSyncs:{},disableIdSyncs:{},idSyncIDCallResult:{},idSyncSSLUseAkamai:{},isCoopSafe:{},isIabContext:{},isOptInStorageEnabled:{},loadSSL:{},loadTimeout:{},marketingCloudServer:{},marketingCloudServerSecure:{},optInCookieDomain:{},optInStorageExpiry:{},overwriteCrossDomainMCIDAndAID:{},preOptInApprovals:{},previousPermissions:{},resetBeforeVersion:{},sdidParamExpiry:{},serverState:{},sessionCookieName:{},secureCookie:{},takeTimeoutMetrics:{},trackingServer:{},trackingServerSecure:{},whitelistIframeDomains:{},whitelistParentDomain:{}},se={getConfigNames:function(){return Object.keys(oe)},getConfigs:function(){return oe},normalizeConfig:function(e){return"function"!=typeof e?e:e()}},le=function(e){var t={};return e.on=function(e,n,i){if(!n||"function"!=typeof n)throw new Error("[ON] Callback should be a function.");t.hasOwnProperty(e)||(t[e]=[]);var r=t[e].push({callback:n,context:i})-1;return function(){t[e].splice(r,1),t[e].length||delete t[e]}},e.off=function(e,n){t.hasOwnProperty(e)&&(t[e]=t[e].filter(function(e){if(e.callback!==n)return e}))},e.publish=function(e){if(t.hasOwnProperty(e)){var n=[].slice.call(arguments,1);t[e].slice(0).forEach(function(e){e.callback.apply(e.context,n)})}},e.publish},ce={PENDING:"pending",CHANGED:"changed",COMPLETE:"complete"},ue={AAM:"aam",ADCLOUD:"adcloud",ANALYTICS:"aa",CAMPAIGN:"campaign",ECID:"ecid",LIVEFYRE:"livefyre",TARGET:"target",VIDEO_ANALYTICS:"videoaa"},de=(C={},t(C,ue.AAM,565),t(C,ue.ECID,565),C),fe=(I={},t(I,ue.AAM,[1,2,5]),t(I,ue.ECID,[1,2,5]),I),pe=function(e){return Object.keys(e).map(function(t){return e[t]})}(ue),ge=function(){var e={};return e.callbacks=Object.create(null),e.add=function(t,n){if(!c(n))throw new Error("[callbackRegistryFactory] Make sure callback is a function or an array of functions.");e.callbacks[t]=e.callbacks[t]||[];var i=e.callbacks[t].push(n)-1;return function(){e.callbacks[t].splice(i,1)}},e.execute=function(t,n){if(e.callbacks[t]){n=void 0===n?[]:n,n=n instanceof Array?n:[n];try{for(;e.callbacks[t].length;){var i=e.callbacks[t].shift();"function"==typeof i?i.apply(null,n):i instanceof Array&&i[1].apply(i[0],n)}delete e.callbacks[t]}catch(e){}}},e.executeAll=function(t,n){(n||t&&!l(t))&&Object.keys(e.callbacks).forEach(function(n){var i=void 0!==t[n]?t[n]:"";e.execute(n,i)},e)},e.hasCallbacks=function(){return Boolean(Object.keys(e.callbacks).length)},e},me=function(){},he=function(e){var t=window,n=t.console;return!!n&&"function"==typeof n[e]},_e=function(e,t,n){return n()?function(){if(he(e)){for(var n=arguments.length,i=new Array(n),r=0;r<n;r++)i[r]=arguments[r];console[e].apply(console,[t].concat(i))}}:me},Ce=u,Ie=new Ce("[ADOBE OPT-IN]"),ve=function(t,n){return e(t)===n},De=function(e,t){return e instanceof Array?e:ve(e,"string")?[e]:t||[]},Se=function(e){var t=Object.keys(e);return!!t.length&&t.every(function(t){return!0===e[t]})},Ae=function(e){return!(!e||Oe(e))&&De(e).every(function(e){return pe.indexOf(e)>-1})},ye=function(e,t){return e.reduce(function(e,n){return e[n]=t,e},{})},be=function(e){return JSON.parse(JSON.stringify(e))},Oe=function(e){return"[object Array]"===Object.prototype.toString.call(e)&&!e.length},Me=function(e){if(Te(e))return e;try{return JSON.parse(e)}catch(e){return{}}},ke=function(e){return void 0===e||(Te(e)?Ae(Object.keys(e)):Ee(e))},Ee=function(e){try{var t=JSON.parse(e);return!!e&&ve(e,"string")&&Ae(Object.keys(t))}catch(e){return!1}},Te=function(e){return null!==e&&ve(e,"object")&&!1===Array.isArray(e)},Le=function(){},Pe=function(e){return ve(e,"function")?e():e},Re=function(e,t){ke(e)||Ie.error("".concat(t))},we=function(e){return Object.keys(e).map(function(t){return e[t]})},Fe=function(e){return we(e).filter(function(e,t,n){return n.indexOf(e)===t})},Ne=function(e){return function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=t.command,i=t.params,r=void 0===i?{}:i,a=t.callback,o=void 0===a?Le:a;if(!n||-1===n.indexOf("."))throw new Error("[OptIn.execute] Please provide a valid command.");try{var s=n.split("."),l=e[s[0]],c=s[1];if(!l||"function"!=typeof l[c])throw new Error("Make sure the plugin and API name exist.");var u=Object.assign(r,{callback:o});l[c].call(l,u)}catch(e){Ie.error("[execute] Something went wrong: "+e.message)}}};f.prototype=Object.create(Error.prototype),f.prototype.constructor=f;var xe="fetchPermissions",je="[OptIn#registerPlugin] Plugin is invalid.";p.Categories=ue,p.TimeoutError=f;var Ve=Object.freeze({OptIn:p,IabPlugin:h}),Ue=function(e,t){e.publishDestinations=function(n){var i=arguments[1],r=arguments[2];try{r="function"==typeof r?r:n.callback}catch(e){r=function(){}}var a=t;if(!a.readyToAttachIframePreliminary())return void r({error:"The destination publishing iframe is disabled in the Visitor library."});if("string"==typeof n){if(!n.length)return void r({error:"subdomain is not a populated string."});if(!(i instanceof Array&&i.length))return void r({error:"messages is not a populated array."});var o=!1;if(i.forEach(function(e){
                  "string"==typeof e&&e.length&&(a.addMessage(e),o=!0)}),!o)return void r({error:"None of the messages are populated strings."})}else{if(!j.isObject(n))return void r({error:"Invalid parameters passed."});var s=n;if("string"!=typeof(n=s.subdomain)||!n.length)return void r({error:"config.subdomain is not a populated string."});var l=s.urlDestinations;if(!(l instanceof Array&&l.length))return void r({error:"config.urlDestinations is not a populated array."});var c=[];l.forEach(function(e){j.isObject(e)&&(e.hideReferrer?e.message&&a.addMessage(e.message):c.push(e))});!function e(){c.length&&setTimeout(function(){var t=new Image,n=c.shift();t.src=n.url,a.onPageDestinationsFired.push(n),e()},100)}()}a.iframe?(r({message:"The destination publishing iframe is already attached and loaded."}),a.requestToProcess()):!e.subdomain&&e._getField("MCMID")?(a.subdomain=n,a.doAttachIframe=!0,a.url=a.getUrl(),a.readyToAttachIframe()?(a.iframeLoadedCallbacks.push(function(e){r({message:"Attempted to attach and load the destination publishing iframe through this API call. Result: "+(e.message||"no result")})}),a.attachIframe()):r({error:"Encountered a problem in attempting to attach and load the destination publishing iframe through this API call."})):a.iframeLoadedCallbacks.push(function(e){r({message:"Attempted to attach and load the destination publishing iframe through normal Visitor API processing. Result: "+(e.message||"no result")})})}},He=function e(t){function n(e,t){return e>>>t|e<<32-t}for(var i,r,a=Math.pow,o=a(2,32),s="",l=[],c=8*t.length,u=e.h=e.h||[],d=e.k=e.k||[],f=d.length,p={},g=2;f<64;g++)if(!p[g]){for(i=0;i<313;i+=g)p[i]=g;u[f]=a(g,.5)*o|0,d[f++]=a(g,1/3)*o|0}for(t+="Â€";t.length%64-56;)t+="\0";for(i=0;i<t.length;i++){if((r=t.charCodeAt(i))>>8)return;l[i>>2]|=r<<(3-i)%4*8}for(l[l.length]=c/o|0,l[l.length]=c,r=0;r<l.length;){var m=l.slice(r,r+=16),h=u;for(u=u.slice(0,8),i=0;i<64;i++){var _=m[i-15],C=m[i-2],I=u[0],v=u[4],D=u[7]+(n(v,6)^n(v,11)^n(v,25))+(v&u[5]^~v&u[6])+d[i]+(m[i]=i<16?m[i]:m[i-16]+(n(_,7)^n(_,18)^_>>>3)+m[i-7]+(n(C,17)^n(C,19)^C>>>10)|0);u=[D+((n(I,2)^n(I,13)^n(I,22))+(I&u[1]^I&u[2]^u[1]&u[2]))|0].concat(u),u[4]=u[4]+D|0}for(i=0;i<8;i++)u[i]=u[i]+h[i]|0}for(i=0;i<8;i++)for(r=3;r+1;r--){var S=u[i]>>8*r&255;s+=(S<16?0:"")+S.toString(16)}return s},Be=function(e,t){return"SHA-256"!==t&&"SHA256"!==t&&"sha256"!==t&&"sha-256"!==t||(e=He(e)),e},Ge=function(e){return String(e).trim().toLowerCase()},Ye=Ve.OptIn;j.defineGlobalNamespace(),window.adobe.OptInCategories=Ye.Categories;var qe=function(t,n,i){function r(e){var t=e;return function(e){var n=e||v.location.href;try{var i=g._extractParamFromUri(n,t);if(i)return F.parsePipeDelimetedKeyValues(i)}catch(e){}}}function a(e){function t(e,t,n){e&&e.match(re.VALID_VISITOR_ID_REGEX)&&(n===A&&(I=!0),t(e))}t(e[A],g.setMarketingCloudVisitorID,A),g._setFieldExpire(k,-1),t(e[O],g.setAnalyticsVisitorID)}function o(e){e=e||{},g._supplementalDataIDCurrent=e.supplementalDataIDCurrent||"",g._supplementalDataIDCurrentConsumed=e.supplementalDataIDCurrentConsumed||{},g._supplementalDataIDLast=e.supplementalDataIDLast||"",g._supplementalDataIDLastConsumed=e.supplementalDataIDLastConsumed||{}}function s(e){function t(e,t,n){return n=n?n+="|":n,n+=e+"="+encodeURIComponent(t)}function n(e,n){var i=n[0],r=n[1];return null!=r&&r!==T&&(e=t(i,r,e)),e}var i=e.reduce(n,"");return function(e){var t=F.getTimestampInSeconds();return e=e?e+="|":e,e+="TS="+t}(i)}function l(e){var t=e.minutesToLive,n="";return(g.idSyncDisableSyncs||g.disableIdSyncs)&&(n=n||"Error: id syncs have been disabled"),"string"==typeof e.dpid&&e.dpid.length||(n=n||"Error: config.dpid is empty"),"string"==typeof e.url&&e.url.length||(n=n||"Error: config.url is empty"),void 0===t?t=20160:(t=parseInt(t,10),(isNaN(t)||t<=0)&&(n=n||"Error: config.minutesToLive needs to be a positive number")),{error:n,ttl:t}}function c(){return!!g.configs.doesOptInApply&&!(m.optIn.isComplete&&u())}function u(){return g.configs.doesOptInApply&&g.configs.isIabContext?m.optIn.isApproved(m.optIn.Categories.ECID)&&C:m.optIn.isApproved(m.optIn.Categories.ECID)}function d(e,t){if(C=!0,e)throw new Error("[IAB plugin] : "+e);t.gdprApplies&&(h=t.consentString),g.init(),p()}function f(){m.optIn.isApproved(m.optIn.Categories.ECID)&&(g.configs.isIabContext?m.optIn.execute({command:"iabPlugin.fetchConsentData",callback:d}):(g.init(),p()))}function p(){m.optIn.off("complete",f)}if(!i||i.split("").reverse().join("")!==t)throw new Error("Please use `Visitor.getInstance` to instantiate Visitor.");var g=this,m=window.adobe,h="",C=!1,I=!1;g.version="4.5.1";var v=_,D=v.Visitor;D.version=g.version,D.AuthState=E.AUTH_STATE,D.OptOut=E.OPT_OUT,v.s_c_in||(v.s_c_il=[],v.s_c_in=0),g._c="Visitor",g._il=v.s_c_il,g._in=v.s_c_in,g._il[g._in]=g,v.s_c_in++,g._instanceType="regular",g._log={requests:[]},g.marketingCloudOrgID=t,g.cookieName="AMCV_"+t,g.sessionCookieName="AMCVS_"+t,g.cookieDomain=$(),g.loadSSL=v.location.protocol.toLowerCase().indexOf("https")>=0,g.loadTimeout=3e4,g.CORSErrors=[],g.marketingCloudServer=g.audienceManagerServer="dpm.demdex.net",g.sdidParamExpiry=30;var S=null,A="MCMID",y="MCIDTS",b="A",O="MCAID",M="AAM",k="MCAAMB",T="NONE",L=function(e){return!Object.prototype[e]},P=ie(g);g.FIELDS=E.FIELDS,g.cookieRead=function(e){return Q.get(e)},g.cookieWrite=function(e,t,n){var i=g.cookieLifetime?(""+g.cookieLifetime).toUpperCase():"",r=!1;return g.configs&&g.configs.secureCookie&&"https:"===location.protocol&&(r=!0),Q.set(e,""+t,{expires:n,domain:g.cookieDomain,cookieLifetime:i,secure:r})},g.resetState=function(e){e?g._mergeServerState(e):o()},g._isAllowedDone=!1,g._isAllowedFlag=!1,g.isAllowed=function(){return g._isAllowedDone||(g._isAllowedDone=!0,(g.cookieRead(g.cookieName)||g.cookieWrite(g.cookieName,"T",1))&&(g._isAllowedFlag=!0)),"T"===g.cookieRead(g.cookieName)&&g._helpers.removeCookie(g.cookieName),g._isAllowedFlag},g.setMarketingCloudVisitorID=function(e){g._setMarketingCloudFields(e)},g._use1stPartyMarketingCloudServer=!1,g.getMarketingCloudVisitorID=function(e,t){g.marketingCloudServer&&g.marketingCloudServer.indexOf(".demdex.net")<0&&(g._use1stPartyMarketingCloudServer=!0);var n=g._getAudienceManagerURLData("_setMarketingCloudFields"),i=n.url;return g._getRemoteField(A,i,e,t,n)};var R=function(e,t){var n={};g.getMarketingCloudVisitorID(function(){t.forEach(function(e){n[e]=g._getField(e,!0)}),-1!==t.indexOf("MCOPTOUT")?g.isOptedOut(function(t){n.MCOPTOUT=t,e(n)},null,!0):e(n)},!0)};g.getVisitorValues=function(e,t){var n={MCMID:{fn:g.getMarketingCloudVisitorID,args:[!0],context:g},MCOPTOUT:{fn:g.isOptedOut,args:[void 0,!0],context:g},MCAID:{fn:g.getAnalyticsVisitorID,args:[!0],context:g},MCAAMLH:{fn:g.getAudienceManagerLocationHint,args:[!0],context:g},MCAAMB:{fn:g.getAudienceManagerBlob,args:[!0],context:g}},i=t&&t.length?j.pluck(n,t):n;t&&-1===t.indexOf("MCAID")?R(e,t):z(i,e)},g._currentCustomerIDs={},g._customerIDsHashChanged=!1,g._newCustomerIDsHash="",g.setCustomerIDs=function(t,n){function i(){g._customerIDsHashChanged=!1}if(!g.isOptedOut()&&t){if(!j.isObject(t)||j.isObjectEmpty(t))return!1;g._readVisitor();var r,a,o;for(r in t)if(L(r)&&(a=t[r],n=a.hasOwnProperty("hashType")?a.hashType:n,a))if("object"===e(a)){var s={};if(a.id){if(n){if(!(o=Be(Ge(a.id),n)))return;a.id=o,s.hashType=n}s.id=a.id}void 0!=a.authState&&(s.authState=a.authState),g._currentCustomerIDs[r]=s}else if(n){if(!(o=Be(Ge(a),n)))return;g._currentCustomerIDs[r]={id:o,hashType:n}}else g._currentCustomerIDs[r]={id:a};var l=g.getCustomerIDs(),c=g._getField("MCCIDH"),u="";c||(c=0);for(r in l)L(r)&&(a=l[r],u+=(u?"|":"")+r+"|"+(a.id?a.id:"")+(a.authState?a.authState:""));g._newCustomerIDsHash=String(g._hash(u)),g._newCustomerIDsHash!==c&&(g._customerIDsHashChanged=!0,g._mapCustomerIDs(i))}},g.getCustomerIDs=function(){g._readVisitor();var e,t,n={};for(e in g._currentCustomerIDs)L(e)&&(t=g._currentCustomerIDs[e],t.id&&(n[e]||(n[e]={}),n[e].id=t.id,void 0!=t.authState?n[e].authState=t.authState:n[e].authState=D.AuthState.UNKNOWN,t.hashType&&(n[e].hashType=t.hashType)));return n},g.setAnalyticsVisitorID=function(e){g._setAnalyticsFields(e)},g.getAnalyticsVisitorID=function(e,t,n){if(!F.isTrackingServerPopulated()&&!n)return g._callCallback(e,[""]),"";var i="";if(n||(i=g.getMarketingCloudVisitorID(function(t){g.getAnalyticsVisitorID(e,!0)})),i||n){var r=n?g.marketingCloudServer:g.trackingServer,a="";g.loadSSL&&(n?g.marketingCloudServerSecure&&(r=g.marketingCloudServerSecure):g.trackingServerSecure&&(r=g.trackingServerSecure));var o={};if(r){var s="http"+(g.loadSSL?"s":"")+"://"+r+"/id",l="d_visid_ver="+g.version+"&mcorgid="+encodeURIComponent(g.marketingCloudOrgID)+(i?"&mid="+encodeURIComponent(i):"")+(g.idSyncDisable3rdPartySyncing||g.disableThirdPartyCookies?"&d_coppa=true":""),c=["s_c_il",g._in,"_set"+(n?"MarketingCloud":"Analytics")+"Fields"];a=s+"?"+l+"&callback=s_c_il%5B"+g._in+"%5D._set"+(n?"MarketingCloud":"Analytics")+"Fields",o.corsUrl=s+"?"+l,o.callback=c}return o.url=a,g._getRemoteField(n?A:O,a,e,t,o)}return""},g.getAudienceManagerLocationHint=function(e,t){if(g.getMarketingCloudVisitorID(function(t){g.getAudienceManagerLocationHint(e,!0)})){var n=g._getField(O);if(!n&&F.isTrackingServerPopulated()&&(n=g.getAnalyticsVisitorID(function(t){g.getAudienceManagerLocationHint(e,!0)})),n||!F.isTrackingServerPopulated()){var i=g._getAudienceManagerURLData(),r=i.url;return g._getRemoteField("MCAAMLH",r,e,t,i)}}return""},g.getLocationHint=g.getAudienceManagerLocationHint,g.getAudienceManagerBlob=function(e,t){if(g.getMarketingCloudVisitorID(function(t){g.getAudienceManagerBlob(e,!0)})){var n=g._getField(O);if(!n&&F.isTrackingServerPopulated()&&(n=g.getAnalyticsVisitorID(function(t){g.getAudienceManagerBlob(e,!0)})),n||!F.isTrackingServerPopulated()){var i=g._getAudienceManagerURLData(),r=i.url;return g._customerIDsHashChanged&&g._setFieldExpire(k,-1),g._getRemoteField(k,r,e,t,i)}}return""},g._supplementalDataIDCurrent="",g._supplementalDataIDCurrentConsumed={},g._supplementalDataIDLast="",g._supplementalDataIDLastConsumed={},g.getSupplementalDataID=function(e,t){g._supplementalDataIDCurrent||t||(g._supplementalDataIDCurrent=g._generateID(1));var n=g._supplementalDataIDCurrent;return g._supplementalDataIDLast&&!g._supplementalDataIDLastConsumed[e]?(n=g._supplementalDataIDLast,g._supplementalDataIDLastConsumed[e]=!0):n&&(g._supplementalDataIDCurrentConsumed[e]&&(g._supplementalDataIDLast=g._supplementalDataIDCurrent,g._supplementalDataIDLastConsumed=g._supplementalDataIDCurrentConsumed,g._supplementalDataIDCurrent=n=t?"":g._generateID(1),g._supplementalDataIDCurrentConsumed={}),n&&(g._supplementalDataIDCurrentConsumed[e]=!0)),n};var w=!1;g._liberatedOptOut=null,g.getOptOut=function(e,t){var n=g._getAudienceManagerURLData("_setMarketingCloudFields"),i=n.url;if(u())return g._getRemoteField("MCOPTOUT",i,e,t,n);if(g._registerCallback("liberatedOptOut",e),null!==g._liberatedOptOut)return g._callAllCallbacks("liberatedOptOut",[g._liberatedOptOut]),w=!1,g._liberatedOptOut;if(w)return null;w=!0;var r="liberatedGetOptOut";return n.corsUrl=n.corsUrl.replace(/dpm\.demdex\.net\/id\?/,"dpm.demdex.net/optOutStatus?"),n.callback=[r],_[r]=function(e){if(e===Object(e)){var t,n,i=j.parseOptOut(e,t,T);t=i.optOut,n=1e3*i.d_ottl,g._liberatedOptOut=t,setTimeout(function(){g._liberatedOptOut=null},n)}g._callAllCallbacks("liberatedOptOut",[t]),w=!1},P.fireCORS(n),null},g.isOptedOut=function(e,t,n){t||(t=D.OptOut.GLOBAL);var i=g.getOptOut(function(n){var i=n===D.OptOut.GLOBAL||n.indexOf(t)>=0;g._callCallback(e,[i])},n);return i?i===D.OptOut.GLOBAL||i.indexOf(t)>=0:null},g._fields=null,g._fieldsExpired=null,g._hash=function(e){var t,n,i=0;if(e)for(t=0;t<e.length;t++)n=e.charCodeAt(t),i=(i<<5)-i+n,i&=i;return i},g._generateID=ne,g._generateLocalMID=function(){var e=g._generateID(0);return x.isClientSideMarketingCloudVisitorID=!0,e},g._callbackList=null,g._callCallback=function(e,t){try{"function"==typeof e?e.apply(v,t):e[1].apply(e[0],t)}catch(e){}},g._registerCallback=function(e,t){t&&(null==g._callbackList&&(g._callbackList={}),void 0==g._callbackList[e]&&(g._callbackList[e]=[]),g._callbackList[e].push(t))},g._callAllCallbacks=function(e,t){if(null!=g._callbackList){var n=g._callbackList[e];if(n)for(;n.length>0;)g._callCallback(n.shift(),t)}},g._addQuerystringParam=function(e,t,n,i){var r=encodeURIComponent(t)+"="+encodeURIComponent(n),a=F.parseHash(e),o=F.hashlessUrl(e);if(-1===o.indexOf("?"))return o+"?"+r+a;var s=o.split("?"),l=s[0]+"?",c=s[1];return l+F.addQueryParamAtLocation(c,r,i)+a},g._extractParamFromUri=function(e,t){var n=new RegExp("[\\?&#]"+t+"=([^&#]*)"),i=n.exec(e);if(i&&i.length)return decodeURIComponent(i[1])},g._parseAdobeMcFromUrl=r(re.ADOBE_MC),g._parseAdobeMcSdidFromUrl=r(re.ADOBE_MC_SDID),g._attemptToPopulateSdidFromUrl=function(e){var n=g._parseAdobeMcSdidFromUrl(e),i=1e9;n&&n.TS&&(i=F.getTimestampInSeconds()-n.TS),n&&n.SDID&&n.MCORGID===t&&i<g.sdidParamExpiry&&(g._supplementalDataIDCurrent=n.SDID,g._supplementalDataIDCurrentConsumed.SDID_URL_PARAM=!0)},g._attemptToPopulateIdsFromUrl=function(){var e=g._parseAdobeMcFromUrl();if(e&&e.TS){var n=F.getTimestampInSeconds(),i=n-e.TS;if(Math.floor(i/60)>re.ADOBE_MC_TTL_IN_MIN||e.MCORGID!==t)return;a(e)}},g._mergeServerState=function(e){if(e)try{if(e=function(e){return F.isObject(e)?e:JSON.parse(e)}(e),e[g.marketingCloudOrgID]){var t=e[g.marketingCloudOrgID];!function(e){F.isObject(e)&&g.setCustomerIDs(e)}(t.customerIDs),o(t.sdid)}}catch(e){throw new Error("`serverState` has an invalid format.")}},g._timeout=null,g._loadData=function(e,t,n,i){t=g._addQuerystringParam(t,"d_fieldgroup",e,1),i.url=g._addQuerystringParam(i.url,"d_fieldgroup",e,1),i.corsUrl=g._addQuerystringParam(i.corsUrl,"d_fieldgroup",e,1),x.fieldGroupObj[e]=!0,i===Object(i)&&i.corsUrl&&"XMLHttpRequest"===P.corsMetadata.corsType&&P.fireCORS(i,n,e)},g._clearTimeout=function(e){null!=g._timeout&&g._timeout[e]&&(clearTimeout(g._timeout[e]),g._timeout[e]=0)},g._settingsDigest=0,g._getSettingsDigest=function(){if(!g._settingsDigest){var e=g.version;g.audienceManagerServer&&(e+="|"+g.audienceManagerServer),g.audienceManagerServerSecure&&(e+="|"+g.audienceManagerServerSecure),g._settingsDigest=g._hash(e)}return g._settingsDigest},g._readVisitorDone=!1,g._readVisitor=function(){if(!g._readVisitorDone){g._readVisitorDone=!0;var e,t,n,i,r,a,o=g._getSettingsDigest(),s=!1,l=g.cookieRead(g.cookieName),c=new Date;if(l||I||g.discardTrackingServerECID||(l=g.cookieRead(re.FIRST_PARTY_SERVER_COOKIE)),null==g._fields&&(g._fields={}),l&&"T"!==l)for(l=l.split("|"),l[0].match(/^[\-0-9]+$/)&&(parseInt(l[0],10)!==o&&(s=!0),l.shift()),l.length%2==1&&l.pop(),e=0;e<l.length;e+=2)t=l[e].split("-"),n=t[0],i=l[e+1],t.length>1?(r=parseInt(t[1],10),a=t[1].indexOf("s")>0):(r=0,a=!1),s&&("MCCIDH"===n&&(i=""),r>0&&(r=c.getTime()/1e3-60)),n&&i&&(g._setField(n,i,1),r>0&&(g._fields["expire"+n]=r+(a?"s":""),(c.getTime()>=1e3*r||a&&!g.cookieRead(g.sessionCookieName))&&(g._fieldsExpired||(g._fieldsExpired={}),g._fieldsExpired[n]=!0)));!g._getField(O)&&F.isTrackingServerPopulated()&&(l=g.cookieRead("s_vi"))&&(l=l.split("|"),l.length>1&&l[0].indexOf("v1")>=0&&(i=l[1],e=i.indexOf("["),e>=0&&(i=i.substring(0,e)),i&&i.match(re.VALID_VISITOR_ID_REGEX)&&g._setField(O,i)))}},g._appendVersionTo=function(e){var t="vVersion|"+g.version,n=e?g._getCookieVersion(e):null;return n?Z.areVersionsDifferent(n,g.version)&&(e=e.replace(re.VERSION_REGEX,t)):e+=(e?"|":"")+t,e},g._writeVisitor=function(){var e,t,n=g._getSettingsDigest();for(e in g._fields)L(e)&&g._fields[e]&&"expire"!==e.substring(0,6)&&(t=g._fields[e],n+=(n?"|":"")+e+(g._fields["expire"+e]?"-"+g._fields["expire"+e]:"")+"|"+t);n=g._appendVersionTo(n),g.cookieWrite(g.cookieName,n,1)},g._getField=function(e,t){return null==g._fields||!t&&g._fieldsExpired&&g._fieldsExpired[e]?null:g._fields[e]},g._setField=function(e,t,n){null==g._fields&&(g._fields={}),g._fields[e]=t,n||g._writeVisitor()},g._getFieldList=function(e,t){var n=g._getField(e,t);return n?n.split("*"):null},g._setFieldList=function(e,t,n){g._setField(e,t?t.join("*"):"",n)},g._getFieldMap=function(e,t){var n=g._getFieldList(e,t);if(n){var i,r={};for(i=0;i<n.length;i+=2)r[n[i]]=n[i+1];return r}return null},g._setFieldMap=function(e,t,n){var i,r=null;if(t){r=[];for(i in t)L(i)&&(r.push(i),r.push(t[i]))}g._setFieldList(e,r,n)},g._setFieldExpire=function(e,t,n){var i=new Date;i.setTime(i.getTime()+1e3*t),null==g._fields&&(g._fields={}),g._fields["expire"+e]=Math.floor(i.getTime()/1e3)+(n?"s":""),t<0?(g._fieldsExpired||(g._fieldsExpired={}),g._fieldsExpired[e]=!0):g._fieldsExpired&&(g._fieldsExpired[e]=!1),n&&(g.cookieRead(g.sessionCookieName)||g.cookieWrite(g.sessionCookieName,"1"))},g._findVisitorID=function(t){return t&&("object"===e(t)&&(t=t.d_mid?t.d_mid:t.visitorID?t.visitorID:t.id?t.id:t.uuid?t.uuid:""+t),t&&"NOTARGET"===(t=t.toUpperCase())&&(t=T),t&&(t===T||t.match(re.VALID_VISITOR_ID_REGEX))||(t="")),t},g._setFields=function(t,n){if(g._clearTimeout(t),null!=g._loading&&(g._loading[t]=!1),x.fieldGroupObj[t]&&x.setState(t,!1),"MC"===t){!0!==x.isClientSideMarketingCloudVisitorID&&(x.isClientSideMarketingCloudVisitorID=!1);var i=g._getField(A);if(!i||g.overwriteCrossDomainMCIDAndAID){if(!(i="object"===e(n)&&n.mid?n.mid:g._findVisitorID(n))){if(g._use1stPartyMarketingCloudServer&&!g.tried1stPartyMarketingCloudServer)return g.tried1stPartyMarketingCloudServer=!0,void g.getAnalyticsVisitorID(null,!1,!0);i=g._generateLocalMID()}g._setField(A,i)}i&&i!==T||(i=""),"object"===e(n)&&((n.d_region||n.dcs_region||n.d_blob||n.blob)&&g._setFields(M,n),g._use1stPartyMarketingCloudServer&&n.mid&&g._setFields(b,{id:n.id})),g._callAllCallbacks(A,[i])}if(t===M&&"object"===e(n)){var r=604800;void 0!=n.id_sync_ttl&&n.id_sync_ttl&&(r=parseInt(n.id_sync_ttl,10));var a=N.getRegionAndCheckIfChanged(n,r);g._callAllCallbacks("MCAAMLH",[a]);var o=g._getField(k);(n.d_blob||n.blob)&&(o=n.d_blob,o||(o=n.blob),g._setFieldExpire(k,r),g._setField(k,o)),o||(o=""),g._callAllCallbacks(k,[o]),!n.error_msg&&g._newCustomerIDsHash&&g._setField("MCCIDH",g._newCustomerIDsHash)}if(t===b){var s=g._getField(O);s&&!g.overwriteCrossDomainMCIDAndAID||(s=g._findVisitorID(n),s?s!==T&&g._setFieldExpire(k,-1):s=T,g._setField(O,s)),s&&s!==T||(s=""),g._callAllCallbacks(O,[s])}if(g.idSyncDisableSyncs||g.disableIdSyncs)N.idCallNotProcesssed=!0;else{N.idCallNotProcesssed=!1;var l={};l.ibs=n.ibs,l.subdomain=n.subdomain,N.processIDCallData(l)}if(n===Object(n)){var c,d;u()&&g.isAllowed()&&(c=g._getField("MCOPTOUT"));var f=j.parseOptOut(n,c,T);c=f.optOut,d=f.d_ottl,g._setFieldExpire("MCOPTOUT",d,!0),g._setField("MCOPTOUT",c),g._callAllCallbacks("MCOPTOUT",[c])}},g._loading=null,g._getRemoteField=function(e,t,n,i,r){var a,o="",s=F.isFirstPartyAnalyticsVisitorIDCall(e),l={MCAAMLH:!0,MCAAMB:!0};if(u()&&g.isAllowed()){g._readVisitor(),o=g._getField(e,!0===l[e]);if(function(){return(!o||g._fieldsExpired&&g._fieldsExpired[e])&&(!g.disableThirdPartyCalls||s)}()){if(e===A||"MCOPTOUT"===e?a="MC":"MCAAMLH"===e||e===k?a=M:e===O&&(a=b),a)return!t||null!=g._loading&&g._loading[a]||(null==g._loading&&(g._loading={}),g._loading[a]=!0,g._loadData(a,t,function(t){if(!g._getField(e)){t&&x.setState(a,!0);var n="";e===A?n=g._generateLocalMID():a===M&&(n={error_msg:"timeout"}),g._setFields(a,n)}},r)),g._registerCallback(e,n),o||(t||g._setFields(a,{id:T}),"")}else o||(e===A?(g._registerCallback(e,n),o=g._generateLocalMID(),g.setMarketingCloudVisitorID(o)):e===O?(g._registerCallback(e,n),o="",g.setAnalyticsVisitorID(o)):(o="",i=!0))}return e!==A&&e!==O||o!==T||(o="",i=!0),n&&i&&g._callCallback(n,[o]),o},g._setMarketingCloudFields=function(e){g._readVisitor(),g._setFields("MC",e)},g._mapCustomerIDs=function(e){g.getAudienceManagerBlob(e,!0)},g._setAnalyticsFields=function(e){g._readVisitor(),g._setFields(b,e)},g._setAudienceManagerFields=function(e){g._readVisitor(),g._setFields(M,e)},g._getAudienceManagerURLData=function(e){var t=g.audienceManagerServer,n="",i=g._getField(A),r=g._getField(k,!0),a=g._getField(O),o=a&&a!==T?"&d_cid_ic=AVID%01"+encodeURIComponent(a):"";if(g.loadSSL&&g.audienceManagerServerSecure&&(t=g.audienceManagerServerSecure),t){var s,l,c=g.getCustomerIDs();if(c)for(s in c)L(s)&&(l=c[s],o+="&d_cid_ic="+encodeURIComponent(s)+"%01"+encodeURIComponent(l.id?l.id:"")+(l.authState?"%01"+l.authState:""));e||(e="_setAudienceManagerFields");var u="http"+(g.loadSSL?"s":"")+"://"+t+"/id",d="d_visid_ver="+g.version+(h&&-1!==u.indexOf("demdex.net")?"&gdpr=1&gdpr_force=1&gdpr_consent="+h:"")+"&d_rtbd=json&d_ver=2"+(!i&&g._use1stPartyMarketingCloudServer?"&d_verify=1":"")+"&d_orgid="+encodeURIComponent(g.marketingCloudOrgID)+"&d_nsid="+(g.idSyncContainerID||0)+(i?"&d_mid="+encodeURIComponent(i):"")+(g.idSyncDisable3rdPartySyncing||g.disableThirdPartyCookies?"&d_coppa=true":"")+(!0===S?"&d_coop_safe=1":!1===S?"&d_coop_unsafe=1":"")+(r?"&d_blob="+encodeURIComponent(r):"")+o,f=["s_c_il",g._in,e];return n=u+"?"+d+"&d_cb=s_c_il%5B"+g._in+"%5D."+e,{url:n,corsUrl:u+"?"+d,callback:f}}return{url:n}},g.appendVisitorIDsTo=function(e){try{var t=[[A,g._getField(A)],[O,g._getField(O)],["MCORGID",g.marketingCloudOrgID]];return g._addQuerystringParam(e,re.ADOBE_MC,s(t))}catch(t){return e}},g.appendSupplementalDataIDTo=function(e,t){if(!(t=t||g.getSupplementalDataID(F.generateRandomString(),!0)))return e;try{var n=s([["SDID",t],["MCORGID",g.marketingCloudOrgID]]);return g._addQuerystringParam(e,re.ADOBE_MC_SDID,n)}catch(t){return e}};var F={parseHash:function(e){var t=e.indexOf("#");return t>0?e.substr(t):""},hashlessUrl:function(e){var t=e.indexOf("#");return t>0?e.substr(0,t):e},addQueryParamAtLocation:function(e,t,n){var i=e.split("&");return n=null!=n?n:i.length,i.splice(n,0,t),i.join("&")},isFirstPartyAnalyticsVisitorIDCall:function(e,t,n){if(e!==O)return!1;var i;return t||(t=g.trackingServer),n||(n=g.trackingServerSecure),!("string"!=typeof(i=g.loadSSL?n:t)||!i.length)&&(i.indexOf("2o7.net")<0&&i.indexOf("omtrdc.net")<0)},isObject:function(e){return Boolean(e&&e===Object(e))},removeCookie:function(e){Q.remove(e,{domain:g.cookieDomain})},isTrackingServerPopulated:function(){return!!g.trackingServer||!!g.trackingServerSecure},getTimestampInSeconds:function(){return Math.round((new Date).getTime()/1e3)},parsePipeDelimetedKeyValues:function(e){return e.split("|").reduce(function(e,t){var n=t.split("=");return e[n[0]]=decodeURIComponent(n[1]),e},{})},generateRandomString:function(e){e=e||5;for(var t="",n="abcdefghijklmnopqrstuvwxyz0123456789";e--;)t+=n[Math.floor(Math.random()*n.length)];return t},normalizeBoolean:function(e){return"true"===e||"false"!==e&&e},parseBoolean:function(e){return"true"===e||"false"!==e&&null},replaceMethodsWithFunction:function(e,t){for(var n in e)e.hasOwnProperty(n)&&"function"==typeof e[n]&&(e[n]=t);return e}};g._helpers=F;var N=ae(g,D);g._destinationPublishing=N,g.timeoutMetricsLog=[];var x={isClientSideMarketingCloudVisitorID:null,MCIDCallTimedOut:null,AnalyticsIDCallTimedOut:null,AAMIDCallTimedOut:null,fieldGroupObj:{},setState:function(e,t){switch(e){case"MC":!1===t?!0!==this.MCIDCallTimedOut&&(this.MCIDCallTimedOut=!1):this.MCIDCallTimedOut=t;break;case b:!1===t?!0!==this.AnalyticsIDCallTimedOut&&(this.AnalyticsIDCallTimedOut=!1):this.AnalyticsIDCallTimedOut=t;break;case M:!1===t?!0!==this.AAMIDCallTimedOut&&(this.AAMIDCallTimedOut=!1):this.AAMIDCallTimedOut=t}}};g.isClientSideMarketingCloudVisitorID=function(){return x.isClientSideMarketingCloudVisitorID},g.MCIDCallTimedOut=function(){return x.MCIDCallTimedOut},g.AnalyticsIDCallTimedOut=function(){return x.AnalyticsIDCallTimedOut},g.AAMIDCallTimedOut=function(){return x.AAMIDCallTimedOut},g.idSyncGetOnPageSyncInfo=function(){return g._readVisitor(),g._getField("MCSYNCSOP")},g.idSyncByURL=function(e){if(!g.isOptedOut()){var t=l(e||{});if(t.error)return t.error;var n,i,r=e.url,a=encodeURIComponent,o=N;return r=r.replace(/^https:/,"").replace(/^http:/,""),n=j.encodeAndBuildRequest(["",e.dpid,e.dpuuid||""],","),i=["ibs",a(e.dpid),"img",a(r),t.ttl,"",n],o.addMessage(i.join("|")),o.requestToProcess(),"Successfully queued"}},g.idSyncByDataSource=function(e){if(!g.isOptedOut())return e===Object(e)&&"string"==typeof e.dpuuid&&e.dpuuid.length?(e.url="//dpm.demdex.net/ibs:dpid="+e.dpid+"&dpuuid="+e.dpuuid,g.idSyncByURL(e)):"Error: config or config.dpuuid is empty"},Ue(g,N),g._getCookieVersion=function(e){e=e||g.cookieRead(g.cookieName);var t=re.VERSION_REGEX.exec(e);return t&&t.length>1?t[1]:null},g._resetAmcvCookie=function(e){var t=g._getCookieVersion();t&&!Z.isLessThan(t,e)||F.removeCookie(g.cookieName)},g.setAsCoopSafe=function(){S=!0},g.setAsCoopUnsafe=function(){S=!1},function(){if(g.configs=Object.create(null),F.isObject(n))for(var e in n)L(e)&&(g[e]=n[e],g.configs[e]=n[e])}(),function(){[["getMarketingCloudVisitorID"],["setCustomerIDs",void 0],["getAnalyticsVisitorID"],["getAudienceManagerLocationHint"],["getLocationHint"],["getAudienceManagerBlob"]].forEach(function(e){var t=e[0],n=2===e.length?e[1]:"",i=g[t];g[t]=function(e){return u()&&g.isAllowed()?i.apply(g,arguments):("function"==typeof e&&g._callCallback(e,[n]),n)}})}(),g.init=function(){if(c())return m.optIn.fetchPermissions(f,!0);!function(){if(F.isObject(n)){g.idSyncContainerID=g.idSyncContainerID||0,S="boolean"==typeof g.isCoopSafe?g.isCoopSafe:F.parseBoolean(g.isCoopSafe),g.resetBeforeVersion&&g._resetAmcvCookie(g.resetBeforeVersion),g._attemptToPopulateIdsFromUrl(),g._attemptToPopulateSdidFromUrl(),g._readVisitor();var e=g._getField(y),t=Math.ceil((new Date).getTime()/re.MILLIS_PER_DAY);g.idSyncDisableSyncs||g.disableIdSyncs||!N.canMakeSyncIDCall(e,t)||(g._setFieldExpire(k,-1),g._setField(y,t)),g.getMarketingCloudVisitorID(),g.getAudienceManagerLocationHint(),g.getAudienceManagerBlob(),g._mergeServerState(g.serverState)}else g._attemptToPopulateIdsFromUrl(),g._attemptToPopulateSdidFromUrl()}(),function(){if(!g.idSyncDisableSyncs&&!g.disableIdSyncs){N.checkDPIframeSrc();var e=function(){var e=N;e.readyToAttachIframe()&&e.attachIframe()};v.addEventListener("load",function(){D.windowLoaded=!0,e()});try{te.receiveMessage(function(e){N.receiveMessage(e.data)},N.iframeHost)}catch(e){}}}(),function(){g.whitelistIframeDomains&&re.POST_MESSAGE_ENABLED&&(g.whitelistIframeDomains=g.whitelistIframeDomains instanceof Array?g.whitelistIframeDomains:[g.whitelistIframeDomains],g.whitelistIframeDomains.forEach(function(e){var n=new B(t,e),i=K(g,n);te.receiveMessage(i,e)}))}()}};qe.config=se,_.Visitor=qe;var Xe=qe,We=function(e){if(j.isObject(e))return Object.keys(e).filter(function(t){return""!==e[t]}).reduce(function(t,n){var i="doesOptInApply"!==n?e[n]:se.normalizeConfig(e[n]),r=j.normalizeBoolean(i);return t[n]=r,t},Object.create(null))},Je=Ve.OptIn,Ke=Ve.IabPlugin;return Xe.getInstance=function(e,t){if(!e)throw new Error("Visitor requires Adobe Marketing Cloud Org ID.");e.indexOf("@")<0&&(e+="@AdobeOrg");var n=function(){var t=_.s_c_il;if(t)for(var n=0;n<t.length;n++){var i=t[n];if(i&&"Visitor"===i._c&&i.marketingCloudOrgID===e)return i}}();if(n)return n;var i=We(t);!function(e){_.adobe.optIn=_.adobe.optIn||function(){var t=j.pluck(e,["doesOptInApply","previousPermissions","preOptInApprovals","isOptInStorageEnabled","optInStorageExpiry","isIabContext"]),n=e.optInCookieDomain||e.cookieDomain;n=n||$(),n=n===window.location.hostname?"":n,t.optInCookieDomain=n;var i=new Je(t,{cookies:Q});if(t.isIabContext&&se.normalizeConfig(t.doesOptInApply)){var r=new Ke(window.__cmp);i.registerPlugin(r)}return i}()}(i||{});var r=e,a=r.split("").reverse().join(""),o=new Xe(e,null,a);j.isObject(i)&&i.cookieDomain&&(o.cookieDomain=i.cookieDomain),function(){_.s_c_il.splice(--_.s_c_in,1)}();var s=j.getIeVersion();if("number"==typeof s&&s<10)return o._helpers.replaceMethodsWithFunction(o,function(){});var l=function(){try{return _.self!==_.parent}catch(e){return!0}}()&&!function(e){return e.cookieWrite("TEST_AMCV_COOKIE","T",1),"T"===e.cookieRead("TEST_AMCV_COOKIE")&&(e._helpers.removeCookie("TEST_AMCV_COOKIE"),!0)}(o)&&_.parent?new Y(e,i,o,_.parent):new Xe(e,i,a);return o=null,l.init(),l},function(){function e(){Xe.windowLoaded=!0}_.addEventListener?_.addEventListener("load",e):_.attachEvent&&_.attachEvent("onload",e),Xe.codeLoadEnd=(new Date).getTime()}(),Xe}();
                return Visitor;
              }();

            }

          },
          "adobe-mcid/src/view/utils/timeUnits.js": {
            "script": function(module, exports, require, turbine) {

              var timeUnits = {
                Hours: 3600,
                Days: 24 * 3600,
                Weeks: 7 * 24 * 3600,
                Months: 30 * 24 * 3600,
                Years: 365 * 24 * 3600
              };

              module.exports = timeUnits;

            }

          }
        },
        "settings": {
          "orgId": "315F75E95BFC0EE50A495C73@AdobeOrg",
          "variables": [
            {
              "name": "cookieDomain",
              "value": "%domain%"
            },
            {
              "name": "secureCookie",
              "value": "true"
            }
          ],
          "isIabContext": false,
          "doesOptInApply": true,
          "preOptInApprovals": {
            "aa": true,
            "aam": true,
            "ecid": true,
            "target": true
          },
          "previousPermissions": "%user: consent object%",
          "isOptInStorageEnabled": false
        },
        "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EP3c046881e1904c3ba615a13260868087/"
      },
      "adobe-target": {
        "displayName": "Adobe Target",
        "modules": {
        },
        "settings": {
          "targetSettings": {
            "enabled": true,
            "timeout": 5000,
            "version": "1.7.1",
            "imsOrgId": "315F75E95BFC0EE50A495C73@AdobeOrg",
            "clientCode": "svenskaspelsportcasi",
            "secureOnly": false,
            "crossDomain": "disabled",
            "optinEnabled": false,
            "serverDomain": "svenskaspelsportcasi.tt.omtrdc.net",
            "urlSizeLimit": 2048,
            "optoutEnabled": false,
            "globalMboxName": "target-global-mbox",
            "bodyHiddenStyle": "body {opacity: 0}",
            "deviceIdLifetime": 63244800000,
            "bodyHidingEnabled": true,
            "sessionIdLifetime": 1860000,
            "visitorApiTimeout": 2000,
            "authoringScriptUrl": "//cdn.tt.omtrdc.net/cdn/target-vec.js",
            "overrideMboxEdgeServer": false,
            "selectorsPollingTimeout": 5000,
            "defaultContentHiddenStyle": "visibility: hidden;",
            "defaultContentVisibleStyle": "visibility: visible;",
            "overrideMboxEdgeServerTimeout": 1860000,
            "supplementalDataIdParamTimeout": 30
          }
        },
        "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EP1efb090e3c464221a450319d914b489c/"
      },
      "lookup-table-utility": {
        "displayName": "Lookup Table Utility",
        "modules": {
          "lookup-table-utility/src/lib/dataElements/lookupTable.js": {
            "name": "lookup-table",
            "displayName": "Lookup Table",
            "script": function(module, exports, require, turbine) {
              'use strict';

              module.exports = function(settings) {
                if (settings.inputVariable.dataElement) {
                  var inputVariable = settings.inputVariable.value.toString();
                } else if (typeof eval(settings.inputVariable.value) === 'object') {
                  var inputVariable = JSON.stringify(eval(settings.inputVariable.value));
                } else {
                  var inputVariable = eval(settings.inputVariable.value).toString();
                }
                var lookupArray = settings.lookupArray;
                var lookupValue = lookupArray.filter(function (item) {
                  if (item.input === inputVariable) return item;
                })
                return !lookupValue[0] ? undefined : lookupValue[0].output;
              };

            }

          }
        },
        "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EPbade1de4902944faadae748f106fb817/"
      }
    },
    "company": {
      "orgId": "315F75E95BFC0EE50A495C73@AdobeOrg"
    },
    "property": {
      "name": "Svenska Spel ",
      "settings": {
        "domains": [
          "www.svenskaspel.se"
        ],
        "undefinedVarsReturnEmpty": false
      }
    },
    "rules": [
      {
        "id": "RLdf0ab8586bb1471cba5c2a0e53bd20c0",
        "name": "promotion: click",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals"
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "promoClick"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "customSetup": {
                "source": function(event, s) {
                }
              },
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar16",
                    "type": "value",
                    "value": "%event.detail.component.componentID%"
                  },
                  {
                    "name": "eVar17",
                    "type": "value",
                    "value": "%event.detail.component.componentPosition%"
                  }
                ],
                "events": [
                  {
                    "name": "event2"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkName": "promotion Click",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL40d6391cb2e2429eb750d1cb796566c1",
        "name": "promotion: impression",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "promoImpression"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "core/src/lib/actions/customCode.js",
            "settings": {
              "source": 'https://assets.adobedtm.com/de1cfb1de36f/4bc19535e626/448aad890223/RC80053ebaa87842a4b38dd4384bb537eb-source.js',
              "language": "javascript",
              "isExternal": true
            }
          }
        ]
      },
      {
        "id": "RL7e66443907bc4834a9f153773b9f44cc",
        "name": "user: set details logged out",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 10.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.user.loggedIn%",
              "rightOperand": "no"
            }
          },
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "matchesRegex"
              },
              "leftOperand": "%session: user id%",
              "rightOperand": ".+"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar14",
                    "type": "value",
                    "value": "%event.detail.user.loggedIn%"
                  },
                  {
                    "name": "eVar15",
                    "type": "value",
                    "value": "%event.detail.user.userID%"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-mcid/src/lib/actions/setCustomerIds.js",
            "settings": {
              "customerIds": [
                {
                  "value": "%session: user id%",
                  "authState": 2,
                  "integrationCode": "customerBridgeId"
                }
              ]
            }
          },
          {
            "modulePath": "core/src/lib/actions/customCode.js",
            "settings": {
              "source": 'https://assets.adobedtm.com/de1cfb1de36f/4bc19535e626/448aad890223/RCdbb1783e53a14347960f6b426e160267-source.js',
              "language": "javascript",
              "isExternal": true
            }
          }
        ]
      },
      {
        "id": "RL6bd89851f4c241d89ff0f70108abb9ef",
        "name": "user: set details loggedin",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 10.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.user.loggedIn%",
              "rightOperand": "yes"
            }
          },
          {
            "modulePath": "core/src/lib/conditions/customCode.js",
            "settings": {
              "source": function(event, target) {
                try{
                  if(event.detail.user.userId){
                    sessionStorage.setItem("_uid", event.detail.user.userId);
                    return true;
                  }
                }catch(e){}
              }
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar14",
                    "type": "value",
                    "value": "%event.detail.user.loggedIn%"
                  },
                  {
                    "name": "eVar15",
                    "type": "value",
                    "value": "%event.detail.user.userId%"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-mcid/src/lib/actions/setCustomerIds.js",
            "settings": {
              "customerIds": [
                {
                  "value": "%session: user id%",
                  "authState": 1,
                  "integrationCode": "customerBridgeId"
                }
              ]
            }
          }
        ]
      },
      {
        "id": "RL668dab882f6b4432a7824ef625b92db1",
        "name": "lotto draw correction: show direct",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Show direct"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar23",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event24"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RLf9fe11bdd0d54b95a2f552d835820c8e",
        "name": "lotto draw correction: animation completed",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Animation completed"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar23",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event25"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RLea74826b4bff40f78a466fdd189a5de9",
        "name": "deposit: success",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Deposit Success"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar19",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  },
                  {
                    "name": "eVar20",
                    "type": "value",
                    "value": "%event.detail.eventInfo.eventPoints%"
                  }
                ],
                "events": [
                  {
                    "name": "event11"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL78e105ff70e84780b9ee9fdce95c95cd",
        "name": "user: logout",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Logout"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event6"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL384a9883553c450ab8295844583b2c62",
        "name": "deposit: failure",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Deposit Failure"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar19",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  },
                  {
                    "name": "eVar20",
                    "type": "value",
                    "value": "%event.detail.eventInfo.eventPoints%"
                  }
                ],
                "events": [
                  {
                    "name": "event12"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL3a78d824bfd742cfa6595d48ccba48db",
        "name": "KYC: completed",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "completed"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event8"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL06a3a3cc490f41a5942522cfccc67ef7",
        "name": "KYC: done",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "done"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event9"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL4dac43cf2af049a5b1aa221e6f3c221c",
        "name": "KYC: more questions",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "more questions"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event10"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL662cd57b4b3943838cb24ed047de7690",
        "name": "withdrawal: success",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Withdrawal Success"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event16"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RLd9d67b1651f74c4083706153167f8835",
        "name": "withdrawal: failure",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Withdrawal Failure"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event17"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL8b2dfa2f9b60402aa15ad3d9f58734a2",
        "name": "weekly budget: increase ",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Increase"
            }
          },
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.eventInfo.type%",
              "rightOperand": "Veckobudget"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar25",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event18"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL27990254f94b401199b0064cb2ea20fc",
        "name": "betslip: complete",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Betslip Complete"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar18",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event22"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL8b9ae45f59a64d36a84002809983a364",
        "name": "weekly budget: decrease ",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Decrease"
            }
          },
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.eventInfo.type%",
              "rightOperand": "Veckobudget"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar25",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event19"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL14df604a75cf404eb2094b57c6cc805d",
        "name": "user: customer registration",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Customer Registration"
            }
          },
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "matchesRegex",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.eventInfo.eventName%",
              "rightOperand": "^(new|retail)_(bankid|freja)"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event7"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL9fc37918656f481ca4fe9d176b4e0ad6",
        "name": "video: start",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Start"
            }
          },
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.eventInfo.type%",
              "rightOperand": "Video"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar21",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event23"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL7ed0a28ff04c414c95f8c11ab2be9b0a",
        "name": "liverattning",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.eventInfo.type%",
              "rightOperand": "Liverattning"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar24",
                    "type": "value",
                    "value": "%event.detail.eventInfo.eventAction%"
                  }
                ],
                "events": [
                  {
                    "name": "event26"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL3345adfaedd440ad8348a8de0a2518af",
        "name": "gtm: interceptor",
        "events": [
          {
            "modulePath": "core/src/lib/events/libraryLoaded.js",
            "settings": {
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/customCode.js",
            "settings": {
              "source": function(event, target) {
                try{
                  if (window.digitalData) {
                    if (!window.digitalData.__oldPush) {
                      window.digitalData.__oldPush = window.digitalData.push;
                      window.digitalData.push = function(payload) {
                        if (payload.event && typeof payload.event === "string") {
                          _satellite.track(payload.event, payload);
                        }
                        window.digitalData.__oldPush(payload);
                      }
                    }
                  }
                }catch(e){}
                return false;
              }
            }
          }
        ],
        "actions": [

        ]
      },
      {
        "id": "RLe3d50d96ecda46dc93f496c208e025bb",
        "name": "user: login success",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "login success"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar14",
                    "type": "value",
                    "value": "%event.detail.event%"
                  }
                ],
                "events": [
                  {
                    "name": "event4"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RLc07064da656545bb9777c9752b519204",
        "name": "spelpaus: cancel",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Cancel"
            }
          },
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.eventInfo.type%",
              "rightOperand": "Spelpaus"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "customSetup": {
                "source": function(event, s) {
                  try{
                    var arr = event.detail.eventInfo.eventLabel.split(":");
                    s.eVar26 = arr[0];
                    s.eVar27 = arr[1];
                    s.linkTrackVars = "eVar26,eVar27,events";
                  }catch(e){}
                }
              },
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar26",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event21"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL58d47b9c32c24403895a6464125d9d60",
        "name": "user: login failure",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "login failure"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar14",
                    "type": "value",
                    "value": "%event.detail.event%"
                  }
                ],
                "events": [
                  {
                    "name": "event5"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RLcd356826be3b46f4b57f8b5a952b97af",
        "name": "GrÃ¤sroten: Ge mitt stÃ¶d",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Ge mitt stÃ¶d"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar31",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event33"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL88ebcaed80a14767986c3ca0ffb32e8b",
        "name": "Form: PÃ¥bÃ¶rja formulÃ¤r",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "PÃ¥bÃ¶rja formulÃ¤r"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar34",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event36"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL1e41dfc90d564c29a7239f43384cc6bd",
        "name": "Tillsammans: Open Basic Europatipset",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Open Basic Europatipset"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event44"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RLc1167cceefb749a09a8049c694dc5eaf",
        "name": "GrÃ¤sroten: Avsluta mitt stÃ¶d",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Avsluta mitt stÃ¶d"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar31",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event34"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL5488c69d80b5418f85aa1ef68ba3d7c8",
        "name": "subscription: changed",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "startsWith",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Changed"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar28",
                    "type": "value",
                    "value": "%event.detail.event%"
                  },
                  {
                    "name": "eVar29",
                    "type": "value",
                    "value": "%event.detail.eventInfo.eventPoints%"
                  },
                  {
                    "name": "eVar30",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event29"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL1694ca72d3114aec9454081b8798bef6",
        "name": "Kundservice: Search",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Search"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar32",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event35"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL69eccfab90c3414ebf5e5e75db3069a6",
        "name": "Game Chooser",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Game Chooser"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar35",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event38"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL11bd0c9f2de744ed8aff9377e3941473",
        "name": "Form: Avsluta formulÃ¤r",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Avsluta formulÃ¤r"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar34",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event37"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL47aad6bf78d14d7ab0230cddbfe75815",
        "name": "Search Oddset",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.eventInfo.type%",
              "rightOperand": "search-oddset"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar32",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event39"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL6321be8ce4da4bc49f5696884ba30d31",
        "name": "subscription: reactivate",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "startsWith",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Reactivate"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar28",
                    "type": "value",
                    "value": "%event.detail.event%"
                  },
                  {
                    "name": "eVar29",
                    "type": "value",
                    "value": "%event.detail.eventInfo.eventPoints%"
                  },
                  {
                    "name": "eVar30",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event31"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RLa5711bed0cbc4ccb9d668bb0a2cb7bdf",
        "name": "Tillsammans: Create Team",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Created team"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event40"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL059ca36705164a29a796d30d51ad8d10",
        "name": "Tillsammans: Open Basic Stryktipset",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Open Basic Stryktipset"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event41"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RLf6cababb19c84df79aeae37c743a4a83",
        "name": "spelpaus: activate",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Activate"
            }
          },
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.eventInfo.type%",
              "rightOperand": "Spelpaus"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "customSetup": {
                "source": function(event, s) {
                  try{
                    var arr = event.detail.eventInfo.eventLabel.split(":");
                    s.eVar26 = arr[0];
                    s.eVar27 = arr[1];
                    s.linkTrackVars = "eVar26,eVar27,events";
                  }catch(e){}
                }
              },
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar26",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event20"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL9b1538a855a94a22bf6fb26ca6bbf774",
        "name": "Tillsammans: Open Advanced Stryktipset",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Open Advanced Stryktipset"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event42"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RLc470c894cb9b4ec487d0a185f4b28d46",
        "name": "deposit_limit: decrease",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "decrease"
            }
          },
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals"
              },
              "leftOperand": "%event.detail.eventInfo.type%",
              "rightOperand": "deposit_limit"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event14"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL346f4efc46c843f89c826342566f9259",
        "name": "Cookie Delete",
        "events": [
          {
            "modulePath": "core/src/lib/events/libraryLoaded.js",
            "settings": {
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [

        ],
        "actions": [
          {
            "modulePath": "core/src/lib/actions/customCode.js",
            "settings": {
              "source": "try{\n  document.cookie = 'mbox=;path=/;domain=svenskaspel.se;expires=Thu, 01 Jan 1970 00:00:01 GMT;';\n}catch(e){}",
              "language": "javascript"
            }
          }
        ]
      },
      {
        "id": "RL5593393c103a46f8a75326bc63af3d60",
        "name": "Tillsammans: Cancel Bet",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Cancel"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event43"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL1570feb540b84539b098ebf8596475f3",
        "name": "Tillsammans: Open Advanced Europatipset ",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Open Advanced Europatipset"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event45"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL4be68d4a4cb5410a82dd3bb235547230",
        "name": "subscription: started more",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "startsWith",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Started More"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar28",
                    "type": "value",
                    "value": "%event.detail.event%"
                  },
                  {
                    "name": "eVar29",
                    "type": "value",
                    "value": "%event.detail.eventInfo.eventPoints%"
                  },
                  {
                    "name": "eVar30",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event28"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RLf31fd762ca814b5cab7c2bca67e36fef",
        "name": "subscription: triss",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Started : Triss"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar28",
                    "type": "value",
                    "value": "%event.detail.event%"
                  },
                  {
                    "name": "eVar29",
                    "type": "value",
                    "value": "%event.detail.eventInfo.eventPoints%"
                  }
                ],
                "events": [
                  {
                    "name": "event30"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL79033f76c43643fd9aecd4ccf50b3e27",
        "name": "subscription: not registered ",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "startsWith",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Initialize First"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar28",
                    "type": "value",
                    "value": "%event.detail.event%"
                  },
                  {
                    "name": "eVar29",
                    "type": "value",
                    "value": "%event.detail.eventInfo.eventPoints%"
                  }
                ],
                "events": [
                  {
                    "name": "event27"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL23f7779e8d614a678b43baa393cf8dd0",
        "name": "subscription: end",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "startsWith",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Ended"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar28",
                    "type": "value",
                    "value": "%event.detail.event%"
                  },
                  {
                    "name": "eVar29",
                    "type": "value",
                    "value": "%event.detail.eventInfo.eventPoints%"
                  },
                  {
                    "name": "eVar30",
                    "type": "value",
                    "value": "%event.detail.eventInfo.effect%"
                  }
                ],
                "events": [
                  {
                    "name": "event32"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          }
        ]
      },
      {
        "id": "RL659ba29fb5b4401a941fb08ec5ed0359",
        "name": "content: pageview",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 80.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/customCode.js",
            "settings": {
              "source": function(event, target) {
                try{
                  _satellite.logger.log("Datalayer Value :" + JSON.stringify(event.detail));
                  if(event.detail.event == "pageview"){
                    var pid = decodeURIComponent(event.detail.page.pageInfo.pageID)
                    var cat = pid.split('/');
                    _satellite.setVar("site section: level1",cat[1]);
                    _satellite.setVar("site section: level2",cat[2]);
                    _satellite.setVar("site section: pageID",pid);
                    return true;
                  }

                }catch(e){_satellite.logger.log(e)}
              }
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "customSetup": {
                "source": function(event, s) {
                  try{
                    if( ! event.detail.page.pageInfo.sysEnv || event.detail.page.pageInfo.sysEnv != "" ){
                      sessionStorage.setItem("systemEnv", event.detail.page.pageInfo.sysEnv );
                    }
                    if(document.location.pathname == "/logga-in"){
                      s.events=s.apl(s.events,"event3",",",2);
                    }
                  }catch(e){}
                }
              },
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar1",
                    "type": "value",
                    "value": "%site section: level1%"
                  },
                  {
                    "name": "eVar2",
                    "type": "value",
                    "value": "%site section: level2%"
                  },
                  {
                    "name": "eVar3",
                    "type": "value",
                    "value": "%event.detail.page.pageInfo.destinationURL%"
                  },
                  {
                    "name": "eVar4",
                    "type": "value",
                    "value": "%event.detail.page.pageInfo.pageID%"
                  },
                  {
                    "name": "eVar5",
                    "type": "value",
                    "value": "%event.detail.page.pageInfo.sysEnv%"
                  },
                  {
                    "name": "eVar37",
                    "type": "value",
                    "value": "%ACC Broadlog Id%"
                  }
                ],
                "props": [
                  {
                    "name": "prop1",
                    "type": "alias",
                    "value": "eVar2"
                  },
                  {
                    "name": "prop3",
                    "type": "alias",
                    "value": "eVar3"
                  },
                  {
                    "name": "prop4",
                    "type": "alias",
                    "value": "eVar4"
                  },
                  {
                    "name": "prop5",
                    "type": "alias",
                    "value": "eVar5"
                  }
                ],
                "server": "%domain%",
                "channel": "%site section: level1%",
                "campaign": {
                  "type": "queryParam",
                  "value": "cid"
                },
                "pageName": "%content: modified page name%"
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "page"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RLf36085d700a148ba962c37ce3b9d41e0",
        "name": "content: product view",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 40.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/customCode.js",
            "settings": {
              "source": function(event, target) {
                try{
                  if(event.detail.event == "pageview"){
                    var cat = event.detail.page.pageInfo.destinationURL.split('/');
                    _satellite.setVar("site section: level1",cat[1]);
                    _satellite.setVar("site section: level2",cat[2]);
                    _satellite.setVar("site section: pageID",event.detail.page.pageInfo.pageID);
                    return true;
                  }

                }catch(e){_satellite.logger.log(e)}
              }
            }
          },
          {
            "modulePath": "core/src/lib/conditions/customCode.js",
            "settings": {
              "source": function(event, target) {
                try{
                  var a = decodeURIComponent(event.detail.page.pageInfo.pageID);
                  var cat = a.split("/");
                  var gm1 = ["stryktipset", "europatipset", "topptipset", "powerplay"];
                  var gm2 = ["maltipset", "challenge","bomben"]
                  var gm3 = ["casino","matchen","bingo"];
                  var gm4 = ["oddset"];
                  if(cat.length == 3 && gm1.indexOf(cat[1]) > -1 ){
                    _satellite.setVar("productView: product", ";" + cat[1]);
                    return true;
                  }else if(cat.length == 5 && gm2.indexOf(cat[1]) > -1 ){
                    _satellite.setVar("productView: product",  ";" + cat[1]);
                    return true;
                  }else if(cat.length == 4 && gm3.indexOf(cat[1]) > -1 ){
                    if(cat[1] == "casino"){
                      _satellite.setVar("productView: product", ";" + cat[3]);
                    }else{
                      _satellite.setVar("productView: product", ";" + cat[1]);
                    }

                    return true;
                  }else if(cat.length == 2 && gm4.indexOf(cat[1]) > -1 ){
                    _satellite.setVar("productView: product", ";" + cat[1]);
                    return true;
                  }

                }catch(e){}
              }
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "customSetup": {
                "source": function(event, s) {
                  s.products = _satellite.getVar("productView: product");
                  s.eVar7 = s.products.replace(";","");    
                  var pp = sessionStorage.getItem("s_eVar38");
                  if(pp)
                    s.eVar38 = sessionStorage.getItem("s_eVar38");
                  sessionStorage.setItem("s_eVar38",s.products.substring(1));
                  _satellite.logger.log("Set the Product View")

                }
              },
              "trackerProperties": {
                "events": [
                  {
                    "id": "%random id%",
                    "name": "prodView"
                  }
                ]
              }
            }
          }
        ]
      },
      {
        "id": "RLdd0babb186ef40cd9cabc367774f08f2",
        "name": "transaction: purchase",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "transaction"
            }
          },
          {
            "modulePath": "core/src/lib/conditions/customCode.js",
            "settings": {
              "source": function(event, target) {
                try{
                  var tn = event.detail.transaction;
                  _satellite.logger.log(event.detail);
                  _satellite.setVar("transaction: product id", tn.item[0].productInfo.productID);
                  _satellite.setVar("transaction: product name", tn.item[0].productInfo.productName);
                  _satellite.setVar("transaction: quickpick", tn.item[0].productInfo.quickpick);
                  _satellite.setVar("transaction: prolong", tn.item[0].productInfo.prolong);
                  _satellite.setVar("transaction: rounds", tn.item[0].productInfo.rounds);
                  _satellite.setVar("transaction: bag", tn.item[0].productInfo.bag);
                  _satellite.setVar("transaction: system", tn.item[0].productInfo.system);
                  _satellite.setVar("transaction: syndicate", tn.item[0].productInfo.syndicate);
                  return true;

                }catch(e){}
              }
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "customSetup": {
                "source": function(event, s) {

                  var t = event.detail.transaction.total.transactionTotal || 0;
                  var q = event.detail.transaction.item[0].quantity || 0;
                  var p = event.detail.transaction.item[0].productInfo.productName;
                  _satellite.logger.log("purchaseid:" + event.detail.transaction.transactionID);
                  _satellite.logger.log("Total:" + t);
                  _satellite.logger.log("Quantity:" + q);
                  _satellite.logger.log("Event Name:" + event.detail.eventInfo.eventName);

                  if(p){
                    p = p.toLowerCase();
                    if(p.indexOf("topptipset") > -1){
                      p = "topptipset";
                    }
                    if(p.indexOf("oddset") > -1){
                      p = "oddset";
                    }
                    s.products=";"+p + ";" + q + ";" + t ;
                  }
                  _satellite.logger.log("Products:" + s.products);
                  s.purchaseID=event.detail.transaction.transactionID;
                  s.linkTrackVars=s.apl(s.linkTrackVars,"products",",",2);
                }
              },
              "trackerProperties": {
                "eVars": [
                  {
                    "name": "eVar6",
                    "type": "value",
                    "value": "%event.detail.transaction. transactionMethod%"
                  },
                  {
                    "name": "eVar7",
                    "type": "value",
                    "value": "%transaction: product name%"
                  },
                  {
                    "name": "eVar8",
                    "type": "value",
                    "value": "%transaction: quickpick%"
                  },
                  {
                    "name": "eVar9",
                    "type": "value",
                    "value": "%transaction: prolong%"
                  },
                  {
                    "name": "eVar10",
                    "type": "value",
                    "value": "%transaction: rounds%"
                  },
                  {
                    "name": "eVar11",
                    "type": "value",
                    "value": "%transaction: bag%"
                  },
                  {
                    "name": "eVar12",
                    "type": "value",
                    "value": "%transaction: system%"
                  },
                  {
                    "name": "eVar13",
                    "type": "value",
                    "value": "%transaction: syndicate%"
                  }
                ],
                "events": [
                  {
                    "name": "purchase"
                  }
                ],
                "transactionID": "%event.detail.transaction.transactionID%"
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkName": "purchase",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL600ec683766042be8f3cd7a6ab349561",
        "name": "deposit_limit: set",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "set"
            }
          },
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals"
              },
              "leftOperand": "%event.detail.eventInfo.type%",
              "rightOperand": "deposit_limit"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event15"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      },
      {
        "id": "RL7fe1b3fee7474b8ebf616ba0d2970dc1",
        "name": "deposit_limit: increase",
        "events": [
          {
            "modulePath": "core/src/lib/events/directCall.js",
            "settings": {
              "identifier": "datalayerPush"
            },
            "ruleOrder": 50.0
          }
        ],
        "conditions": [
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals",
                "caseInsensitive": true
              },
              "leftOperand": "%event.detail.event%",
              "rightOperand": "Increase"
            }
          },
          {
            "modulePath": "core/src/lib/conditions/valueComparison.js",
            "settings": {
              "comparison": {
                "operator": "equals"
              },
              "leftOperand": "%event.detail.eventInfo.type%",
              "rightOperand": "deposit_limit"
            }
          }
        ],
        "actions": [
          {
            "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
            "settings": {
              "trackerProperties": {
                "events": [
                  {
                    "name": "event13"
                  }
                ]
              }
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
            "settings": {
              "type": "link",
              "linkType": "o"
            }
          },
          {
            "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
            "settings": {
            }
          }
        ]
      }
    ]
  }
})();

var _satellite = (function () {
  'use strict';

  if (!window.atob) { console.warn('Adobe Launch is unsupported in IE 9 and below.'); return; }


  var levels = {
    LOG: 'log',
    INFO: 'info',
    DEBUG: 'debug',
    WARN: 'warn',
    ERROR: 'error'
  };

  var ROCKET = '\uD83D\uDE80';

  var ieVersion = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]);

  var launchPrefix = ieVersion === 10 ? '[Launch]' : ROCKET;

  var outputEnabled = false;

  var process = function(level) {
    if (outputEnabled && window.console) {
      var logArguments = Array.prototype.slice.call(arguments, 1);
      logArguments.unshift(launchPrefix);
      if (level === levels.DEBUG && !window.console[level]) {
        level = levels.INFO;
      }
      window.console[level].apply(window.console, logArguments);
    }
  };

  var log = process.bind(null, levels.LOG);

  var info = process.bind(null, levels.INFO);

  var debug = process.bind(null, levels.DEBUG);

  var warn = process.bind(null, levels.WARN);

  var error = process.bind(null, levels.ERROR);

  var logger = {
    log: log,
    info: info,
    debug: debug,
    warn: warn,
    error: error,
    get outputEnabled() {
      return outputEnabled;
    },
    set outputEnabled(value) {
      outputEnabled = value;
    },
    createPrefixedLogger: function(identifier) {
      var loggerSpecificPrefix = '[' + identifier + ']';

      return {
        log: log.bind(null, loggerSpecificPrefix),
        info: info.bind(null, loggerSpecificPrefix),
        debug: debug.bind(null, loggerSpecificPrefix),
        warn: warn.bind(null, loggerSpecificPrefix),
        error: error.bind(null, loggerSpecificPrefix)
      };
    }
  };




  var createReplaceTokens = function(isVar, getVar, undefinedVarsReturnEmpty) {
    var replaceTokensInString;
    var replaceTokensInObject;
    var replaceTokensInArray;
    var replaceTokens;
    var variablesBeingRetrieved = [];

    var getVarValue = function(token, variableName, syntheticEvent) {
      if (!isVar(variableName)) {
        return token;
      }

      variablesBeingRetrieved.push(variableName);
      var val = getVar(variableName, syntheticEvent);
      variablesBeingRetrieved.pop();
      return val == null && undefinedVarsReturnEmpty ? '' : val;
    };

    replaceTokensInString = function(str, syntheticEvent) {
      var result = /^%([^%]+)%$/.exec(str);

      if (result) {
        return getVarValue(str, result[1], syntheticEvent);
      } else {
        return str.replace(/%(.+?)%/g, function(token, variableName) {
          return getVarValue(token, variableName, syntheticEvent);
        });
      }
    };

    replaceTokensInObject = function(obj, syntheticEvent) {
      var ret = {};
      var keys = Object.keys(obj);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = obj[key];
        ret[key] = replaceTokens(value, syntheticEvent);
      }
      return ret;
    };

    replaceTokensInArray = function(arr, syntheticEvent) {
      var ret = [];
      for (var i = 0, len = arr.length; i < len; i++) {
        ret.push(replaceTokens(arr[i], syntheticEvent));
      }
      return ret;
    };

    replaceTokens = function(thing, syntheticEvent) {
      if (typeof thing === 'string') {
        return replaceTokensInString(thing, syntheticEvent);
      } else if (Array.isArray(thing)) {
        return replaceTokensInArray(thing, syntheticEvent);
      } else if (typeof thing === 'object' && thing !== null) {
        return replaceTokensInObject(thing, syntheticEvent);
      }

      return thing;
    };

    return function(thing, syntheticEvent) {
      if (variablesBeingRetrieved.length > 10) {
        logger.error('Data element circular reference detected: ' +
          variablesBeingRetrieved.join(' -> '));
        return thing;
      }

      return replaceTokens(thing, syntheticEvent);
    };
  };


  var createSetCustomVar = function(customVars) {
    return function() {
      if (typeof arguments[0] === 'string') {
        customVars[arguments[0]] = arguments[1];
      } else if (arguments[0]) { 
        var mapping = arguments[0];
        for (var key in mapping) {
          customVars[key] = mapping[key];
        }
      }
    };
  };


  var cleanText = function(str) {
    return typeof str === 'string' ? str.replace(/\s+/g, ' ').trim() : str;
  };

  function createCommonjsModule(fn, module) {
    return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var js_cookie = createCommonjsModule(function (module, exports) {
    (function (factory) {
      var registeredInModuleLoader;
      if (typeof undefined === 'function' && undefined.amd) {
        undefined(factory);
        registeredInModuleLoader = true;
      }
      {
        module.exports = factory();
        registeredInModuleLoader = true;
      }
      if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function () {
          window.Cookies = OldCookies;
          return api;
        };
      }
    }(function () {
      function extend () {
        var i = 0;
        var result = {};
        for (; i < arguments.length; i++) {
          var attributes = arguments[ i ];
          for (var key in attributes) {
            result[key] = attributes[key];
          }
        }
        return result;
      }

      function decode (s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }

      function init (converter) {
        function api() {}

        function set (key, value, attributes) {
          if (typeof document === 'undefined') {
            return;
          }

          attributes = extend({
            path: '/'
          }, api.defaults, attributes);

          if (typeof attributes.expires === 'number') {
            attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
          }

          attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

          try {
            var result = JSON.stringify(value);
            if (/^[\{\[]/.test(result)) {
              value = result;
            }
          } catch (e) {}

          value = converter.write ?
            converter.write(value, key) :
            encodeURIComponent(String(value))
            .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

          key = encodeURIComponent(String(key))
          .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
          .replace(/[\(\)]/g, escape);

          var stringifiedAttributes = '';
          for (var attributeName in attributes) {
            if (!attributes[attributeName]) {
              continue;
            }
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) {
              continue;
            }

            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
          }

          return (document.cookie = key + '=' + value + stringifiedAttributes);
        }

        function get (key, json) {
          if (typeof document === 'undefined') {
            return;
          }

          var jar = {};
          var cookies = document.cookie ? document.cookie.split('; ') : [];
          var i = 0;

          for (; i < cookies.length; i++) {
            var parts = cookies[i].split('=');
            var cookie = parts.slice(1).join('=');

            if (!json && cookie.charAt(0) === '"') {
              cookie = cookie.slice(1, -1);
            }

            try {
              var name = decode(parts[0]);
              cookie = (converter.read || converter)(cookie, name) ||
                decode(cookie);

              if (json) {
                try {
                  cookie = JSON.parse(cookie);
                } catch (e) {}
              }

              jar[name] = cookie;

              if (key === name) {
                break;
              }
            } catch (e) {}
          }

          return key ? jar[key] : jar;
        }

        api.set = set;
        api.get = function (key) {
          return get(key, false );
        };
        api.getJSON = function (key) {
          return get(key, true );
        };
        api.remove = function (key, attributes) {
          set(key, '', extend(attributes, {
            expires: -1
          }));
        };

        api.defaults = {};

        api.withConverter = init;

        return api;
      }

      return init(function () {});
    }));
  });

  'use strict';



  var reactorCookie = {
    get: js_cookie.get,
    set: js_cookie.set,
    remove: js_cookie.remove
  };

  'use strict';

  var reactorWindow = window;



  var NAMESPACE = 'com.adobe.reactor.';

  var getNamespacedStorage = function(storageType, additionalNamespace) {
    var finalNamespace = NAMESPACE + (additionalNamespace || '');

    return {
      getItem: function(name) {
        try {
          return reactorWindow[storageType].getItem(finalNamespace + name);
        } catch (e) {
          return null;
        }
      },
      setItem: function(name, value) {
        try {
          reactorWindow[storageType].setItem(finalNamespace + name, value);
          return true;
        } catch (e) {
          return false;
        }
      }
    };
  };





  var COOKIE_PREFIX = '_sdsat_';

  var DATA_ELEMENTS_NAMESPACE = 'dataElements.';
  var MIGRATED_KEY = 'dataElementCookiesMigrated';

  var reactorLocalStorage = getNamespacedStorage('localStorage');
  var dataElementSessionStorage = getNamespacedStorage('sessionStorage', DATA_ELEMENTS_NAMESPACE);
  var dataElementLocalStorage = getNamespacedStorage('localStorage', DATA_ELEMENTS_NAMESPACE);

  var storageDurations = {
    PAGEVIEW: 'pageview',
    SESSION: 'session',
    VISITOR: 'visitor'
  };

  var pageviewCache = {};

  var serialize = function(value) {
    var serialized;

    try {
      serialized = JSON.stringify(value);
    } catch (e) {}

    return serialized;
  };

  var setValue = function(key, storageDuration, value) {
    var serializedValue;

    switch (storageDuration) {
      case storageDurations.PAGEVIEW:
        pageviewCache[key] = value;
        return;
      case storageDurations.SESSION:
        serializedValue = serialize(value);
        if (serializedValue) {
          dataElementSessionStorage.setItem(key, serializedValue);
        }
        return;
      case storageDurations.VISITOR:
        serializedValue = serialize(value);
        if (serializedValue) {
          dataElementLocalStorage.setItem(key, serializedValue);
        }
        return;
    }
  };

  var getValue = function(key, storageDuration) {
    var value;

    switch (storageDuration) {
      case storageDurations.PAGEVIEW:
        return pageviewCache.hasOwnProperty(key) ? pageviewCache[key] : null;
      case storageDurations.SESSION:
        value = dataElementSessionStorage.getItem(key);
        return value === null ? value : JSON.parse(value);
      case storageDurations.VISITOR:
        value = dataElementLocalStorage.getItem(key);
        return value === null ? value : JSON.parse(value);
    }
  };

  var migrateDataElement = function(dataElementName, storageDuration) {
    var storedValue = reactorCookie.get(COOKIE_PREFIX + dataElementName);

    if (storedValue !== undefined) {
      setValue(dataElementName, storageDuration, storedValue);
    }
  };

  var migrateCookieData = function(dataElements) {
    if (!reactorLocalStorage.getItem(MIGRATED_KEY)) {
      Object.keys(dataElements).forEach(function(dataElementName) {
        migrateDataElement(dataElementName, dataElements[dataElementName].storageDuration);
      });

      reactorLocalStorage.setItem(MIGRATED_KEY, true);
    }
  };

  var dataElementSafe = {
    setValue: setValue,
    getValue: getValue,
    migrateCookieData: migrateCookieData
  };






  var getErrorMessage = function(dataDef, dataElementName, errorMessage, errorStack) {
    return 'Failed to execute data element module ' + dataDef.modulePath + ' for data element ' +
      dataElementName + '. ' + errorMessage + (errorStack ? '\n' + errorStack : '');
  };

  var isDataElementValuePresent = function(value) {
    return value !== undefined && value !== null;
  };

  var createGetDataElementValue = function(
    moduleProvider,
    getDataElementDefinition,
    replaceTokens,
    undefinedVarsReturnEmpty
  ) {
    return function(name, syntheticEvent) {
      var dataDef = getDataElementDefinition(name);

      if (!dataDef) {
        return undefinedVarsReturnEmpty ? '' : null;
      }

      var storageDuration = dataDef.storageDuration;
      var moduleExports;

      try {
        moduleExports = moduleProvider.getModuleExports(dataDef.modulePath);
      } catch (e) {
        logger.error(getErrorMessage(dataDef, name, e.message, e.stack));
        return;
      }

      if (typeof moduleExports !== 'function') {
        logger.error(getErrorMessage(dataDef, name, 'Module did not export a function.'));
        return;
      }

      var value;

      try {
        value = moduleExports(replaceTokens(dataDef.settings, syntheticEvent), syntheticEvent);
      } catch (e) {
        logger.error(getErrorMessage(dataDef, name, e.message, e.stack));
        return;
      }

      if (storageDuration) {
        if (isDataElementValuePresent(value)) {
          dataElementSafe.setValue(name, storageDuration, value);
        } else {
          value = dataElementSafe.getValue(name, storageDuration);
        }
      }

      if (!isDataElementValuePresent(value)) {
        value = dataDef.defaultValue || '';
      }

      if (typeof value === 'string') {
        if (dataDef.cleanText) {
          value = cleanText(value);
        }

        if (dataDef.forceLowerCase) {
          value = value.toLowerCase();
        }
      }

      return value;
    };
  };


  var extractModuleExports = function(script, require, turbine) {
    var module = {
      exports: {}
    };

    script.call(module.exports, module, module.exports, require, turbine);

    return module.exports;
  };





  var createModuleProvider = function() {
    var moduleByReferencePath = {};

    var getModule = function(referencePath) {
      var module = moduleByReferencePath[referencePath];

      if (!module) {
        throw new Error('Module ' + referencePath + ' not found.');
      }

      return module;
    };

    var registerModule = function(referencePath, moduleDefinition, extensionName, require, turbine) {
      var module = {
        definition: moduleDefinition,
        extensionName: extensionName,
        require: require,
        turbine: turbine
      };
      module.require = require;
      moduleByReferencePath[referencePath] = module;
    };

    var hydrateCache = function() {
      Object.keys(moduleByReferencePath).forEach(function(referencePath) {
        try {
          getModuleExports(referencePath);
        } catch (e) {
          var errorMessage = 'Error initializing module ' + referencePath + '. ' +
            e.message + (e.stack ? '\n' + e.stack : '');
          logger.error(errorMessage);
        }
      });
    };

    var getModuleExports = function(referencePath) {
      var module = getModule(referencePath);

      if (!module.hasOwnProperty('exports')) {
        module.exports = extractModuleExports(module.definition.script, module.require,
          module.turbine);
      }

      return module.exports;
    };

    var getModuleDefinition = function(referencePath) {
      return getModule(referencePath).definition;
    };

    var getModuleExtensionName = function(referencePath) {
      return getModule(referencePath).extensionName;
    };

    return {
      registerModule: registerModule,
      hydrateCache: hydrateCache,
      getModuleExports: getModuleExports,
      getModuleDefinition: getModuleDefinition,
      getModuleExtensionName: getModuleExtensionName
    };
  };


  var createIsVar = function(customVars, getDataElementDefinition) {
    return function(variableName) {
      var nameBeforeDot = variableName.split('.')[0];

      return Boolean(
        getDataElementDefinition(variableName) ||
        nameBeforeDot === 'this' ||
        nameBeforeDot === 'event' ||
        nameBeforeDot === 'target' ||
        customVars.hasOwnProperty(nameBeforeDot)
      );
    };
  };




  var specialPropertyAccessors = {
    text: function(obj) {
      return obj.textContent;
    },
    cleanText: function(obj) {
      return cleanText(obj.textContent);
    }
  };

  var getObjectProperty = function(host, propChain, supportSpecial) {
    var value = host;
    var attrMatch;
    for (var i = 0, len = propChain.length; i < len; i++) {
      if (value == null) {
        return undefined;
      }
      var prop = propChain[i];
      if (supportSpecial && prop.charAt(0) === '@') {
        var specialProp = prop.slice(1);
        value = specialPropertyAccessors[specialProp](value);
        continue;
      }
      if (value.getAttribute &&
        (attrMatch = prop.match(/^getAttribute\((.+)\)$/))) {
        var attr = attrMatch[1];
        value = value.getAttribute(attr);
        continue;
      }
      value = value[prop];
    }
    return value;
  };

  var createGetVar = function(customVars, getDataElementDefinition, getDataElementValue) {
    return function(variable, syntheticEvent) {
      var value;

      if (getDataElementDefinition(variable)) {
        value = getDataElementValue(variable, syntheticEvent);
      } else {
        var propChain = variable.split('.');
        var variableHostName = propChain.shift();

        if (variableHostName === 'this') {
          if (syntheticEvent) {
            value = getObjectProperty(syntheticEvent.element, propChain, true);
          }
        } else if (variableHostName === 'event') {
          if (syntheticEvent) {
            value = getObjectProperty(syntheticEvent, propChain);
          }
        } else if (variableHostName === 'target') {
          if (syntheticEvent) {
            value = getObjectProperty(syntheticEvent.target, propChain);
          }
        } else {
          value = getObjectProperty(customVars[variableHostName], propChain);
        }
      }

      return value;
    };
  };


  var createGetSharedModuleExports = function(extensions, moduleProvider) {
    return function(extensionName, moduleName) {
      var extension = extensions[extensionName];

      if (extension) {
        var modules = extension.modules;
        if (modules) {
          var referencePaths = Object.keys(modules);
          for (var i = 0; i < referencePaths.length; i++) {
            var referencePath = referencePaths[i];
            var module = modules[referencePath];
            if (module.shared && module.name === moduleName) {
              return moduleProvider.getModuleExports(referencePath);
            }
          }
        }
      }
    };
  };


  var createGetExtensionSettings = function(replaceTokens, settings) {
    return function() {
      return settings ? replaceTokens(settings) : {};
    };
  };



  var createGetHostedLibFileUrl = function(hostedLibFilesBaseUrl, minified) {
    return function(file) {
      if (minified) {
        var fileParts = file.split('.');
        fileParts.splice(fileParts.length - 1 || 1, 0, 'min');
        file = fileParts.join('.');
      }

      return hostedLibFilesBaseUrl + file;
    };
  };


  var JS_EXTENSION = '.js';

  var dirname = function(path) {
    return path.substr(0, path.lastIndexOf('/'));
  };

  var endsWith = function(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
  };

  var resolveRelativePath = function(fromPath, relativePath) {
    if (!endsWith(relativePath, JS_EXTENSION)) {
      relativePath = relativePath + JS_EXTENSION;
    }

    var relativePathSegments = relativePath.split('/');
    var resolvedPathSegments = dirname(fromPath).split('/');

    relativePathSegments.forEach(function(relativePathSegment) {
      if (!relativePathSegment || relativePathSegment === '.') {
        return;
      } else if (relativePathSegment === '..') {
        if (resolvedPathSegments.length) {
          resolvedPathSegments.pop();
        }
      } else {
        resolvedPathSegments.push(relativePathSegment);
      }
    });

    return resolvedPathSegments.join('/');
  };

  'use strict';

  var reactorDocument = document;

  function finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(
      function(value) {
        return constructor.resolve(callback()).then(function() {
          return value;
        });
      },
      function(reason) {
        return constructor.resolve(callback()).then(function() {
          return constructor.reject(reason);
        });
      }
    );
  }

  var setTimeoutFunc = setTimeout;

  function isArray(x) {
    return Boolean(x && typeof x.length !== 'undefined');
  }

  function noop() {}

  function bind(fn, thisArg) {
    return function() {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (!(this instanceof Promise))
      throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function() {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      if (newValue === self)
        throw new TypeError('A promise cannot be resolved with itself.');
      if (
        newValue &&
        (typeof newValue === 'object' || typeof newValue === 'function')
      ) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function() {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  function doResolve(fn, self) {
    var done = false;
    try {
      fn(
        function(value) {
          if (done) return;
          done = true;
          resolve(self, value);
        },
        function(reason) {
          if (done) return;
          done = true;
          reject(self, reason);
        }
      );
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function(onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function(onFulfilled, onRejected) {
    var prom = new this.constructor(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.prototype['finally'] = finallyConstructor;

  Promise.all = function(arr) {
    return new Promise(function(resolve, reject) {
      if (!isArray(arr)) {
        return reject(new TypeError('Promise.all accepts an array'));
      }

      var args = Array.prototype.slice.call(arr);
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(
                val,
                function(val) {
                  res(i, val);
                },
                reject
              );
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function(value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function(resolve) {
      resolve(value);
    });
  };

  Promise.reject = function(value) {
    return new Promise(function(resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function(arr) {
    return new Promise(function(resolve, reject) {
      if (!isArray(arr)) {
        return reject(new TypeError('Promise.race accepts an array'));
      }

      for (var i = 0, len = arr.length; i < len; i++) {
        Promise.resolve(arr[i]).then(resolve, reject);
      }
    });
  };

  Promise._immediateFn =
    (typeof setImmediate === 'function' &&
      function(fn) {
        setImmediate(fn);
      }) ||
    function(fn) {
      setTimeoutFunc(fn, 0);
    };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); 
    }
  };




  var src$2 = Object.freeze({
    default: Promise
  });

  var require$$0 = ( src$2 && Promise ) || src$2;

  'use strict';

  var reactorPromise =
    window.Promise ||
    require$$0.default ||
    require$$0;

  'use strict';



  var getPromise = function(url, script) {
    return new reactorPromise(function(resolve, reject) {
      script.onload = function() {
        resolve(script);
      };

      script.onerror = function() {
        reject(new Error('Failed to load script ' + url));
      };
    });
  };

  var reactorLoadScript = function(url) {
    var script = document.createElement('script');
    script.src = url;
    script.async = true;

    var promise = getPromise(url, script);

    document.getElementsByTagName('head')[0].appendChild(script);
    return promise;
  };


  'use strict';
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }


      var test1 = new String('abc');  
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !==
        'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      return false;
    }
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };

  'use strict';

  var reactorObjectAssign = objectAssign;


  'use strict';

  function hasOwnProperty$1(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  var decode = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};

    if (typeof qs !== 'string' || qs.length === 0) {
      return obj;
    }

    var regexp = /\+/g;
    qs = qs.split(sep);

    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') {
      maxKeys = options.maxKeys;
    }

    var len = qs.length;
    if (maxKeys > 0 && len > maxKeys) {
      len = maxKeys;
    }

    for (var i = 0; i < len; ++i) {
      var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

      if (idx >= 0) {
        kstr = x.substr(0, idx);
        vstr = x.substr(idx + 1);
      } else {
        kstr = x;
        vstr = '';
      }

      k = decodeURIComponent(kstr);
      v = decodeURIComponent(vstr);

      if (!hasOwnProperty$1(obj, k)) {
        obj[k] = v;
      } else if (Array.isArray(obj[k])) {
        obj[k].push(v);
      } else {
        obj[k] = [obj[k], v];
      }
    }

    return obj;
  };


  'use strict';

  var stringifyPrimitive = function(v) {
    switch (typeof v) {
      case 'string':
        return v;

      case 'boolean':
        return v ? 'true' : 'false';

      case 'number':
        return isFinite(v) ? v : '';

      default:
        return '';
    }
  };

  var encode = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) {
      obj = undefined;
    }

    if (typeof obj === 'object') {
      return Object.keys(obj).map(function(k) {
        var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
        if (Array.isArray(obj[k])) {
          return obj[k].map(function(v) {
            return ks + encodeURIComponent(stringifyPrimitive(v));
          }).join(sep);
        } else {
          return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
        }
      }).join(sep);

    }

    if (!name) return '';
    return encodeURIComponent(stringifyPrimitive(name)) + eq +
      encodeURIComponent(stringifyPrimitive(obj));
  };

  var querystring = createCommonjsModule(function (module, exports) {
    'use strict';

    exports.decode = exports.parse = decode;
    exports.encode = exports.stringify = encode;
  });

  'use strict';



  var reactorQueryString = {
    parse: function(string) {
      if (typeof string === 'string') {
        string = string.trim().replace(/^[?#&]/, '');
      }
      return querystring.parse(string);
    },
    stringify: function(object) {
      return querystring.stringify(object);
    }
  };


  var CORE_MODULE_PREFIX = '@adobe/reactor-';

  var modules = {
    'cookie': reactorCookie,
    'document': reactorDocument,
    'load-script': reactorLoadScript,
    'object-assign': reactorObjectAssign,
    'promise': reactorPromise,
    'query-string': reactorQueryString,
    'window': reactorWindow
  };

  var createPublicRequire = function(getModuleExportsByRelativePath) {
    return function(key) {
      if (key.indexOf(CORE_MODULE_PREFIX) === 0) {
        var keyWithoutScope = key.substr(CORE_MODULE_PREFIX.length);
        var module = modules[keyWithoutScope];

        if (module) {
          return module;
        }
      }

      if (key.indexOf('./') === 0 || key.indexOf('../') === 0) {
        return getModuleExportsByRelativePath(key);
      }

      throw new Error('Cannot resolve module "' + key + '".');
    };
  };









  var hydrateModuleProvider = function(container, moduleProvider, replaceTokens, getDataElementValue) {
    var extensions = container.extensions;
    var buildInfo = container.buildInfo;
    var propertySettings = container.property.settings;

    if (extensions) {
      var getSharedModuleExports = createGetSharedModuleExports(extensions, moduleProvider);

      Object.keys(extensions).forEach(function(extensionName) {
        var extension = extensions[extensionName];
        var getExtensionSettings = createGetExtensionSettings(replaceTokens, extension.settings);

        if (extension.modules) {
          var prefixedLogger = logger.createPrefixedLogger(extension.displayName);
          var getHostedLibFileUrl = createGetHostedLibFileUrl(
            extension.hostedLibFilesBaseUrl,
            buildInfo.minified
          );
          var turbine = {
            buildInfo: buildInfo,
            getDataElementValue: getDataElementValue,
            getExtensionSettings: getExtensionSettings,
            getHostedLibFileUrl: getHostedLibFileUrl,
            getSharedModule: getSharedModuleExports,
            logger: prefixedLogger,
            propertySettings: propertySettings,
            replaceTokens: replaceTokens
          };

          Object.keys(extension.modules).forEach(function(referencePath) {
            var module = extension.modules[referencePath];
            var getModuleExportsByRelativePath = function(relativePath) {
              var resolvedReferencePath = resolveRelativePath(referencePath, relativePath);
              return moduleProvider.getModuleExports(resolvedReferencePath);
            };
            var publicRequire = createPublicRequire(getModuleExportsByRelativePath);

            moduleProvider.registerModule(
              referencePath,
              module,
              extensionName,
              publicRequire,
              turbine
            );
          });
        }
      });

      moduleProvider.hydrateCache();
    }
    return moduleProvider;
  };





  var hydrateSatelliteObject = function(_satellite, container, setDebugOutputEnabled, getVar, setCustomVar) {
    var customScriptPrefixedLogger = logger.createPrefixedLogger('Custom Script');

    _satellite.track = function(identifier) {
      logger.log('"' + identifier + '" does not match any direct call identifiers.');
    };

    _satellite.getVisitorId = function() { return null; };

    _satellite.property = {
      name: container.property.name
    };

    _satellite.company = container.company;

    _satellite.buildInfo = container.buildInfo;

    _satellite.logger = customScriptPrefixedLogger;

    _satellite.notify = function(message, level) {
      logger.warn('_satellite.notify is deprecated. Please use the `_satellite.logger` API.');

      switch (level) {
        case 3:
          customScriptPrefixedLogger.info(message);
          break;
        case 4:
          customScriptPrefixedLogger.warn(message);
          break;
        case 5:
          customScriptPrefixedLogger.error(message);
          break;
        default:
          customScriptPrefixedLogger.log(message);
      }
    };

    _satellite.getVar = getVar;
    _satellite.setVar = setCustomVar;

    _satellite.setCookie = function(name, value, days) {
      var optionsStr = '';
      var options = {};

      if (days) {
        optionsStr = ', { expires: ' + days + ' }';
        options.expires = days;
      }

      var msg = '_satellite.setCookie is deprecated. Please use ' +
        '_satellite.cookie.set("' + name + '", "' + value + '"' + optionsStr + ').';

      logger.warn(msg);
      reactorCookie.set(name, value, options);
    };

    _satellite.readCookie = function(name) {
      logger.warn('_satellite.readCookie is deprecated. ' +
        'Please use _satellite.cookie.get("' + name + '").');
      return reactorCookie.get(name);
    };

    _satellite.removeCookie = function(name) {
      logger.warn('_satellite.removeCookie is deprecated. ' +
        'Please use _satellite.cookie.remove("' + name + '").');
      reactorCookie.remove(name);
    };

    _satellite.cookie = reactorCookie;

    _satellite.pageBottom = function() {};

    _satellite.setDebug = setDebugOutputEnabled;

    var warningLogged = false;

    Object.defineProperty(_satellite, '_container', {
      get: function() {
        if (!warningLogged) {
          logger.warn('_satellite._container may change at any time and should only ' +
            'be used for debugging.');
          warningLogged = true;
        }

        return container;
      }
    });
  };





  var normalizeSyntheticEvent = function(syntheticEventMeta, syntheticEvent) {
    syntheticEvent = syntheticEvent || {};
    reactorObjectAssign(syntheticEvent, syntheticEventMeta);

    if (!syntheticEvent.hasOwnProperty('type')) {
      Object.defineProperty(syntheticEvent, 'type', {
        get: function() {
          logger.warn('Accessing event.type in Adobe Launch has been deprecated and will be ' +
            'removed soon. Please use event.$type instead.');
          return syntheticEvent.$type;
        }
      });
    }

    return syntheticEvent;
  };


  var buildRuleExecutionOrder = function(rules) {
    var ruleEventPairs = [];

    rules.forEach(function(rule) {
      if (rule.events) {
        rule.events.forEach(function(event) {
          ruleEventPairs.push({
            rule: rule,
            event: event
          });
        });
      }
    });

    return ruleEventPairs.sort(function(ruleEventPairA, ruleEventPairB) {
      return ruleEventPairA.event.ruleOrder - ruleEventPairB.event.ruleOrder;
    });
  };



  var warningLogged = false;

  var createNotifyMonitors = function(_satellite) {
    return function(type, event) {
      var monitors = _satellite._monitors;

      if (monitors) {
        if (!warningLogged) {
          logger.warn('The _satellite._monitors API may change at any time and should only ' +
            'be used for debugging.');
          warningLogged = true;
        }

        monitors.forEach(function(monitor) {
          if (monitor[type]) {
            monitor[type](event);
          }
        });
      }
    };
  };


  var MODULE_NOT_FUNCTION_ERROR = 'Module did not export a function.';

  var createExecuteDelegateModule = function(moduleProvider, replaceTokens) {
    return function(moduleDescriptor, syntheticEvent, moduleCallParameters) {
      moduleCallParameters = moduleCallParameters || [];
      var moduleExports = moduleProvider.getModuleExports(
        moduleDescriptor.modulePath
      );

      if (typeof moduleExports !== 'function') {
        throw new Error(MODULE_NOT_FUNCTION_ERROR);
      }

      var settings = replaceTokens(
        moduleDescriptor.settings || {},
        syntheticEvent
      );
      return moduleExports.bind(null, settings).apply(null, moduleCallParameters);
    };
  };



  var localStorage$1 = getNamespacedStorage('localStorage');
  var sessionStorage = getNamespacedStorage('sessionStorage');

  var isRuleQueueActive = function() {
    return Boolean(localStorage$1.getItem('queue') || sessionStorage.getItem('queue'));
  };









  var PROMISE_TIMEOUT = 2000;

  var queueWarningLogged = false;
  var logQueueWarningOnce = function() {
    if (!queueWarningLogged) {
      queueWarningLogged = true;
      logger.warn(
        'Rule queueing is only intended for testing purposes. Queueing behavior may be ' +
        'changed or removed at any time.'
      );
    }
  };

  var initRules = function(
    _satellite,
    rules,
    moduleProvider,
    replaceTokens
  ) {
    var lastPromiseInQueue = reactorPromise.resolve();
    var notifyMonitors = createNotifyMonitors(_satellite);
    var executeDelegateModule = createExecuteDelegateModule(
      moduleProvider,
      replaceTokens
    );

    var getModuleDisplayNameByRuleComponent = function(ruleComponent) {
      var moduleDefinition = moduleProvider.getModuleDefinition(
        ruleComponent.modulePath
      );
      return (
        (moduleDefinition && moduleDefinition.displayName) ||
        ruleComponent.modulePath
      );
    };

    var getErrorMessage = function(
      ruleComponent,
      rule,
      errorMessage,
      errorStack
    ) {
      var moduleDisplayName = getModuleDisplayNameByRuleComponent(ruleComponent);
      return (
        'Failed to execute ' +
        moduleDisplayName +
        ' for ' +
        rule.name +
        ' rule. ' +
        errorMessage +
        (errorStack ? '\n' + errorStack : '')
      );
    };

    var logActionError = function(action, rule, e) {
      logger.error(getErrorMessage(action, rule, e.message, e.stack));

      notifyMonitors('ruleActionFailed', {
        rule: rule,
        action: action
      });
    };

    var logConditionError = function(condition, rule, e) {
      logger.error(getErrorMessage(condition, rule, e.message, e.stack));

      notifyMonitors('ruleConditionFailed', {
        rule: rule,
        condition: condition
      });
    };

    var logConditionNotMet = function(condition, rule) {
      var conditionDisplayName = getModuleDisplayNameByRuleComponent(condition);

      logger.log(
        'Condition ' +
        conditionDisplayName +
        ' for rule ' +
        rule.name +
        ' not met.'
      );

      notifyMonitors('ruleConditionFailed', {
        rule: rule,
        condition: condition
      });
    };

    var logRuleCompleted = function(rule) {
      logger.log('Rule "' + rule.name + '" fired.');
      notifyMonitors('ruleCompleted', {
        rule: rule
      });
    };

    var normalizeError = function(e) {
      if (!e) {
        e = new Error(
          'The extension triggered an error, but no error information was provided.'
        );
      }

      if (!(e instanceof Error)) {
        e = new Error(String(e));
      }

      return e;
    };

    var isConditionMet = function(condition, result) {
      return (result && !condition.negate) || (!result && condition.negate);
    };

    var addRuleToQueue = function(rule, syntheticEvent) {
      if (rule.conditions) {
        rule.conditions.forEach(function(condition) {
          lastPromiseInQueue = lastPromiseInQueue.then(function() {
            var timeoutId;

            return new reactorPromise(function(resolve, reject) {
              timeoutId = setTimeout(function() {
                reject(
                  'A timeout occurred because the condition took longer than ' +
                  PROMISE_TIMEOUT / 1000 +
                  ' seconds to complete. '
                );
              }, PROMISE_TIMEOUT);

              reactorPromise.resolve(
                executeDelegateModule(condition, syntheticEvent, [syntheticEvent])
              ).then(resolve, reject);
            })
            .catch(function(e) {
              clearTimeout(timeoutId);
              e = normalizeError(e, condition);
              logConditionError(condition, rule, e);
              return reactorPromise.reject(e);
            })
            .then(function(result) {
              clearTimeout(timeoutId);
              if (!isConditionMet(condition, result)) {
                logConditionNotMet(condition, rule);
                return reactorPromise.reject();
              }
            });
          });
        });
      }

      if (rule.actions) {
        rule.actions.forEach(function(action) {
          lastPromiseInQueue = lastPromiseInQueue.then(function() {
            var timeoutId;

            return new reactorPromise(function(resolve, reject) {
              timeoutId = setTimeout(function() {
                reject(
                  'A timeout occurred because the action took longer than ' +
                  PROMISE_TIMEOUT / 1000 +
                  ' seconds to complete. '
                );
              }, PROMISE_TIMEOUT);

              reactorPromise.resolve(
                executeDelegateModule(action, syntheticEvent, [syntheticEvent])
              ).then(resolve, reject);
            })
            .catch(function(e) {
              clearTimeout(timeoutId);
              e = normalizeError(e);
              logActionError(action, rule, e);
              return reactorPromise.reject(e);
            })
            .then(function() {
              clearTimeout(timeoutId);
            });
          });
        });
      }

      lastPromiseInQueue = lastPromiseInQueue.then(function() {
        logRuleCompleted(rule);
      });

      lastPromiseInQueue = lastPromiseInQueue.catch(function() {});
    };

    var checkConditions = function(rule, syntheticEvent) {
      var condition;

      if (rule.conditions) {
        for (var i = 0; i < rule.conditions.length; i++) {
          condition = rule.conditions[i];

          try {
            var result = executeDelegateModule(condition, syntheticEvent, [
              syntheticEvent
            ]);

            if (!isConditionMet(condition, result)) {
              logConditionNotMet(condition, rule);
              return;
            }
          } catch (e) {
            logConditionError(condition, rule, e);
            return;
          }
        }
      }
      runActions(rule, syntheticEvent);
    };

    var runActions = function(rule, syntheticEvent) {
      var action;

      if (rule.actions) {
        for (var i = 0; i < rule.actions.length; i++) {
          action = rule.actions[i];
          try {
            executeDelegateModule(action, syntheticEvent, [syntheticEvent]);
          } catch (e) {
            logActionError(action, rule, e);
            return;
          }
        }
      }

      logRuleCompleted(rule);
    };

    var eventModulesInitialized = false;
    var triggerCallQueue = [];

    var initEventModule = function(ruleEventPair) {
      var rule = ruleEventPair.rule;
      var event = ruleEventPair.event;
      event.settings = event.settings || {};

      var moduleName;
      var extensionName;

      try {
        moduleName = moduleProvider.getModuleDefinition(event.modulePath).name;
        extensionName = moduleProvider.getModuleExtensionName(event.modulePath);

        var syntheticEventMeta = {
          $type: extensionName + '.' + moduleName,
          $rule: {
            id: rule.id,
            name: rule.name
          }
        };

        var trigger = function(syntheticEvent) {
          if (!eventModulesInitialized) {
            triggerCallQueue.push(trigger.bind(null, syntheticEvent));
            return;
          }

          notifyMonitors('ruleTriggered', {
            rule: rule
          });

          var normalizedSyntheticEvent = normalizeSyntheticEvent(
            syntheticEventMeta,
            syntheticEvent
          );

          if (isRuleQueueActive()) {
            logQueueWarningOnce();
            addRuleToQueue(rule, normalizedSyntheticEvent);
          } else {
            checkConditions(rule, normalizedSyntheticEvent);
          }
        };

        executeDelegateModule(event, null, [trigger]);
      } catch (e) {
        logger.error(getErrorMessage(event, rule, e.message, e.stack));
      }
    };

    buildRuleExecutionOrder(rules).forEach(initEventModule);
    eventModulesInitialized = true;
    triggerCallQueue.forEach(function(triggerCall) {
      triggerCall();
    });
    triggerCallQueue = null;

    return lastPromiseInQueue;
  };














  var DEBUG_LOCAL_STORAGE_NAME = 'debug';


  var _satellite = window._satellite;

  if (_satellite && !window.__satelliteLoaded) {
    window.__satelliteLoaded = true;

    var container = _satellite.container;

    delete _satellite.container;

    var undefinedVarsReturnEmpty = container.property.settings.undefinedVarsReturnEmpty;

    var dataElements = container.dataElements || {};

    dataElementSafe.migrateCookieData(dataElements);

    var getDataElementDefinition = function(name) {
      return dataElements[name];
    };

    var moduleProvider = createModuleProvider();

    var replaceTokens;

    var proxyReplaceTokens = function() {
      return replaceTokens.apply(null, arguments);
    };

    var getDataElementValue = createGetDataElementValue(
      moduleProvider,
      getDataElementDefinition,
      proxyReplaceTokens,
      undefinedVarsReturnEmpty
    );

    var customVars = {};
    var setCustomVar = createSetCustomVar(
      customVars
    );

    var isVar = createIsVar(
      customVars,
      getDataElementDefinition
    );

    var getVar = createGetVar(
      customVars,
      getDataElementDefinition,
      getDataElementValue
    );

    replaceTokens = createReplaceTokens(
      isVar,
      getVar,
      undefinedVarsReturnEmpty
    );

    var localStorage = getNamespacedStorage('localStorage');

    var getDebugOutputEnabled = function() {
      return localStorage.getItem(DEBUG_LOCAL_STORAGE_NAME) === 'true';
    };

    var setDebugOutputEnabled = function(value) {
      localStorage.setItem(DEBUG_LOCAL_STORAGE_NAME, value);
      logger.outputEnabled = value;
    };

    logger.outputEnabled = getDebugOutputEnabled();

    hydrateSatelliteObject(
      _satellite,
      container,
      setDebugOutputEnabled,
      getVar,
      setCustomVar
    );

    hydrateModuleProvider(
      container,
      moduleProvider,
      replaceTokens,
      getDataElementValue
    );

    initRules(
      _satellite,
      container.rules || [],
      moduleProvider,
      replaceTokens
    );
  }

  var src = _satellite;

  return src;

}());


 })(window);